import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccountStatus = {
  __typename?: 'AccountStatus';
  emailVerificationStatus: AccountStatusProgress;
  identityVerificationStatus: AccountStatusProgress;
  personalDetailsStatus: AccountStatusProgress;
};

export enum AccountStatusProgress {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export type AdditionalDocumentsRecordData = {
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<CountryCode>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum AssociatedDocumentFileType {
  AdditionalDocument = 'AdditionalDocument',
  BloodTestDocument = 'BloodTestDocument',
  BreedingCertificate = 'BreedingCertificate',
  ChiropractorRecordDocument = 'ChiropractorRecordDocument',
  CompetitionRecord = 'CompetitionRecord',
  DentalRecordDocument = 'DentalRecordDocument',
  FarrierRecordHoofImage = 'FarrierRecordHoofImage',
  HorsePassportProof = 'HorsePassportProof',
  HorsePhoto = 'HorsePhoto',
  HorseTransportVideo = 'HorseTransportVideo',
  HorseVideo = 'HorseVideo',
  MedicationLogRecordDocument = 'MedicationLogRecordDocument',
  PassportInformationDocument = 'PassportInformationDocument',
  PassportMarkingsDocument = 'PassportMarkingsDocument',
  PhysiotherapyRecordDocument = 'PhysiotherapyRecordDocument',
  ProfilePhoto = 'ProfilePhoto',
  TackRecordDocument = 'TackRecordDocument',
  TravelRecordDocument = 'TravelRecordDocument',
  VaccinationRecord = 'VaccinationRecord',
  VaccinationRecordDocument = 'VaccinationRecordDocument',
  VerificationDocumentBack = 'VerificationDocumentBack',
  VerificationDocumentFront = 'VerificationDocumentFront',
  VetCertificate = 'VetCertificate',
  VetHistory = 'VetHistory',
  VetHistoryRecordDocument = 'VetHistoryRecordDocument',
  VetOther = 'VetOther',
  WormingRecordDocument = 'WormingRecordDocument',
  XRay = 'XRay'
}

export enum AssociatedEntityType {
  Horse = 'Horse',
  Transaction = 'Transaction',
  User = 'User',
  Vetting = 'Vetting'
}

export type BankTransferInstructions = {
  __typename?: 'BankTransferInstructions';
  amountRemaining?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  financialAddresses?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum BloodTestCategory {
  Outcome = 'OUTCOME',
  Reason = 'REASON'
}

export type BloodTestRecordData = {
  nextFieldBloodTestDate?: InputMaybe<Scalars['String']['input']>;
  results: Scalars['String']['input'];
};

export type BloodTestReferenceDataDto = {
  __typename?: 'BloodTestReferenceDataDto';
  category: BloodTestCategory;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type BrevoUserEventInput = {
  eventName: Scalars['String']['input'];
  eventProperties: Scalars['JSON']['input'];
  userId: Scalars['Int']['input'];
};

export type BunnyVideoUploadHeaders = {
  __typename?: 'BunnyVideoUploadHeaders';
  authorizationExpire: Scalars['Float']['output'];
  authorizationSignature: Scalars['String']['output'];
  collectionId: Scalars['String']['output'];
  libraryId: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export enum ChargeStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  Unknown = 'Unknown'
}

export type CompetitionRecord = {
  __typename?: 'CompetitionRecord';
  competitionName: Scalars['String']['output'];
  competitionNumber: Scalars['Float']['output'];
  fileId: Scalars['String']['output'];
  horseId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
};

export type CompetitionRecordData = {
  governingBody: Scalars['String']['input'];
  horseRegistrationNumber: Scalars['String']['input'];
  recordLink?: InputMaybe<Scalars['String']['input']>;
  registeredCompetitionName: Scalars['String']['input'];
};

export type CompetitionRecordQueryInput = {
  horseId?: InputMaybe<Scalars['Float']['input']>;
};

export type CompleteRegistrationInput = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  terms: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type ConfirmDeliveryPayload = {
  __typename?: 'ConfirmDeliveryPayload';
  message: Scalars['String']['output'];
};

export enum ConflictStatus {
  AcceptedNoConflict = 'ACCEPTED_NO_CONFLICT',
  Pending = 'PENDING',
  RejectedConflict = 'REJECTED_CONFLICT'
}

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Float']['output'];
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
};

export enum ContactType {
  ChiropractorContact = 'CHIROPRACTOR_CONTACT',
  DentistContact = 'DENTIST_CONTACT',
  FarrierContact = 'FARRIER_CONTACT',
  PhysiotherapistContact = 'PHYSIOTHERAPIST_CONTACT',
  VeterinaryContact = 'VETERINARY_CONTACT'
}

/** ISO 3166-1 alpha-2 country code. */
export enum CountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateAdditionalDocumentsRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<AdditionalDocumentsRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateBloodTestRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<BloodTestRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateChiropractorRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateCompetitionRecordInput = {
  competitionName: Scalars['String']['input'];
  competitionNumber: Scalars['Float']['input'];
  fileId: Scalars['String']['input'];
  horseId: Scalars['Float']['input'];
};

export type CreateCompetitionRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<CompetitionRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateDentalRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateExerciseRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<ExerciseRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateFarrierRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateFeedingRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<FeedingRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateFileInput = {
  associatedDocumentFileType: AssociatedDocumentFileType;
  associatedEntityId: Scalars['Float']['input'];
  associatedEntityType: AssociatedEntityType;
  fileLocation: FileLocation;
  fileType?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Float']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHorseInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  ageInYear?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  breedersName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dam?: InputMaybe<Scalars['String']['input']>;
  damSire?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfLicensing?: InputMaybe<Scalars['DateTime']['input']>;
  heightInCentimeter?: InputMaybe<Scalars['Float']['input']>;
  heightInHands?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Float']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['Float']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<Scalars['String']['input']>;
  sireSire?: InputMaybe<Scalars['String']['input']>;
  stableName?: InputMaybe<Scalars['String']['input']>;
  studBook?: InputMaybe<Scalars['String']['input']>;
  transponderCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHorseListingInput = {
  deposit?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  horseId: Scalars['Float']['input'];
  isPriceHidden?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerId: Scalars['Float']['input'];
};

export type CreateMedicationLogRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<MedicationLogRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  amount: Scalars['Float']['output'];
  payerId: Scalars['Float']['output'];
  paymentType: PaymentType;
};

export type CreatePayoutBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountHolderType: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  country: CountryCode;
  currency: CurrencyCode;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Float']['input'];
};

export type CreatePersonalityRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<PersonalityRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreatePhysiotherapyRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateSellerAccountInput = {
  address?: InputMaybe<AddressInput>;
  countryCode?: InputMaybe<CountryCode>;
  countryDialCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  dateOfBirth?: InputMaybe<DateOfBirthInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tosAcceptance?: InputMaybe<TosAcceptanceInput>;
  userId: Scalars['Float']['input'];
};

export type CreateShipmentInput = {
  shipmentMethod: ShipmentMethod;
  transactionRecordId: Scalars['Float']['input'];
};

export type CreateTackRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<TackRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateTrainingRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<TrainingRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateTransactionRecordInput = {
  buyerId: Scalars['Float']['input'];
  listingId: Scalars['Float']['input'];
};

export type CreateTravelDocumentsRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<TravelDocumentsRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateTurnoutRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<TurnoutRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateVaccinationRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<VaccinationRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateVetDetailsRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<VetDetailsRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateVeterinaryHistoryRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateVettingInput = {
  transactionRecordId: Scalars['Float']['input'];
};

export type CreateWormingRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<WormingRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

export type CreateXrayRecordPayload = {
  contacts?: InputMaybe<Array<ContactInput>>;
  data?: InputMaybe<XRayRecordData>;
  date?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  horseId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  nextVisitDueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  type: HorseRecordType;
};

/** Currency code */
export enum CurrencyCode {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type DateOfBirth = {
  __typename?: 'DateOfBirth';
  day: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type DateOfBirthInput = {
  day: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export type DeleteContactInput = {
  contactId: Scalars['Float']['input'];
};

export type DepositRequest = {
  __typename?: 'DepositRequest';
  id: Scalars['Float']['output'];
  status: DepositRequestStatus;
  transactionRecordId: Scalars['Float']['output'];
};

export type DepositRequestPayload = {
  __typename?: 'DepositRequestPayload';
  depositRequestId: Scalars['Float']['output'];
};

export enum DepositRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum EntityType {
  SystemDefined = 'SYSTEM_DEFINED',
  UserCreated = 'USER_CREATED'
}

export type ExerciseRecordData = {
  exerciseType: Scalars['String']['input'];
};

export type ExternalBankAccount = {
  __typename?: 'ExternalBankAccount';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountHolderType?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  currency?: Maybe<CurrencyCode>;
  defaultForCurrency?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ExternalBankAccountInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountHolderType?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  currency?: InputMaybe<CurrencyCode>;
  defaultForCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  last4?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type Feed = {
  forages?: InputMaybe<Array<Forage>>;
  hardFeeds?: InputMaybe<Array<HardFeed>>;
  supplements?: InputMaybe<Array<Supplement>>;
};

export type FeedingRecordData = {
  lunchFeed?: InputMaybe<Feed>;
  morningFeed?: InputMaybe<Feed>;
  nightFeed?: InputMaybe<Feed>;
};

export enum FeedingRefDataCategory {
  ForageType = 'FORAGE_TYPE',
  Frequency = 'FREQUENCY'
}

export type FeedingReferenceDataDto = {
  __typename?: 'FeedingReferenceDataDto';
  category?: Maybe<FeedingRefDataCategory>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type FileDto = {
  __typename?: 'FileDto';
  associatedDocumentFileType: AssociatedDocumentFileType;
  associatedEntityId: Scalars['Float']['output'];
  associatedEntityType: AssociatedEntityType;
  cloudId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileLocation: Scalars['String']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isLocked: Scalars['Boolean']['output'];
  signedUploadUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadStatus?: Maybe<FileUploadStatus>;
  uploaderId?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum FileLocation {
  Bunny = 'Bunny',
  Gcp = 'GCP',
  Link = 'Link'
}

export type FileQueryInput = {
  associatedDocumentFileType?: InputMaybe<AssociatedDocumentFileType>;
  associatedEntityId?: InputMaybe<Scalars['Float']['input']>;
  associatedEntityType?: InputMaybe<AssociatedEntityType>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FileUploadStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export type FindRecordsInput = {
  horseId: Scalars['Float']['input'];
  type: HorseRecordType;
};

export type Forage = {
  forageType?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type HardFeed = {
  amount?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HorseDto = {
  __typename?: 'HorseDto';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  ageInYear?: Maybe<Scalars['Float']['output']>;
  breed?: Maybe<Scalars['String']['output']>;
  breedersName?: Maybe<Scalars['String']['output']>;
  breedingCertificates: Array<FileDto>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  competitionRecords: Array<FileDto>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentAge?: Maybe<Scalars['Float']['output']>;
  dam?: Maybe<Scalars['String']['output']>;
  damSire?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  dateOfLicensing?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  equiydRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  heightInCentimeter?: Maybe<Scalars['Float']['output']>;
  heightInHands?: Maybe<Scalars['Float']['output']>;
  horseListings: Array<HorseListing>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  noBreedingCertificate?: Maybe<Scalars['Boolean']['output']>;
  noCompetitionRecords?: Maybe<Scalars['Boolean']['output']>;
  noVeterinarianHistory?: Maybe<Scalars['Boolean']['output']>;
  ownerId?: Maybe<Scalars['Float']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<ProfilePhoto>;
  registrationNumber?: Maybe<Scalars['Float']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  sire?: Maybe<Scalars['String']['output']>;
  sireSire?: Maybe<Scalars['String']['output']>;
  stableName?: Maybe<Scalars['String']['output']>;
  studBook?: Maybe<Scalars['String']['output']>;
  transponderCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vaccinationRecords: Array<FileDto>;
  vetCertificates: Array<FileDto>;
  vetHistory: Array<FileDto>;
  vetOther: Array<FileDto>;
  xRays: Array<FileDto>;
};

export type HorseListing = {
  __typename?: 'HorseListing';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  depositFee?: Maybe<Scalars['Float']['output']>;
  depositFeePercentage?: Maybe<Scalars['Float']['output']>;
  depositFeeVat?: Maybe<Scalars['Float']['output']>;
  depositTotal?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  horse: HorseDto;
  horseId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  isPriceHidden?: Maybe<Scalars['Boolean']['output']>;
  platformFeePercentage?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  reservedUserId?: Maybe<Scalars['Float']['output']>;
  sellerId: Scalars['Float']['output'];
  serviceFee?: Maybe<Scalars['Float']['output']>;
  serviceFeeVat?: Maybe<Scalars['Float']['output']>;
  status: ListingStatus;
  total?: Maybe<Scalars['Float']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatPercentage?: Maybe<Scalars['Float']['output']>;
};

export type HorseNotificationResponse = {
  __typename?: 'HorseNotificationResponse';
  horseNotificationCount?: Maybe<Scalars['Int']['output']>;
};

export type HorseRecord = {
  __typename?: 'HorseRecord';
  contacts?: Maybe<Array<Contact>>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['DateTime']['output'];
  events?: Maybe<Array<HorseRecordEvent>>;
  files?: Maybe<Array<Scalars['String']['output']>>;
  horseId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  nextVisitDueDate?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  reasonForVisit?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HorseRecordEvent = {
  __typename?: 'HorseRecordEvent';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  horseRecordId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['Float']['output'];
};

export enum HorseRecordType {
  AdditionalDocuments = 'ADDITIONAL_DOCUMENTS',
  BloodTestResults = 'BLOOD_TEST_RESULTS',
  ChiropractorRecords = 'CHIROPRACTOR_RECORDS',
  CompetitionRecords = 'COMPETITION_RECORDS',
  DentalRecords = 'DENTAL_RECORDS',
  Exercise = 'EXERCISE',
  FarrierTreatment = 'FARRIER_TREATMENT',
  Feeding = 'FEEDING',
  MedicationLog = 'MEDICATION_LOG',
  Personality = 'PERSONALITY',
  PhysiotherapyRecords = 'PHYSIOTHERAPY_RECORDS',
  Tack = 'TACK',
  Training = 'TRAINING',
  TravelDocuments = 'TRAVEL_DOCUMENTS',
  Turnout = 'TURNOUT',
  VaccinationRecords = 'VACCINATION_RECORDS',
  VeterinaryHistory = 'VETERINARY_HISTORY',
  VetDetails = 'VET_DETAILS',
  Worming = 'WORMING',
  Xrays = 'XRAYS'
}

export enum IdVerificationStatus {
  Pending = 'Pending',
  Unknown = 'Unknown',
  Unverified = 'Unverified',
  Verified = 'Verified'
}

export type InitiateFileUploadInput = {
  associatedDocumentFileType: AssociatedDocumentFileType;
  associatedEntityId: Scalars['Float']['input'];
  associatedEntityType: AssociatedEntityType;
  fileType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type InitiateVideoUploadInput = {
  associatedDocumentFileType: AssociatedDocumentFileType;
  associatedEntityId: Scalars['Float']['input'];
  associatedEntityType: AssociatedEntityType;
  fileType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type InitiateVideoUploadResponse = {
  __typename?: 'InitiateVideoUploadResponse';
  bunnyVideoUploadHeaders: BunnyVideoUploadHeaders;
  file: FileDto;
};

export enum ListingStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published',
  Reserved = 'Reserved',
  Sold = 'Sold'
}

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  idToken: Scalars['String']['output'];
  user: User;
};

export type MedicalLogReferenceData = {
  __typename?: 'MedicalLogReferenceData';
  createdAt: Scalars['DateTime']['output'];
  medicationLogType: MedicationLogType;
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type MedicationLogRecordData = {
  dateOfFirstMedication?: InputMaybe<Scalars['String']['input']>;
  frequencyOfMedication?: InputMaybe<Scalars['String']['input']>;
  medicationName?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPrescribed?: InputMaybe<Scalars['Float']['input']>;
  reasonForPrescription?: InputMaybe<Scalars['String']['input']>;
};

export enum MedicationLogType {
  Frequency = 'FREQUENCY',
  Reason = 'REASON'
}

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeNotification: Scalars['Boolean']['output'];
  addVerificationDocuments: User;
  completeRegistration: Scalars['Boolean']['output'];
  create: FileDto;
  createAdditionalDocumentsRecord: HorseRecord;
  createBloodTestRecord: HorseRecord;
  createChiropractorRecord: HorseRecord;
  createCompetitionRecord: CompetitionRecord;
  createCompetitionRecordv2: HorseRecord;
  createContact: Contact;
  createDentalRecord: HorseRecord;
  createExerciseRecord: HorseRecord;
  createFarrierRecord: HorseRecord;
  createFeedingRecord: HorseRecord;
  createHorse: HorseDto;
  createHorseListing: HorseListing;
  createMedicationLogRecord: HorseRecord;
  createOrUpdatePayoutBankAccount: SellerAccount;
  createOrUpdateSellerAccount: SellerAccount;
  createPersonalityRecord: HorseRecord;
  createPhysiotherapyRecord: HorseRecord;
  createShipment: Shipment;
  createTackRecord: HorseRecord;
  createTrainingRecord: HorseRecord;
  createTransactionRecord: TransactionRecord;
  createTravelDocumentsRecord: HorseRecord;
  createTurnoutRecord: HorseRecord;
  createVaccinationRecord: HorseRecord;
  createVetDetailsRecord: HorseRecord;
  createVeterinaryHistoryRecord: HorseRecord;
  createVetting: Vetting;
  createWormingRecord: HorseRecord;
  createXrayRecord: HorseRecord;
  deleteCompetitionRecord: Scalars['Boolean']['output'];
  deleteContact: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteHorse: Scalars['Boolean']['output'];
  deleteHorseRecord: Scalars['Boolean']['output'];
  deleteProfilePhoto: Scalars['Boolean']['output'];
  fundBalance: Scalars['Boolean']['output'];
  handleBuyerEvent: TransactionRecord;
  handleSellerEvent: TransactionRecord;
  initiateFileUpload: FileDto;
  initiateVideoUpload: InitiateVideoUploadResponse;
  login: LoginResponse;
  recordUserEvent: Scalars['Boolean']['output'];
  register: User;
  replayStripeEvent: Scalars['Boolean']['output'];
  resendCompleteRegistrationEmail: Scalars['Boolean']['output'];
  resendVerificationEmail: Scalars['Boolean']['output'];
  seed: Scalars['Boolean']['output'];
  sendResetPasswordEmail: Scalars['Boolean']['output'];
  sendSupportRequest: SupportRequest;
  setProfilePhoto: HorseDto;
  setUserProperties: Scalars['Boolean']['output'];
  syncBrevoUserProfile: Scalars['Boolean']['output'];
  syncSingleUserToBrevoById: Scalars['Boolean']['output'];
  syncUsers: Scalars['Boolean']['output'];
  updateEquiydFee: Scalars['Boolean']['output'];
  updateFileUploadStatus: FileDto;
  updateHorse: HorseDto;
  updateHorseDocuments: HorseDto;
  updateHorseListing: HorseListing;
  updatePassword: Scalars['Boolean']['output'];
  updateUserRoles: Array<UserRole>;
  uploadVerificationDocuments: SellerAccount;
  upsertProfile: User;
  verifyEmail: Scalars['Boolean']['output'];
  verifyToken: VerificationToken;
};


export type MutationAcknowledgeNotificationArgs = {
  id: Scalars['Float']['input'];
};


export type MutationAddVerificationDocumentsArgs = {
  backFileId: Scalars['String']['input'];
  frontFileId: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};


export type MutationCompleteRegistrationArgs = {
  input: CompleteRegistrationInput;
};


export type MutationCreateArgs = {
  createFileInput: CreateFileInput;
};


export type MutationCreateAdditionalDocumentsRecordArgs = {
  input: CreateAdditionalDocumentsRecordPayload;
};


export type MutationCreateBloodTestRecordArgs = {
  input: CreateBloodTestRecordPayload;
};


export type MutationCreateChiropractorRecordArgs = {
  input: CreateChiropractorRecordPayload;
};


export type MutationCreateCompetitionRecordArgs = {
  createCompetitionRecordInput: CreateCompetitionRecordInput;
};


export type MutationCreateCompetitionRecordv2Args = {
  input: CreateCompetitionRecordPayload;
};


export type MutationCreateContactArgs = {
  input: ContactInput;
};


export type MutationCreateDentalRecordArgs = {
  input: CreateDentalRecordPayload;
};


export type MutationCreateExerciseRecordArgs = {
  input: CreateExerciseRecordPayload;
};


export type MutationCreateFarrierRecordArgs = {
  input: CreateFarrierRecordPayload;
};


export type MutationCreateFeedingRecordArgs = {
  input: CreateFeedingRecordPayload;
};


export type MutationCreateHorseArgs = {
  createHorseInput: CreateHorseInput;
};


export type MutationCreateHorseListingArgs = {
  createHorseListingInput: CreateHorseListingInput;
};


export type MutationCreateMedicationLogRecordArgs = {
  input: CreateMedicationLogRecordPayload;
};


export type MutationCreateOrUpdatePayoutBankAccountArgs = {
  createPayoutBankAccountInput: CreatePayoutBankAccountInput;
};


export type MutationCreateOrUpdateSellerAccountArgs = {
  createSellerAccountInput: CreateSellerAccountInput;
};


export type MutationCreatePersonalityRecordArgs = {
  input: CreatePersonalityRecordPayload;
};


export type MutationCreatePhysiotherapyRecordArgs = {
  input: CreatePhysiotherapyRecordPayload;
};


export type MutationCreateShipmentArgs = {
  createShipmentInput: CreateShipmentInput;
};


export type MutationCreateTackRecordArgs = {
  input: CreateTackRecordPayload;
};


export type MutationCreateTrainingRecordArgs = {
  input: CreateTrainingRecordPayload;
};


export type MutationCreateTransactionRecordArgs = {
  createTransactionRecordInput: CreateTransactionRecordInput;
};


export type MutationCreateTravelDocumentsRecordArgs = {
  input: CreateTravelDocumentsRecordPayload;
};


export type MutationCreateTurnoutRecordArgs = {
  input: CreateTurnoutRecordPayload;
};


export type MutationCreateVaccinationRecordArgs = {
  input: CreateVaccinationRecordPayload;
};


export type MutationCreateVetDetailsRecordArgs = {
  input: CreateVetDetailsRecordPayload;
};


export type MutationCreateVeterinaryHistoryRecordArgs = {
  input: CreateVeterinaryHistoryRecordPayload;
};


export type MutationCreateVettingArgs = {
  createVettingInput: CreateVettingInput;
};


export type MutationCreateWormingRecordArgs = {
  input: CreateWormingRecordPayload;
};


export type MutationCreateXrayRecordArgs = {
  input: CreateXrayRecordPayload;
};


export type MutationDeleteCompetitionRecordArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteFileArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteHorseArgs = {
  horseId: Scalars['Float']['input'];
};


export type MutationDeleteHorseRecordArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteProfilePhotoArgs = {
  id: Scalars['Float']['input'];
};


export type MutationFundBalanceArgs = {
  amount: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};


export type MutationHandleBuyerEventArgs = {
  transactionEventInput: TransactionEventInput;
};


export type MutationHandleSellerEventArgs = {
  transactionEventInput: TransactionEventInput;
};


export type MutationInitiateFileUploadArgs = {
  initiateFileUploadInput: InitiateFileUploadInput;
};


export type MutationInitiateVideoUploadArgs = {
  initiateVideoUploadInput: InitiateVideoUploadInput;
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationRecordUserEventArgs = {
  userEventInput: BrevoUserEventInput;
};


export type MutationRegisterArgs = {
  registerInput: RegisterInput;
};


export type MutationReplayStripeEventArgs = {
  id: Scalars['Float']['input'];
};


export type MutationResendCompleteRegistrationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendSupportRequestArgs = {
  sendSupportRequestInput: SendSupportRequestInput;
};


export type MutationSetProfilePhotoArgs = {
  setProfilePhotoInput: SetProfilePhotoInput;
};


export type MutationSetUserPropertiesArgs = {
  setUserPropertiesInput: SetUserPropertiesInputDto;
};


export type MutationSyncSingleUserToBrevoByIdArgs = {
  id: Scalars['Float']['input'];
};


export type MutationUpdateEquiydFeeArgs = {
  updateFeePercentageInput: UpdateEquiydFeeInput;
};


export type MutationUpdateFileUploadStatusArgs = {
  options: UpdateFileUploadStatusInput;
};


export type MutationUpdateHorseArgs = {
  updateHorseInput: UpdateHorseInput;
};


export type MutationUpdateHorseDocumentsArgs = {
  updateHorseDocumentsInput: UpdateHorseDocumentsInput;
};


export type MutationUpdateHorseListingArgs = {
  options: UpdateHorseListingInput;
};


export type MutationUpdatePasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationUpdateUserRolesArgs = {
  roles: Array<UserRole>;
  userId: Scalars['Float']['input'];
};


export type MutationUploadVerificationDocumentsArgs = {
  userId: Scalars['Float']['input'];
};


export type MutationUpsertProfileArgs = {
  upsertProfileInput: UpsertProfileInput;
};


export type MutationVerifyEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

export type NotificationEntityDto = {
  __typename?: 'NotificationEntityDto';
  acknowledgedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  recipientUserId: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  buyerNotificationCount?: Maybe<Scalars['Int']['output']>;
  sellerNotificationCount?: Maybe<Scalars['Int']['output']>;
};

export type PagedHorseListingInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  horseName?: InputMaybe<Scalars['String']['input']>;
  onlySellerListings?: InputMaybe<Scalars['Boolean']['input']>;
  pageOffset?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<ListingStatus>;
  statuses?: InputMaybe<Array<ListingStatus>>;
};

export type PagedHorseListingResponse = {
  __typename?: 'PagedHorseListingResponse';
  pageOffset: Scalars['Float']['output'];
  pageSize: Scalars['Float']['output'];
  results: Array<HorseListing>;
  totalCount: Scalars['Float']['output'];
};

export type PagedPaymentQueryInput = {
  pageOffset?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type PagedPaymentQueryResponse = {
  __typename?: 'PagedPaymentQueryResponse';
  pageOffset: Scalars['Float']['output'];
  pageSize: Scalars['Float']['output'];
  results: Array<Payment>;
  totalCount: Scalars['Float']['output'];
};

export type PagedQueryInputDto = {
  pageOffset?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type PagedStripeEventQueryResponse = {
  __typename?: 'PagedStripeEventQueryResponse';
  pageOffset: Scalars['Float']['output'];
  pageSize: Scalars['Float']['output'];
  results: Array<StripeEvent>;
  totalCount: Scalars['Float']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']['output']>;
  chargeStatus?: Maybe<ChargeStatus>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  nextAction?: Maybe<PaymentAction>;
  paymentIntentId: Scalars['String']['output'];
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType: PaymentType;
  refundStatus?: Maybe<RefundStatus>;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Float']['output'];
};

export type PaymentAction = {
  __typename?: 'PaymentAction';
  bankTransferInstructions?: Maybe<BankTransferInstructions>;
  type: Scalars['String']['output'];
};

export type PaymentChargedPayload = {
  __typename?: 'PaymentChargedPayload';
  chargeId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type PaymentPayload = {
  __typename?: 'PaymentPayload';
  paymentIntentId: Scalars['String']['output'];
};

export type PaymentRefundedPayload = {
  __typename?: 'PaymentRefundedPayload';
  paymentIntentId: Scalars['String']['output'];
  refundId: Scalars['String']['output'];
};

export enum PaymentStatus {
  Canceled = 'Canceled',
  Processing = 'Processing',
  RequiresAction = 'RequiresAction',
  RequiresCapture = 'RequiresCapture',
  RequiresConfirmation = 'RequiresConfirmation',
  RequiresPaymentMethod = 'RequiresPaymentMethod',
  Succeeded = 'Succeeded',
  Unknown = 'Unknown'
}

export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  amountDue: Scalars['Float']['output'];
  depositAmount: Scalars['Float']['output'];
  depositAmountReceived: Scalars['Float']['output'];
  depositDue: Scalars['Float']['output'];
  depositFee: Scalars['Float']['output'];
  depositFeePercentage?: Maybe<Scalars['Float']['output']>;
  depositFeeVat: Scalars['Float']['output'];
  depositSubTotal: Scalars['Float']['output'];
  depositTotal: Scalars['Float']['output'];
  finalPaymentAmountReceived: Scalars['Float']['output'];
  fullPaymentMade: Scalars['Boolean']['output'];
  listingPrice: Scalars['Float']['output'];
  platformFee: Scalars['Float']['output'];
  platformFeePercentage: Scalars['Float']['output'];
  platformFeeVat: Scalars['Float']['output'];
  subTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalReceived: Scalars['Float']['output'];
  vatPercentage: Scalars['Float']['output'];
};

export enum PaymentType {
  Deposit = 'DEPOSIT',
  FinalPrice = 'FINAL_PRICE'
}

export type Payout = {
  __typename?: 'Payout';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  payoutStatus?: Maybe<PayoutStatus>;
  payoutType: PayoutType;
  stripePayoutId?: Maybe<Scalars['String']['output']>;
  transactionRecordId: Scalars['Float']['output'];
  transferId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Float']['output'];
};

export type PayoutPayload = {
  __typename?: 'PayoutPayload';
  amount?: Maybe<Scalars['String']['output']>;
  payoutId: Scalars['Float']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripePayoutId?: Maybe<Scalars['String']['output']>;
};

export enum PayoutStatus {
  Created = 'CREATED',
  Done = 'DONE',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Paid = 'PAID',
  Prepared = 'PREPARED',
  Unknown = 'UNKNOWN'
}

export enum PayoutType {
  FinalPrice = 'FINAL_PRICE'
}

export type PersonalityRecordData = {
  busyPlaces?: InputMaybe<Scalars['String']['input']>;
  clipping?: InputMaybe<Scalars['String']['input']>;
  dontLikeBeingTouched?: InputMaybe<Scalars['String']['input']>;
  iAmMore?: InputMaybe<Scalars['String']['input']>;
  iFeelAround?: InputMaybe<Scalars['String']['input']>;
  iGetAlong?: InputMaybe<Scalars['String']['input']>;
  iGetExitedWhen?: InputMaybe<Scalars['String']['input']>;
  iGetUpsetWhen?: InputMaybe<Scalars['String']['input']>;
  iHateItWhen?: InputMaybe<Scalars['String']['input']>;
  iLearn?: InputMaybe<Scalars['String']['input']>;
  iLoveBeingGroomedOn?: InputMaybe<Scalars['String']['input']>;
  iPreferHacking?: InputMaybe<Scalars['String']['input']>;
  iPreferRider?: InputMaybe<Scalars['String']['input']>;
  iRespondBest?: InputMaybe<Scalars['String']['input']>;
  iSleepBestWhen?: InputMaybe<Scalars['String']['input']>;
  ifICouldTalk?: InputMaybe<Scalars['String']['input']>;
  myBestFriend?: InputMaybe<Scalars['String']['input']>;
  myFaveThing?: InputMaybe<Scalars['String']['input']>;
  myFaveTime?: InputMaybe<Scalars['String']['input']>;
  myFavouriteTreat?: InputMaybe<Scalars['String']['input']>;
  myHumanSays?: InputMaybe<Scalars['String']['input']>;
  pleaseDontFeedMe?: InputMaybe<Scalars['String']['input']>;
  quirks?: InputMaybe<Scalars['String']['input']>;
  scratches?: InputMaybe<Scalars['String']['input']>;
  thingsThatSpookMe?: InputMaybe<Scalars['String']['input']>;
  turnout?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonalityRefDataCategory {
  Busyplaces = 'BUSYPLACES',
  Clipping = 'CLIPPING',
  Iammore = 'IAMMORE',
  Ifeelaround = 'IFEELAROUND',
  Igetalong = 'IGETALONG',
  Ilearn = 'ILEARN',
  Ipreferhacking = 'IPREFERHACKING',
  Ipreferrider = 'IPREFERRIDER',
  Irespondbest = 'IRESPONDBEST',
  Scratches = 'SCRATCHES',
  Turnout = 'TURNOUT'
}

export type PersonalityReferenceDataDto = {
  __typename?: 'PersonalityReferenceDataDto';
  category: PersonalityRefDataCategory;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type PriceRequest = {
  __typename?: 'PriceRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PriceRequestStatus>;
  transactionRecord: TransactionRecord;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum PriceRequestStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Profile = {
  __typename?: 'Profile';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<CountryCode>;
  countryDialCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dobString?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isBusiness?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reasonForJoining?: Maybe<ReasonForJoining>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['Float']['output'];
};

export type ProfilePhoto = {
  __typename?: 'ProfilePhoto';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  status: PurchaseRequestStatus;
  transactionRecord: TransactionRecord;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseRequestPayload = {
  __typename?: 'PurchaseRequestPayload';
  purchaseRequestId: Scalars['Float']['output'];
};

export enum PurchaseRequestStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type PurchasesQueryInput = {
  listingId?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  Shipment: Shipment;
  activeNotifications: Array<NotificationEntityDto>;
  buyerTransactionRecord?: Maybe<TransactionRecord>;
  competitionRecords: Array<CompetitionRecord>;
  contacts: Array<Contact>;
  contactsByName: Array<Contact>;
  contactsByUser: Array<Contact>;
  exerciseTypes: Array<ReferenceDataDto>;
  file: FileDto;
  files: Array<FileDto>;
  getBloodTest: Array<BloodTestReferenceDataDto>;
  getChiropractor: Array<ReferenceDataDto>;
  getDental: Array<ReferenceDataDto>;
  getEventPayloadUnion?: Maybe<TransactionEventPayload>;
  getFarrierTreatments: Array<ReferenceDataDto>;
  getFeeding: Array<FeedingReferenceDataDto>;
  getMedicationLog: Array<MedicalLogReferenceData>;
  getPersonality: Array<PersonalityReferenceDataDto>;
  getPhysiotherapy: Array<ReferenceDataDto>;
  getSignedUrl: Scalars['String']['output'];
  getVaccination: Array<VaccinationReferenceDataDto>;
  getVeterinaryHistories: Array<VeterninaryHistoryReferenceDataDto>;
  getWorming: Array<ReferenceDataDto>;
  getXray: Array<XrayReferenceDataDto>;
  horse: HorseDto;
  horseListing: HorseListing;
  horseListings: PagedHorseListingResponse;
  horseRecord: HorseRecord;
  horseRecords: Array<HorseRecord>;
  horses: Array<HorseDto>;
  payment?: Maybe<Payment>;
  payments: PagedPaymentQueryResponse;
  processPaidPayout: Scalars['Boolean']['output'];
  processSellerPayout: Scalars['Boolean']['output'];
  purchase: PurchaseRequest;
  purchases: Array<PurchaseRequest>;
  queryFarrierRecord: HorseRecord;
  self: User;
  sellerAccount?: Maybe<SellerAccount>;
  sellerHorseNotificationCounter: HorseNotificationResponse;
  stripeEvents: PagedStripeEventQueryResponse;
  transactionRecord?: Maybe<TransactionRecord>;
  transactionRecords: Array<TransactionRecord>;
  transactionRecordsNotificationCounter: NotificationResponse;
  user?: Maybe<User>;
  vetting: Vetting;
  vettings: Array<Vetting>;
  viewingRequest: ViewingRequest;
  viewingRequests: Array<ViewingRequest>;
};


export type QueryShipmentArgs = {
  shipmentId: Scalars['Float']['input'];
};


export type QueryBuyerTransactionRecordArgs = {
  options: TransactionRecordQueryInput;
};


export type QueryCompetitionRecordsArgs = {
  competitionRecordQueryInput: CompetitionRecordQueryInput;
};


export type QueryContactsByNameArgs = {
  input: QueryContactsInput;
};


export type QueryContactsByUserArgs = {
  input: QueryContactsInput;
};


export type QueryFileArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryFilesArgs = {
  options: FileQueryInput;
};


export type QueryGetSignedUrlArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryHorseArgs = {
  id: Scalars['Float']['input'];
};


export type QueryHorseListingArgs = {
  options: QueryHorseListingInput;
};


export type QueryHorseListingsArgs = {
  pagedQueryInput: PagedHorseListingInput;
};


export type QueryHorseRecordArgs = {
  id: Scalars['Float']['input'];
};


export type QueryHorseRecordsArgs = {
  options: FindRecordsInput;
};


export type QueryHorsesArgs = {
  ownerId: Scalars['Float']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['Float']['input'];
};


export type QueryPaymentsArgs = {
  options?: InputMaybe<PagedPaymentQueryInput>;
};


export type QueryPurchaseArgs = {
  purchaseRequestId: Scalars['Float']['input'];
};


export type QueryPurchasesArgs = {
  options: PurchasesQueryInput;
};


export type QueryQueryFarrierRecordArgs = {
  id: Scalars['Float']['input'];
};


export type QuerySellerAccountArgs = {
  userId: Scalars['Float']['input'];
};


export type QuerySellerHorseNotificationCounterArgs = {
  options: TransactionRecordsQueryInput;
};


export type QueryStripeEventsArgs = {
  options?: InputMaybe<PagedQueryInputDto>;
};


export type QueryTransactionRecordArgs = {
  id: Scalars['Float']['input'];
};


export type QueryTransactionRecordsArgs = {
  options: TransactionRecordsQueryInput;
};


export type QueryTransactionRecordsNotificationCounterArgs = {
  options: TransactionRecordsQueryInput;
};


export type QueryUserArgs = {
  id: Scalars['Float']['input'];
};


export type QueryVettingArgs = {
  vettingId: Scalars['Float']['input'];
};


export type QueryVettingsArgs = {
  options: VettingsQueryInput;
};


export type QueryViewingRequestArgs = {
  viewingRequestId: Scalars['Float']['input'];
};


export type QueryViewingRequestsArgs = {
  options: ViewingRequestQueryInput;
};

export type QueryContactsInput = {
  contactType?: InputMaybe<ContactType>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryHorseListingInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Possible reasons for joining Equiyd */
export enum ReasonForJoining {
  BuyingAHorse = 'BUYING_A_HORSE',
  JustBrowsing = 'JUST_BROWSING',
  ManagingMyHorse = 'MANAGING_MY_HORSE',
  NotSelected = 'NOT_SELECTED',
  SellingAHorse = 'SELLING_A_HORSE'
}

export type ReferenceDataDto = {
  __typename?: 'ReferenceDataDto';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export enum RefundStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Pending = 'Pending',
  RequiresAction = 'RequiresAction',
  Succeeded = 'Succeeded',
  Unknown = 'Unknown'
}

export type RegisterInput = {
  email: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isLive: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type RequestShipmentPayload = {
  __typename?: 'RequestShipmentPayload';
  shipmentMethod: ShipmentMethod;
};

export type RequestVettingPayload = {
  __typename?: 'RequestVettingPayload';
  message: Scalars['String']['output'];
};

export type RequestViewingPayload = {
  __typename?: 'RequestViewingPayload';
  message: Scalars['String']['output'];
  type?: Maybe<ViewingRequestType>;
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SellerAccount = {
  __typename?: 'SellerAccount';
  address?: Maybe<Address>;
  canAcceptPayments: Scalars['Boolean']['output'];
  canMakePayments: Scalars['Boolean']['output'];
  countryCode: CountryCode;
  countryDialCode?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<CurrencyCode>;
  dateOfBirth?: Maybe<DateOfBirth>;
  email?: Maybe<Scalars['String']['output']>;
  externalBankAccounts?: Maybe<Array<ExternalBankAccount>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  stripeResponse?: Maybe<StripeAccount>;
};

export type SellerPayout = {
  __typename?: 'SellerPayout';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  sellerPayoutStatus: SellerPayoutStatus;
  stripePayoutId?: Maybe<Scalars['String']['output']>;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Float']['output'];
};

export enum SellerPayoutStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Processed = 'PROCESSED'
}

export type SendSupportRequestInput = {
  message: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};

export type SetConflictOfInterestPayload = {
  __typename?: 'SetConflictOfInterestPayload';
  status: ConflictStatus;
  vettingDetailsId: Scalars['Float']['output'];
};

export type SetProfilePhotoInput = {
  fileId: Scalars['String']['input'];
  horseId: Scalars['Float']['input'];
};

export type SetUserPropertiesInputDto = {
  properties: Scalars['JSON']['input'];
  userIds: Array<Scalars['Float']['input']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  shipmentDetails?: Maybe<ShipmentDetails>;
  shipmentMethod: ShipmentMethod;
  status: ShipmentStatus;
  transactionRecord: TransactionRecord;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShipmentDetails = {
  __typename?: 'ShipmentDetails';
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  shipment: Shipment;
  shipmentDate: Scalars['DateTime']['output'];
  status: ShipmentDetailsStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ShipmentDetailsStatus {
  Confirmed = 'Confirmed',
  Created = 'Created'
}

export enum ShipmentMethod {
  BuyerTransport = 'BUYER_TRANSPORT',
  Collection = 'COLLECTION',
  SellerTransport = 'SELLER_TRANSPORT'
}

export enum ShipmentStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Received = 'Received',
  Rejected = 'Rejected',
  Transferred = 'Transferred'
}

export type StripeAccount = {
  __typename?: 'StripeAccount';
  charges_enabled: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payouts_enabled: Scalars['Boolean']['output'];
  requirements?: Maybe<StripeAccountRequirements>;
};

export type StripeAccountRequirements = {
  __typename?: 'StripeAccountRequirements';
  /** Unix timestamp of date by which the fields in currently_due must be collected to keep the account enabled. The account may be disabled sooner if the next threshold is reached before the currently_due fields are collected. */
  current_deadline?: Maybe<Scalars['Float']['output']>;
  /** Fields that you must collect by the current_deadline for the connected account to remain enabled. currently_due is a subset of eventually_due. */
  currently_due?: Maybe<Array<Scalars['String']['output']>>;
  /** Describes why the connected account isn’t enabled. */
  disabled_reason?: Maybe<Scalars['String']['output']>;
  /** The list of reasons why a particular field in eventually_due, currently_due, or past_due must be collected again because validation or verification failed. */
  errors?: Maybe<Array<StripeRequirementError>>;
  /** Fields that you might need to collect, assuming all thresholds are reached. As they become required, they appear in currently_due and set the current_deadline. All required information starts in this array. */
  eventually_due?: Maybe<Array<Scalars['String']['output']>>;
  /** Fields you didn’t submit by the deadline, which disabled the connected account. past_due is a subset of currently_due. */
  past_due?: Maybe<Array<Scalars['String']['output']>>;
  /** Fields that may become required depending on the results of verification or review. Is an empty array unless a verification is pending. If verification fails, fields in pending_verification move to eventually_due, currently_due, or past_due. */
  pending_verification?: Maybe<Array<Scalars['String']['output']>>;
};

export type StripeEvent = {
  __typename?: 'StripeEvent';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type StripeRequirementError = {
  __typename?: 'StripeRequirementError';
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  requirement: Scalars['String']['output'];
};

export type Supplement = {
  amount?: InputMaybe<Scalars['String']['input']>;
  supplementName?: InputMaybe<Scalars['String']['input']>;
};

export type SupportRequest = {
  __typename?: 'SupportRequest';
  dateCreated: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  userId: Scalars['Float']['output'];
};

export type TackRecordData = {
  saddleFitterName: Scalars['String']['input'];
  typeOfBit: Scalars['String']['input'];
  typeOfBitNotes: Scalars['String']['input'];
  typeOfBridle: Scalars['String']['input'];
  typeOfBridleNotes: Scalars['String']['input'];
};

export type TosAcceptanceInput = {
  /** UTC timestamp that you accepted the Stripe Services Agreement. */
  date: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type TrainingRecordData = {
  lessonType: Scalars['String']['input'];
  trainer: Scalars['String']['input'];
};

export type TransactionAction = {
  __typename?: 'TransactionAction';
  deposit?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<Scalars['String']['output']>;
  transactionRecord: TransactionRecord;
  vetting?: Maybe<Scalars['String']['output']>;
  viewing?: Maybe<Scalars['String']['output']>;
};

export type TransactionEvent = {
  __typename?: 'TransactionEvent';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Float']['output'];
  transactionRecordId: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type TransactionEventInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  transactionRecordId: Scalars['Float']['input'];
  type: TransactionEventType;
};

export type TransactionEventPayload = ConfirmDeliveryPayload | CreatePaymentPayload | DepositRequestPayload | PaymentChargedPayload | PaymentPayload | PaymentRefundedPayload | PayoutPayload | PurchaseRequestPayload | RequestShipmentPayload | RequestVettingPayload | RequestViewingPayload | SetConflictOfInterestPayload | TransferPayload | TransferToShipperPayload | VetDetailsPayload | VettingRequestPayload | ViewingRequestPayload;

export enum TransactionEventType {
  AcceptDepositRequest = 'ACCEPT_DEPOSIT_REQUEST',
  AcceptDocumentViewing = 'ACCEPT_DOCUMENT_VIEWING',
  AcceptPriceRequest = 'ACCEPT_PRICE_REQUEST',
  AcceptPurchase = 'ACCEPT_PURCHASE',
  AcceptShipmentMethodCollection = 'ACCEPT_SHIPMENT_METHOD_COLLECTION',
  AcceptShipmentMethodDelivery = 'ACCEPT_SHIPMENT_METHOD_DELIVERY',
  AcceptVetting = 'ACCEPT_VETTING',
  AcceptViewing = 'ACCEPT_VIEWING',
  ConfirmDelivery = 'CONFIRM_DELIVERY',
  ConfirmShipmentDetails = 'CONFIRM_SHIPMENT_DETAILS',
  CreateDepositRequest = 'CREATE_DEPOSIT_REQUEST',
  CreatePayment = 'CREATE_PAYMENT',
  CreateShipmentDetails = 'CREATE_SHIPMENT_DETAILS',
  CreateVetDetails = 'CREATE_VET_DETAILS',
  DeclineDepositRequest = 'DECLINE_DEPOSIT_REQUEST',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentProcessed = 'PAYMENT_PROCESSED',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  PaymentRequiresAction = 'PAYMENT_REQUIRES_ACTION',
  PaymentSucceeded = 'PAYMENT_SUCCEEDED',
  PayoutCompleted = 'PAYOUT_COMPLETED',
  PayoutCreated = 'PAYOUT_CREATED',
  PayoutFailed = 'PAYOUT_FAILED',
  ReceiveEscrowPaymentConfirmation = 'RECEIVE_ESCROW_PAYMENT_CONFIRMATION',
  ReceiveFinalPayment = 'RECEIVE_FINAL_PAYMENT',
  RejectDocumentViewing = 'REJECT_DOCUMENT_VIEWING',
  RejectPriceRequest = 'REJECT_PRICE_REQUEST',
  RejectPurchase = 'REJECT_PURCHASE',
  RejectVetting = 'REJECT_VETTING',
  RejectViewing = 'REJECT_VIEWING',
  RequestDocumentViewing = 'REQUEST_DOCUMENT_VIEWING',
  RequestPrice = 'REQUEST_PRICE',
  RequestPurchase = 'REQUEST_PURCHASE',
  RequestShipmentMethod = 'REQUEST_SHIPMENT_METHOD',
  RequestVetting = 'REQUEST_VETTING',
  RequestViewing = 'REQUEST_VIEWING',
  ReturnDesposit = 'RETURN_DESPOSIT',
  SetConflictOfInterest = 'SET_CONFLICT_OF_INTEREST',
  TransferCreated = 'TRANSFER_CREATED',
  TransferToShipper = 'TRANSFER_TO_SHIPPER',
  UpdateVettingDetails = 'UPDATE_VETTING_DETAILS',
  UpdateVettingDocuments = 'UPDATE_VETTING_DOCUMENTS',
  UpdateVetDetails = 'UPDATE_VET_DETAILS',
  VettingDisputed = 'VETTING_DISPUTED',
  VettingFailed = 'VETTING_FAILED',
  VettingPassed = 'VETTING_PASSED'
}

export type TransactionRecord = {
  __typename?: 'TransactionRecord';
  action?: Maybe<TransactionAction>;
  buyerId: Scalars['Float']['output'];
  buyerProfile?: Maybe<TransactionUserProfile>;
  createdAt: Scalars['DateTime']['output'];
  deposit?: Maybe<DepositRequest>;
  id: Scalars['Float']['output'];
  listing: HorseListing;
  listingId: Scalars['Float']['output'];
  paymentSummary?: Maybe<PaymentSummary>;
  payments?: Maybe<Array<Payment>>;
  payouts?: Maybe<Array<Payout>>;
  priceRequest?: Maybe<PriceRequest>;
  purchaseRequest?: Maybe<PurchaseRequest>;
  seller?: Maybe<User>;
  sellerPayouts?: Maybe<Array<SellerPayout>>;
  sellerProfile?: Maybe<TransactionUserProfile>;
  shipment?: Maybe<Shipment>;
  state?: Maybe<Scalars['JSONObject']['output']>;
  transactionEvents: Array<TransactionEvent>;
  updatedAt: Scalars['DateTime']['output'];
  vetting?: Maybe<Vetting>;
  viewingRequest?: Maybe<ViewingRequest>;
};

export type TransactionRecordQueryInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  listingId?: InputMaybe<Scalars['Float']['input']>;
  listingUid?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionRecordsQueryInput = {
  buyerId?: InputMaybe<Scalars['Float']['input']>;
  horseId?: InputMaybe<Scalars['Float']['input']>;
  listingId?: InputMaybe<Scalars['Float']['input']>;
  listingUid?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type TransactionUserProfile = {
  __typename?: 'TransactionUserProfile';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isIdentityVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
};

export type TransferPayload = {
  __typename?: 'TransferPayload';
  payoutId: Scalars['Float']['output'];
};

export type TransferToShipperPayload = {
  __typename?: 'TransferToShipperPayload';
  comments: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  shipmentDate: Scalars['String']['output'];
  shipmentId: Scalars['Float']['output'];
};

export type TravelDocumentsRecordData = {
  dateOfPreTravelVetsVisit?: InputMaybe<Scalars['String']['input']>;
  preTravelBloodTests?: InputMaybe<Scalars['String']['input']>;
};

export type TurnoutRecordData = {
  bringInTime: Scalars['String']['input'];
  turnoutDate: Scalars['DateTime']['input'];
  turnoutTime: Scalars['String']['input'];
};

export type UpdateEquiydFeeInput = {
  equiydFeePercentage: Scalars['Float']['input'];
};

export type UpdateFileUploadStatusInput = {
  fileUploadStatus: FileUploadStatus;
  id: Scalars['String']['input'];
};

export type UpdateHorseDocumentsInput = {
  id: Scalars['Float']['input'];
  noBreedingCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  noCompetitionRecords?: InputMaybe<Scalars['Boolean']['input']>;
  noVeterinarianHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateHorseInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  ageInYear?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  breedersName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dam?: InputMaybe<Scalars['String']['input']>;
  damSire?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfLicensing?: InputMaybe<Scalars['DateTime']['input']>;
  heightInCentimeter?: InputMaybe<Scalars['Float']['input']>;
  heightInHands?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['Float']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<Scalars['String']['input']>;
  sireSire?: InputMaybe<Scalars['String']['input']>;
  stableName?: InputMaybe<Scalars['String']['input']>;
  studBook?: InputMaybe<Scalars['String']['input']>;
  transponderCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHorseListingInput = {
  deposit?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  horseId?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Float']['input'];
  isPriceHidden?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  reservedUserId?: InputMaybe<Scalars['Float']['input']>;
  sellerId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<ListingStatus>;
};

export type UpsertProfileInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  countryDialCode?: InputMaybe<Scalars['String']['input']>;
  dobString?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  reasonForJoining?: InputMaybe<ReasonForJoining>;
  state?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Float']['input'];
};

export type User = {
  __typename?: 'User';
  accountStatus: AccountStatus;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  idVerificationStatus?: Maybe<IdVerificationStatus>;
  isTestAccount?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<Profile>;
  roles: Array<UserRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationDocumentBackFileId?: Maybe<Scalars['String']['output']>;
  verificationDocumentFrontFileId?: Maybe<Scalars['String']['output']>;
};

/** User role */
export enum UserRole {
  Admin = 'Admin',
  User = 'User'
}

export enum VaccinationCategory {
  Outcome = 'OUTCOME',
  Type = 'TYPE'
}

export type VaccinationRecordData = {
  batchNumber: Scalars['String']['input'];
  vaccinationType: Scalars['String']['input'];
};

export type VaccinationReferenceDataDto = {
  __typename?: 'VaccinationReferenceDataDto';
  category: VaccinationCategory;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type VerificationToken = {
  __typename?: 'VerificationToken';
  email: Scalars['String']['output'];
};

export type VetDetails = {
  __typename?: 'VetDetails';
  conflictStatus: ConflictStatus;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vetName: Scalars['String']['output'];
  vettingDate: Scalars['DateTime']['output'];
};

export type VetDetailsPayload = {
  __typename?: 'VetDetailsPayload';
  vetName: Scalars['String']['output'];
  vettingDate: Scalars['String']['output'];
  vettingId: Scalars['Float']['output'];
};

export type VetDetailsRecordData = {
  practiceName: Scalars['String']['input'];
};

export enum VeterinaryHistoryCategory {
  Outcome = 'OUTCOME',
  Type = 'TYPE'
}

export type VeterninaryHistoryReferenceDataDto = {
  __typename?: 'VeterninaryHistoryReferenceDataDto';
  category: VeterinaryHistoryCategory;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type Vetting = {
  __typename?: 'Vetting';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  status: VettingStatus;
  transactionRecord: TransactionRecord;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vetDetails?: Maybe<Array<VetDetails>>;
};

export type VettingRequestPayload = {
  __typename?: 'VettingRequestPayload';
  isWithDeposit?: Maybe<Scalars['Boolean']['output']>;
  vettingId: Scalars['Float']['output'];
};

export enum VettingStatus {
  Accepted = 'ACCEPTED',
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  Passed = 'PASSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type VettingsQueryInput = {
  listingId?: InputMaybe<Scalars['Float']['input']>;
};

export type ViewingRequest = {
  __typename?: 'ViewingRequest';
  createdAt: Scalars['DateTime']['output'];
  documentRequestStatus?: Maybe<ViewingRequestStatus>;
  id: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ViewingRequestStatus>;
  transactionRecord: TransactionRecord;
  transactionRecordId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ViewingRequestPayload = {
  __typename?: 'ViewingRequestPayload';
  type?: Maybe<ViewingRequestType>;
  viewingRequestId: Scalars['Float']['output'];
};

export type ViewingRequestQueryInput = {
  listingId?: InputMaybe<Scalars['Float']['input']>;
  viewingRequestType?: InputMaybe<ViewingRequestType>;
};

export enum ViewingRequestStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ViewingRequestType {
  Document = 'DOCUMENT',
  Horse = 'HORSE'
}

export type WormingRecordData = {
  wormCount?: InputMaybe<Scalars['String']['input']>;
  wormCountTestDate?: InputMaybe<Scalars['String']['input']>;
  wormerName?: InputMaybe<Scalars['String']['input']>;
  wormingFrequency?: InputMaybe<Scalars['String']['input']>;
  wormingType?: InputMaybe<Scalars['String']['input']>;
};

export type XRayRecordData = {
  results: Scalars['String']['input'];
  xRayType: Scalars['String']['input'];
};

export enum XrayCategory {
  Outcome = 'OUTCOME',
  Reason = 'REASON',
  TypeOfXray = 'TYPE_OF_XRAY'
}

export type XrayReferenceDataDto = {
  __typename?: 'XrayReferenceDataDto';
  category: XrayCategory;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentUid?: Maybe<Scalars['String']['output']>;
  type: EntityType;
  uid: Scalars['String']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type HorseProfileDisplayFieldsFragment = { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, category?: string | null, sex?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null };

export type HorseProfileFieldsFragment = { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, ownerId?: number | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, category?: string | null, ageInYear?: number | null, currentAge?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, breed?: string | null, noBreedingCertificate?: boolean | null, noVeterinarianHistory?: boolean | null, noCompetitionRecords?: boolean | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null, breedingCertificates: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vaccinationRecords: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetHistory: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, competitionRecords: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetCertificates: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, xRays: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetOther: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }> };

export type TransactionRecordFieldsFragment = { __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null };

export type TransactionUserProfileFieldsFragment = { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null };

export type RegisterMutationVariables = Exact<{
  registerInput: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'User', id: number, firebaseId: string, email?: string | null } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type ResendCompleteRegistrationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendCompleteRegistrationEmailMutation = { __typename?: 'Mutation', resendCompleteRegistrationEmail: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type VerifyTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyTokenMutation = { __typename?: 'Mutation', verifyToken: { __typename?: 'VerificationToken', email: string } };

export type CompleteRegistrationMutationVariables = Exact<{
  input: CompleteRegistrationInput;
}>;


export type CompleteRegistrationMutation = { __typename?: 'Mutation', completeRegistration: boolean };

export type RecordUserEventMutationVariables = Exact<{
  userEventInput: BrevoUserEventInput;
}>;


export type RecordUserEventMutation = { __typename?: 'Mutation', recordUserEvent: boolean };

export type CreateContactMutationVariables = Exact<{
  input: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', name: string, email?: string | null, phoneNumber?: string | null } };

export type InitiateFileUploadMutationVariables = Exact<{
  initiateFileUploadInput: InitiateFileUploadInput;
}>;


export type InitiateFileUploadMutation = { __typename?: 'Mutation', initiateFileUpload: { __typename?: 'FileDto', id: string, associatedEntityId: number, associatedEntityType: AssociatedEntityType, associatedDocumentFileType: AssociatedDocumentFileType, filename?: string | null, fileType?: string | null, signedUploadUrl?: string | null } };

export type InitiateVideoUploadMutationVariables = Exact<{
  initiateVideoUploadInput: InitiateVideoUploadInput;
}>;


export type InitiateVideoUploadMutation = { __typename?: 'Mutation', initiateVideoUpload: { __typename?: 'InitiateVideoUploadResponse', bunnyVideoUploadHeaders: { __typename?: 'BunnyVideoUploadHeaders', authorizationSignature: string, authorizationExpire: number, videoId: string, libraryId: string, collectionId: string }, file: { __typename?: 'FileDto', id: string } } };

export type UpdateFileUploadStatusMutationVariables = Exact<{
  options: UpdateFileUploadStatusInput;
}>;


export type UpdateFileUploadStatusMutation = { __typename?: 'Mutation', updateFileUploadStatus: { __typename?: 'FileDto', id: string, associatedEntityId: number, associatedEntityType: AssociatedEntityType, associatedDocumentFileType: AssociatedDocumentFileType, filename?: string | null, fileType?: string | null, url?: string | null } };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type CreateFileMutationVariables = Exact<{
  createFileInput: CreateFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', create: { __typename?: 'FileDto', id: string, associatedEntityId: number, associatedEntityType: AssociatedEntityType, associatedDocumentFileType: AssociatedDocumentFileType, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null, uploaderId?: number | null, createdAt: any, updatedAt: any, signedUploadUrl?: string | null, uploadStatus?: FileUploadStatus | null, thumbnailUrl?: string | null, cloudId?: string | null, isLocked: boolean } };

export type CreateHorseListingMutationVariables = Exact<{
  options: CreateHorseListingInput;
}>;


export type CreateHorseListingMutation = { __typename?: 'Mutation', createHorseListing: { __typename?: 'HorseListing', id: number, sellerId: number, horseId: number, price?: number | null, deposit?: number | null, platformFeePercentage?: number | null, depositFeePercentage?: number | null, vatPercentage?: number | null, description?: string | null, status: ListingStatus, uid?: string | null, total?: number | null, serviceFee?: number | null, serviceFeeVat?: number | null, depositFee?: number | null, depositFeeVat?: number | null, depositTotal?: number | null, isPriceHidden?: boolean | null } };

export type UpdateHorseListingMutationVariables = Exact<{
  options: UpdateHorseListingInput;
}>;


export type UpdateHorseListingMutation = { __typename?: 'Mutation', updateHorseListing: { __typename?: 'HorseListing', id: number, sellerId: number, horseId: number, price?: number | null, deposit?: number | null, platformFeePercentage?: number | null, depositFeePercentage?: number | null, vatPercentage?: number | null, description?: string | null, status: ListingStatus, uid?: string | null, total?: number | null, serviceFee?: number | null, serviceFeeVat?: number | null, depositFee?: number | null, depositFeeVat?: number | null, depositTotal?: number | null, isPriceHidden?: boolean | null } };

export type DeleteHorseRecordMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteHorseRecordMutation = { __typename?: 'Mutation', deleteHorseRecord: boolean };

export type CreateFarrierRecordMutationVariables = Exact<{
  input: CreateFarrierRecordPayload;
}>;


export type CreateFarrierRecordMutation = { __typename?: 'Mutation', createFarrierRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null } };

export type CreateVetDetailsRecordMutationVariables = Exact<{
  input: CreateVetDetailsRecordPayload;
}>;


export type CreateVetDetailsRecordMutation = { __typename?: 'Mutation', createVetDetailsRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateVeterinaryHistoryRecordMutationVariables = Exact<{
  input: CreateVeterinaryHistoryRecordPayload;
}>;


export type CreateVeterinaryHistoryRecordMutation = { __typename?: 'Mutation', createVeterinaryHistoryRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateMedicationLogRecordMutationVariables = Exact<{
  input: CreateMedicationLogRecordPayload;
}>;


export type CreateMedicationLogRecordMutation = { __typename?: 'Mutation', createMedicationLogRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null } };

export type CreatePhysiotherapyRecordMutationVariables = Exact<{
  input: CreatePhysiotherapyRecordPayload;
}>;


export type CreatePhysiotherapyRecordMutation = { __typename?: 'Mutation', createPhysiotherapyRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateChiropractorRecordMutationVariables = Exact<{
  input: CreateChiropractorRecordPayload;
}>;


export type CreateChiropractorRecordMutation = { __typename?: 'Mutation', createChiropractorRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateDentalRecordMutationVariables = Exact<{
  input: CreateDentalRecordPayload;
}>;


export type CreateDentalRecordMutation = { __typename?: 'Mutation', createDentalRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateXrayRecordMutationVariables = Exact<{
  input: CreateXrayRecordPayload;
}>;


export type CreateXrayRecordMutation = { __typename?: 'Mutation', createXrayRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateWormingRecordMutationVariables = Exact<{
  input: CreateWormingRecordPayload;
}>;


export type CreateWormingRecordMutation = { __typename?: 'Mutation', createWormingRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateVaccinationRecordMutationVariables = Exact<{
  input: CreateVaccinationRecordPayload;
}>;


export type CreateVaccinationRecordMutation = { __typename?: 'Mutation', createVaccinationRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateBloodTestRecordMutationVariables = Exact<{
  input: CreateBloodTestRecordPayload;
}>;


export type CreateBloodTestRecordMutation = { __typename?: 'Mutation', createBloodTestRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateCompetitionRecordv2MutationVariables = Exact<{
  input: CreateCompetitionRecordPayload;
}>;


export type CreateCompetitionRecordv2Mutation = { __typename?: 'Mutation', createCompetitionRecordv2: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateTravelDocumentsRecordMutationVariables = Exact<{
  input: CreateTravelDocumentsRecordPayload;
}>;


export type CreateTravelDocumentsRecordMutation = { __typename?: 'Mutation', createTravelDocumentsRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateAdditionalDocumentsRecordMutationVariables = Exact<{
  input: CreateAdditionalDocumentsRecordPayload;
}>;


export type CreateAdditionalDocumentsRecordMutation = { __typename?: 'Mutation', createAdditionalDocumentsRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateTurnoutRecordMutationVariables = Exact<{
  input: CreateTurnoutRecordPayload;
}>;


export type CreateTurnoutRecordMutation = { __typename?: 'Mutation', createTurnoutRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateFeedingRecordMutationVariables = Exact<{
  input: CreateFeedingRecordPayload;
}>;


export type CreateFeedingRecordMutation = { __typename?: 'Mutation', createFeedingRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateExerciseRecordMutationVariables = Exact<{
  input: CreateExerciseRecordPayload;
}>;


export type CreateExerciseRecordMutation = { __typename?: 'Mutation', createExerciseRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateTrainingRecordMutationVariables = Exact<{
  input: CreateTrainingRecordPayload;
}>;


export type CreateTrainingRecordMutation = { __typename?: 'Mutation', createTrainingRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateTackRecordMutationVariables = Exact<{
  input: CreateTackRecordPayload;
}>;


export type CreateTackRecordMutation = { __typename?: 'Mutation', createTackRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreatePersonalityRecordMutationVariables = Exact<{
  input: CreatePersonalityRecordPayload;
}>;


export type CreatePersonalityRecordMutation = { __typename?: 'Mutation', createPersonalityRecord: { __typename?: 'HorseRecord', id: number, horseId: number, type: string, date?: string | null, notes?: string | null, files?: Array<string> | null, data?: any | null, contacts?: Array<{ __typename?: 'Contact', name: string, type: string }> | null } };

export type CreateHorseMutationVariables = Exact<{
  createHorseInput: CreateHorseInput;
}>;


export type CreateHorseMutation = { __typename?: 'Mutation', createHorse: { __typename?: 'HorseDto', id: number, createdAt: any, updatedAt: any, ownerId?: number | null, name?: string | null, displayName?: string | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, breed?: string | null, category?: string | null, ageInYear?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, addressLine1?: string | null, addressLine2?: string | null, country?: string | null, city?: string | null, postcode?: string | null, dateOfBirth?: any | null } };

export type DeleteHorseMutationVariables = Exact<{
  horseId: Scalars['Float']['input'];
}>;


export type DeleteHorseMutation = { __typename?: 'Mutation', deleteHorse: boolean };

export type UpdateHorseMutationVariables = Exact<{
  updateHorseInput: UpdateHorseInput;
}>;


export type UpdateHorseMutation = { __typename?: 'Mutation', updateHorse: { __typename?: 'HorseDto', id: number, createdAt: any, updatedAt: any, ownerId?: number | null, name?: string | null, displayName?: string | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, breed?: string | null, category?: string | null, ageInYear?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, addressLine1?: string | null, addressLine2?: string | null, country?: string | null, city?: string | null, postcode?: string | null, dateOfBirth?: any | null } };

export type SetProfilePhotoMutationVariables = Exact<{
  setProfilePhotoInput: SetProfilePhotoInput;
}>;


export type SetProfilePhotoMutation = { __typename?: 'Mutation', setProfilePhoto: { __typename?: 'HorseDto', id: number, createdAt: any, name?: string | null, ownerId?: number | null } };

export type DeleteProfilePhotoMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteProfilePhotoMutation = { __typename?: 'Mutation', deleteProfilePhoto: boolean };

export type CreateCompetitionRecordMutationVariables = Exact<{
  createCompetitionRecordInput: CreateCompetitionRecordInput;
}>;


export type CreateCompetitionRecordMutation = { __typename?: 'Mutation', createCompetitionRecord: { __typename?: 'CompetitionRecord', id: number, horseId: number, fileId: string, competitionName: string, competitionNumber: number } };

export type UpdateHorseDocumentsMutationVariables = Exact<{
  updateHorseDocumentsInput: UpdateHorseDocumentsInput;
}>;


export type UpdateHorseDocumentsMutation = { __typename?: 'Mutation', updateHorseDocuments: { __typename?: 'HorseDto', id: number, createdAt: any, updatedAt: any, ownerId?: number | null, name?: string | null, displayName?: string | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, breed?: string | null, category?: string | null, ageInYear?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, addressLine1?: string | null, addressLine2?: string | null, country?: string | null, city?: string | null, postcode?: string | null, noBreedingCertificate?: boolean | null, noVeterinarianHistory?: boolean | null, noCompetitionRecords?: boolean | null } };

export type AcknowledgeNotificationMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification: boolean };

export type CreateOrUpdateSellerAccountMutationVariables = Exact<{
  createSellerAccountInput: CreateSellerAccountInput;
}>;


export type CreateOrUpdateSellerAccountMutation = { __typename?: 'Mutation', createOrUpdateSellerAccount: { __typename?: 'SellerAccount', stripeResponse?: { __typename?: 'StripeAccount', requirements?: { __typename?: 'StripeAccountRequirements', currently_due?: Array<string> | null, eventually_due?: Array<string> | null, past_due?: Array<string> | null, pending_verification?: Array<string> | null, current_deadline?: number | null, disabled_reason?: string | null, errors?: Array<{ __typename?: 'StripeRequirementError', code: string, reason: string, requirement: string }> | null } | null } | null } };

export type CreateOrUpdatePayoutBankAccountMutationVariables = Exact<{
  createPayoutBankAccountInput: CreatePayoutBankAccountInput;
}>;


export type CreateOrUpdatePayoutBankAccountMutation = { __typename?: 'Mutation', createOrUpdatePayoutBankAccount: { __typename?: 'SellerAccount', stripeResponse?: { __typename?: 'StripeAccount', requirements?: { __typename?: 'StripeAccountRequirements', currently_due?: Array<string> | null, eventually_due?: Array<string> | null, past_due?: Array<string> | null, pending_verification?: Array<string> | null, current_deadline?: number | null, disabled_reason?: string | null, errors?: Array<{ __typename?: 'StripeRequirementError', code: string, reason: string, requirement: string }> | null } | null } | null } };

export type UploadVerificationDocumentsMutationVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type UploadVerificationDocumentsMutation = { __typename?: 'Mutation', uploadVerificationDocuments: { __typename?: 'SellerAccount', stripeResponse?: { __typename?: 'StripeAccount', requirements?: { __typename?: 'StripeAccountRequirements', currently_due?: Array<string> | null, eventually_due?: Array<string> | null, past_due?: Array<string> | null, pending_verification?: Array<string> | null, current_deadline?: number | null, disabled_reason?: string | null, errors?: Array<{ __typename?: 'StripeRequirementError', code: string, reason: string, requirement: string }> | null } | null } | null } };

export type CreateTransactionRecordMutationVariables = Exact<{
  createTransactionRecordInput: CreateTransactionRecordInput;
}>;


export type CreateTransactionRecordMutation = { __typename?: 'Mutation', createTransactionRecord: { __typename?: 'TransactionRecord', id: number, buyerId: number, listingId: number, state?: any | null } };

export type HandleBuyerEventMutationVariables = Exact<{
  transactionEventInput: TransactionEventInput;
}>;


export type HandleBuyerEventMutation = { __typename?: 'Mutation', handleBuyerEvent: { __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null } };

export type HandleSellerEventMutationVariables = Exact<{
  transactionEventInput: TransactionEventInput;
}>;


export type HandleSellerEventMutation = { __typename?: 'Mutation', handleSellerEvent: { __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null } };

export type UpsertProfileMutationVariables = Exact<{
  upsertProfileInput: UpsertProfileInput;
}>;


export type UpsertProfileMutation = { __typename?: 'Mutation', upsertProfile: { __typename?: 'User', id: number, profile?: { __typename?: 'Profile', id: number, firstName?: string | null, lastName?: string | null, countryDialCode?: string | null, phoneNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null, isBusiness?: boolean | null } | null } };

export type SendSupportRequestMutationVariables = Exact<{
  sendSupportRequestInput: SendSupportRequestInput;
}>;


export type SendSupportRequestMutation = { __typename?: 'Mutation', sendSupportRequest: { __typename?: 'SupportRequest', id: number, userId: number, message: string } };

export type AddVerificationDocumentsMutationVariables = Exact<{
  userId: Scalars['Float']['input'];
  frontFileId: Scalars['String']['input'];
  backFileId: Scalars['String']['input'];
}>;


export type AddVerificationDocumentsMutation = { __typename?: 'Mutation', addVerificationDocuments: { __typename?: 'User', id: number, verificationDocumentFrontFileId?: string | null, verificationDocumentBackFileId?: string | null } };

export type FundBalanceMutationVariables = Exact<{
  userId: Scalars['Float']['input'];
  amount: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
}>;


export type FundBalanceMutation = { __typename?: 'Mutation', fundBalance: boolean };

export type ProcessSellerPayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessSellerPayoutQuery = { __typename?: 'Query', processSellerPayout: boolean };

export type ProcessPaidPayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessPaidPayoutQuery = { __typename?: 'Query', processPaidPayout: boolean };

export type QueryContactsByUserQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type QueryContactsByUserQuery = { __typename?: 'Query', contactsByUser: Array<{ __typename?: 'Contact', id: number, name: string, email?: string | null, phoneNumber?: string | null }> };

export type QueryContactsByNameQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  contactType: ContactType;
}>;


export type QueryContactsByNameQuery = { __typename?: 'Query', contactsByName: Array<{ __typename?: 'Contact', id: number, name: string, email?: string | null, phoneNumber?: string | null }> };

export type FilesQueryVariables = Exact<{
  options: FileQueryInput;
}>;


export type FilesQuery = { __typename?: 'Query', files: Array<{ __typename?: 'FileDto', id: string, associatedEntityId: number, associatedEntityType: AssociatedEntityType, associatedDocumentFileType: AssociatedDocumentFileType, uploaderId?: number | null, createdAt: any, filename?: string | null, fileLocation: string, fileType?: string | null, url?: string | null, uploadStatus?: FileUploadStatus | null, thumbnailUrl?: string | null, isLocked: boolean }> };

export type FileQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, url?: string | null, thumbnailUrl?: string | null, fileType?: string | null, isLocked: boolean } };

export type GetSignedUrlQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type GetSignedUrlQuery = { __typename?: 'Query', getSignedUrl: string };

export type HorseListingsQueryVariables = Exact<{
  pagedQueryInput: PagedHorseListingInput;
}>;


export type HorseListingsQuery = { __typename?: 'Query', horseListings: { __typename?: 'PagedHorseListingResponse', pageOffset: number, pageSize: number, totalCount: number, results: Array<{ __typename?: 'HorseListing', id: number, sellerId: number, description?: string | null, status: ListingStatus, price?: number | null, platformFeePercentage?: number | null, depositFeePercentage?: number | null, vatPercentage?: number | null, deposit?: number | null, uid?: string | null, total?: number | null, serviceFee?: number | null, serviceFeeVat?: number | null, depositFee?: number | null, depositFeeVat?: number | null, depositTotal?: number | null, isPriceHidden?: boolean | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, category?: string | null, sex?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }> } };

export type HorseListingQueryVariables = Exact<{
  options: QueryHorseListingInput;
}>;


export type HorseListingQuery = { __typename?: 'Query', horseListing: { __typename?: 'HorseListing', id: number, horseId: number, sellerId: number, description?: string | null, status: ListingStatus, price?: number | null, platformFeePercentage?: number | null, depositFeePercentage?: number | null, vatPercentage?: number | null, deposit?: number | null, uid?: string | null, total?: number | null, serviceFee?: number | null, serviceFeeVat?: number | null, depositFee?: number | null, depositFeeVat?: number | null, depositTotal?: number | null, isPriceHidden?: boolean | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, ownerId?: number | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, category?: string | null, ageInYear?: number | null, currentAge?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, breed?: string | null, noBreedingCertificate?: boolean | null, noVeterinarianHistory?: boolean | null, noCompetitionRecords?: boolean | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null, breedingCertificates: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vaccinationRecords: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetHistory: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, competitionRecords: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetCertificates: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, xRays: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }>, vetOther: Array<{ __typename?: 'FileDto', thumbnailUrl?: string | null, url?: string | null }> } } };

export type GetFarrierTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFarrierTreatmentsQuery = { __typename?: 'Query', getFarrierTreatments: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetVeterinaryHistoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVeterinaryHistoriesQuery = { __typename?: 'Query', getVeterinaryHistories: Array<{ __typename?: 'VeterninaryHistoryReferenceDataDto', uid: string, name: string, parentUid?: string | null, category: VeterinaryHistoryCategory }> };

export type GetMedicationLogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedicationLogQuery = { __typename?: 'Query', getMedicationLog: Array<{ __typename?: 'MedicalLogReferenceData', uid: string, name: string, medicationLogType: MedicationLogType }> };

export type GetPhysiotherapyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPhysiotherapyQuery = { __typename?: 'Query', getPhysiotherapy: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetChiropractorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChiropractorQuery = { __typename?: 'Query', getChiropractor: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetDentalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDentalQuery = { __typename?: 'Query', getDental: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetXrayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXrayQuery = { __typename?: 'Query', getXray: Array<{ __typename?: 'XrayReferenceDataDto', uid: string, name: string, category: XrayCategory, parentUid?: string | null }> };

export type GetWormingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWormingQuery = { __typename?: 'Query', getWorming: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetVaccinationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVaccinationQuery = { __typename?: 'Query', getVaccination: Array<{ __typename?: 'VaccinationReferenceDataDto', uid: string, name: string, category: VaccinationCategory, parentUid?: string | null }> };

export type GetBloodTestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBloodTestQuery = { __typename?: 'Query', getBloodTest: Array<{ __typename?: 'BloodTestReferenceDataDto', uid: string, name: string, category: BloodTestCategory, parentUid?: string | null }> };

export type GetFeedingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedingQuery = { __typename?: 'Query', getFeeding: Array<{ __typename?: 'FeedingReferenceDataDto', uid: string, name: string, category?: FeedingRefDataCategory | null }> };

export type ExerciseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExerciseTypesQuery = { __typename?: 'Query', exerciseTypes: Array<{ __typename?: 'ReferenceDataDto', uid: string, name: string }> };

export type GetPersonalityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalityQuery = { __typename?: 'Query', getPersonality: Array<{ __typename?: 'PersonalityReferenceDataDto', uid: string, name: string, category: PersonalityRefDataCategory }> };

export type HorseRecordsQueryVariables = Exact<{
  type: HorseRecordType;
  horseId: Scalars['Float']['input'];
}>;


export type HorseRecordsQuery = { __typename?: 'Query', horseRecords: Array<{ __typename?: 'HorseRecord', id: number, type: string, createdAt: any, date?: string | null, nextVisitDueDate?: string | null, reasonForVisit?: string | null, data?: any | null, files?: Array<string> | null, horseId: number, outcome?: string | null, notes?: string | null, contacts?: Array<{ __typename?: 'Contact', id: number, name: string }> | null }> };

export type HorseRecordQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type HorseRecordQuery = { __typename?: 'Query', horseRecord: { __typename?: 'HorseRecord', id: number, type: string, createdAt: any, date?: string | null, nextVisitDueDate?: string | null, reasonForVisit?: string | null, data?: any | null, files?: Array<string> | null, horseId: number, outcome?: string | null, notes?: string | null, contacts?: Array<{ __typename?: 'Contact', id: number, name: string }> | null } };

export type HorseQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type HorseQuery = { __typename?: 'Query', horse: { __typename?: 'HorseDto', id: number, createdAt: any, updatedAt: any, ownerId?: number | null, name?: string | null, displayName?: string | null, passportNumber?: string | null, transponderCode?: string | null, stableName?: string | null, breed?: string | null, category?: string | null, ageInYear?: number | null, currentAge?: number | null, heightInCentimeter?: number | null, heightInHands?: number | null, colour?: string | null, sex?: string | null, dam?: string | null, sire?: string | null, damSire?: string | null, sireSire?: string | null, breedersName?: string | null, studBook?: string | null, registrationNumber?: number | null, dateOfLicensing?: any | null, addressLine1?: string | null, addressLine2?: string | null, country?: string | null, city?: string | null, postcode?: string | null, dateOfBirth?: any | null, noBreedingCertificate?: boolean | null, noVeterinarianHistory?: boolean | null, noCompetitionRecords?: boolean | null, horseListings: Array<{ __typename?: 'HorseListing', id: number, horseId: number, uid?: string | null, status: ListingStatus }>, breedingCertificates: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, vaccinationRecords: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, vetHistory: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, competitionRecords: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, vetCertificates: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, xRays: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, vetOther: Array<{ __typename?: 'FileDto', id: string, createdAt: any, filename?: string | null, fileType?: string | null, fileLocation: string, url?: string | null }>, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } };

export type HorsesQueryVariables = Exact<{
  ownerId: Scalars['Float']['input'];
}>;


export type HorsesQuery = { __typename?: 'Query', horses: Array<{ __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, ownerId?: number | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null, horseListings: Array<{ __typename?: 'HorseListing', id: number, horseId: number, uid?: string | null, status: ListingStatus, price?: number | null }> }> };

export type CompetitionRecordsQueryVariables = Exact<{
  competitionRecordQueryInput: CompetitionRecordQueryInput;
}>;


export type CompetitionRecordsQuery = { __typename?: 'Query', competitionRecords: Array<{ __typename?: 'CompetitionRecord', id: number, horseId: number, fileId: string, competitionName: string, competitionNumber: number }> };

export type DeleteCompetitionRecordMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteCompetitionRecordMutation = { __typename?: 'Mutation', deleteCompetitionRecord: boolean };

export type ActiveNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveNotificationsQuery = { __typename?: 'Query', activeNotifications: Array<{ __typename?: 'NotificationEntityDto', id: number, recipientUserId: number, title: string, message: string, acknowledgedDate?: any | null }> };

export type PaymentsQueryVariables = Exact<{
  options: PagedPaymentQueryInput;
}>;


export type PaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PagedPaymentQueryResponse', totalCount: number, pageOffset: number, results: Array<{ __typename?: 'Payment', id: number, createdAt: any, amount?: number | null, transactionRecordId: number, paymentType: PaymentType, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> } };

export type PaymentWithActionQueryVariables = Exact<{
  paymentId: Scalars['Float']['input'];
}>;


export type PaymentWithActionQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: number, createdAt: any, amount?: number | null, transactionRecordId: number, paymentType: PaymentType, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null, nextAction?: { __typename?: 'PaymentAction', type: string, bankTransferInstructions?: { __typename?: 'BankTransferInstructions', type: string, currency?: string | null, reference?: string | null, amountRemaining?: string | null, financialAddresses?: any | null } | null } | null } | null };

export type PurchasesQueryVariables = Exact<{
  options: PurchasesQueryInput;
}>;


export type PurchasesQuery = { __typename?: 'Query', purchases: Array<{ __typename?: 'PurchaseRequest', id: number, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null } }> };

export type PurchaseQueryVariables = Exact<{
  purchaseRequestId: Scalars['Float']['input'];
}>;


export type PurchaseQuery = { __typename?: 'Query', purchase: { __typename?: 'PurchaseRequest', id: number, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null } } };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number, email?: string | null, firebaseId: string, roles: Array<UserRole>, accountStatus: { __typename?: 'AccountStatus', emailVerificationStatus: AccountStatusProgress, personalDetailsStatus: AccountStatusProgress, identityVerificationStatus: AccountStatusProgress }, profile?: { __typename?: 'Profile', id: number, firstName?: string | null, lastName?: string | null, countryDialCode?: string | null, phoneNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null, countryCode?: CountryCode | null, isBusiness?: boolean | null, photoUrl?: string | null, reasonForJoining?: ReasonForJoining | null } | null } };

export type SellerAccountQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type SellerAccountQuery = { __typename?: 'Query', sellerAccount?: { __typename?: 'SellerAccount', canAcceptPayments: boolean, canMakePayments: boolean, firstName?: string | null, lastName?: string | null, countryCode: CountryCode, phone?: string | null, countryDialCode?: string | null, dateOfBirth?: { __typename?: 'DateOfBirth', year: number, month: number, day: number } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, countryCode?: CountryCode | null } | null, externalBankAccounts?: Array<{ __typename?: 'ExternalBankAccount', id: string, accountHolderName?: string | null, accountHolderType?: string | null, bankName?: string | null, country?: CountryCode | null, currency?: CurrencyCode | null, defaultForCurrency?: boolean | null, last4?: string | null, routingNumber?: string | null, status: string }> | null, stripeResponse?: { __typename?: 'StripeAccount', id: string, charges_enabled: boolean, payouts_enabled: boolean, default_currency?: string | null, country?: string | null, requirements?: { __typename?: 'StripeAccountRequirements', currently_due?: Array<string> | null, eventually_due?: Array<string> | null, past_due?: Array<string> | null, pending_verification?: Array<string> | null, current_deadline?: number | null, disabled_reason?: string | null, errors?: Array<{ __typename?: 'StripeRequirementError', code: string, reason: string, requirement: string }> | null } | null } | null } | null };

export type TransactionRecordsQueryVariables = Exact<{
  options: TransactionRecordsQueryInput;
}>;


export type TransactionRecordsQuery = { __typename?: 'Query', transactionRecords: Array<{ __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null }> };

export type TransactionRecordQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type TransactionRecordQuery = { __typename?: 'Query', transactionRecord?: { __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null } | null };

export type BuyerTransactionRecordQueryVariables = Exact<{
  options: TransactionRecordQueryInput;
}>;


export type BuyerTransactionRecordQuery = { __typename?: 'Query', buyerTransactionRecord?: { __typename?: 'TransactionRecord', id: number, createdAt: any, updatedAt: any, buyerId: number, state?: any | null, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, sellerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null, transactionEvents: Array<{ __typename?: 'TransactionEvent', id: number, createdAt: any, type: string, data?: any | null }>, listing: { __typename?: 'HorseListing', id: number, price?: number | null, deposit?: number | null, uid?: string | null, status: ListingStatus, sellerId: number, isPriceHidden?: boolean | null, total?: number | null, reservedUserId?: number | null, horse: { __typename?: 'HorseDto', id: number, name?: string | null, displayName?: string | null, profilePhoto?: { __typename?: 'ProfilePhoto', id: string, url: string } | null } }, priceRequest?: { __typename?: 'PriceRequest', id: number, createdAt: any, updatedAt: any, status?: PriceRequestStatus | null } | null, viewingRequest?: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null } | null, vetting?: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } | null, payments?: Array<{ __typename?: 'Payment', id: number, createdAt: any, paymentType: PaymentType, paymentIntentId: string, amount?: number | null, clientSecret?: string | null, paymentStatus?: PaymentStatus | null, chargeStatus?: ChargeStatus | null, refundStatus?: RefundStatus | null }> | null, deposit?: { __typename?: 'DepositRequest', id: number, status: DepositRequestStatus } | null, purchaseRequest?: { __typename?: 'PurchaseRequest', id: number, createdAt: any, updatedAt: any, status: PurchaseRequestStatus } | null, shipment?: { __typename?: 'Shipment', id: number, createdAt: any, updatedAt: any, shipmentMethod: ShipmentMethod, status: ShipmentStatus, comments?: string | null, shipmentDetails?: { __typename?: 'ShipmentDetails', id: number, createdAt: any, updatedAt: any, companyName: string, shipmentDate: any, status: ShipmentDetailsStatus } | null } | null, paymentSummary?: { __typename?: 'PaymentSummary', listingPrice: number, platformFee: number, subTotal: number, platformFeeVat: number, total: number, totalReceived: number, amountDue: number, depositAmount: number, depositFee: number, depositFeeVat: number, depositFeePercentage?: number | null, depositTotal: number, depositDue: number, depositAmountReceived: number, finalPaymentAmountReceived: number, vatPercentage: number, platformFeePercentage: number, fullPaymentMade: boolean } | null, payouts?: Array<{ __typename?: 'Payout', payoutType: PayoutType, amount?: number | null, updatedAt: any, payoutStatus?: PayoutStatus | null }> | null, action?: { __typename?: 'TransactionAction', pricing?: string | null, viewing?: string | null, vetting?: string | null, deposit?: string | null, purchase?: string | null } | null } | null };

export type TransactionRecordsNotificationCounterQueryVariables = Exact<{
  options: TransactionRecordsQueryInput;
}>;


export type TransactionRecordsNotificationCounterQuery = { __typename?: 'Query', transactionRecordsNotificationCounter: { __typename?: 'NotificationResponse', buyerNotificationCount?: number | null, sellerNotificationCount?: number | null } };

export type SellerHorseNotificationCounterQueryVariables = Exact<{
  options: TransactionRecordsQueryInput;
}>;


export type SellerHorseNotificationCounterQuery = { __typename?: 'Query', sellerHorseNotificationCounter: { __typename?: 'HorseNotificationResponse', horseNotificationCount?: number | null } };

export type VettingQueryVariables = Exact<{
  vettingId: Scalars['Float']['input'];
}>;


export type VettingQuery = { __typename?: 'Query', vetting: { __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null }, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null } };

export type VettingsQueryVariables = Exact<{
  options: VettingsQueryInput;
}>;


export type VettingsQuery = { __typename?: 'Query', vettings: Array<{ __typename?: 'Vetting', id: number, createdAt: any, updatedAt: any, status: VettingStatus, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null }, vetDetails?: Array<{ __typename?: 'VetDetails', id: number, createdAt: any, updatedAt: any, vetName: string, vettingDate: any, conflictStatus: ConflictStatus }> | null }> };

export type ViewingRequestsQueryVariables = Exact<{
  options: ViewingRequestQueryInput;
}>;


export type ViewingRequestsQuery = { __typename?: 'Query', viewingRequests: Array<{ __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null } }> };

export type ViewingRequestQueryVariables = Exact<{
  viewingRequestId: Scalars['Float']['input'];
}>;


export type ViewingRequestQuery = { __typename?: 'Query', viewingRequest: { __typename?: 'ViewingRequest', id: number, createdAt: any, updatedAt: any, message?: string | null, status?: ViewingRequestStatus | null, documentRequestStatus?: ViewingRequestStatus | null, transactionRecordId: number, transactionRecord: { __typename?: 'TransactionRecord', id: number, buyerProfile?: { __typename?: 'TransactionUserProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, isEmailVerified?: boolean | null, isIdentityVerified?: boolean | null, phoneNumber?: string | null, profilePhotoUrl?: string | null } | null } } };

export const HorseProfileDisplayFieldsFragmentDoc = gql`
    fragment HorseProfileDisplayFields on HorseDto {
  id
  name
  displayName
  category
  sex
  profilePhoto {
    id
    url
  }
}
    `;
export const HorseProfileFieldsFragmentDoc = gql`
    fragment HorseProfileFields on HorseDto {
  id
  name
  displayName
  ownerId
  passportNumber
  transponderCode
  stableName
  category
  ageInYear
  currentAge
  heightInCentimeter
  heightInHands
  colour
  sex
  dam
  sire
  damSire
  breed
  profilePhoto {
    id
    url
  }
  breedingCertificates {
    thumbnailUrl
    url
  }
  vaccinationRecords {
    thumbnailUrl
    url
  }
  vetHistory {
    thumbnailUrl
    url
  }
  competitionRecords {
    thumbnailUrl
    url
  }
  vetCertificates {
    thumbnailUrl
    url
  }
  xRays {
    thumbnailUrl
    url
  }
  vetOther {
    thumbnailUrl
    url
  }
  noBreedingCertificate
  noVeterinarianHistory
  noCompetitionRecords
}
    `;
export const TransactionUserProfileFieldsFragmentDoc = gql`
    fragment TransactionUserProfileFields on TransactionUserProfile {
  id
  email
  firstName
  lastName
  isEmailVerified
  isIdentityVerified
  phoneNumber
  profilePhotoUrl
}
    `;
export const TransactionRecordFieldsFragmentDoc = gql`
    fragment TransactionRecordFields on TransactionRecord {
  id
  createdAt
  updatedAt
  buyerId
  state
  buyerProfile {
    ...TransactionUserProfileFields
  }
  sellerProfile {
    ...TransactionUserProfileFields
  }
  transactionEvents {
    id
    createdAt
    type
    data
  }
  listing {
    id
    horse {
      id
      name
      displayName
      profilePhoto {
        id
        url
      }
    }
    price
    deposit
    uid
    status
    sellerId
    isPriceHidden
    total
    reservedUserId
  }
  priceRequest {
    id
    createdAt
    updatedAt
    status
  }
  viewingRequest {
    id
    createdAt
    updatedAt
    message
    status
    documentRequestStatus
  }
  vetting {
    id
    createdAt
    updatedAt
    status
    vetDetails {
      id
      createdAt
      updatedAt
      vetName
      vettingDate
      conflictStatus
    }
  }
  payments {
    id
    createdAt
    paymentType
    paymentIntentId
    amount
    clientSecret
    paymentStatus
    chargeStatus
    refundStatus
  }
  deposit {
    id
    status
  }
  purchaseRequest {
    id
    createdAt
    updatedAt
    status
  }
  shipment {
    id
    createdAt
    updatedAt
    shipmentMethod
    status
    comments
    shipmentDetails {
      id
      createdAt
      updatedAt
      companyName
      shipmentDate
      status
    }
  }
  paymentSummary {
    listingPrice
    platformFee
    subTotal
    platformFeeVat
    total
    totalReceived
    amountDue
    depositAmount
    depositFee
    depositFeeVat
    depositFeePercentage
    depositTotal
    depositDue
    depositAmountReceived
    finalPaymentAmountReceived
    vatPercentage
    platformFeePercentage
    fullPaymentMade
  }
  payouts {
    payoutType
    amount
    updatedAt
    payoutStatus
  }
  action {
    pricing
    viewing
    vetting
    deposit
    purchase
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;
export const RegisterDocument = gql`
    mutation register($registerInput: RegisterInput!) {
  register(registerInput: $registerInput) {
    id
    firebaseId
    email
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      registerInput: // value for 'registerInput'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($token: String!) {
  verifyEmail(id: $token)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation sendResetPasswordEmail($email: String!) {
  sendResetPasswordEmail(email: $email)
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const ResendCompleteRegistrationEmailDocument = gql`
    mutation resendCompleteRegistrationEmail($email: String!) {
  resendCompleteRegistrationEmail(email: $email)
}
    `;
export type ResendCompleteRegistrationEmailMutationFn = Apollo.MutationFunction<ResendCompleteRegistrationEmailMutation, ResendCompleteRegistrationEmailMutationVariables>;

/**
 * __useResendCompleteRegistrationEmailMutation__
 *
 * To run a mutation, you first call `useResendCompleteRegistrationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCompleteRegistrationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCompleteRegistrationEmailMutation, { data, loading, error }] = useResendCompleteRegistrationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendCompleteRegistrationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendCompleteRegistrationEmailMutation, ResendCompleteRegistrationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendCompleteRegistrationEmailMutation, ResendCompleteRegistrationEmailMutationVariables>(ResendCompleteRegistrationEmailDocument, options);
      }
export type ResendCompleteRegistrationEmailMutationHookResult = ReturnType<typeof useResendCompleteRegistrationEmailMutation>;
export type ResendCompleteRegistrationEmailMutationResult = Apollo.MutationResult<ResendCompleteRegistrationEmailMutation>;
export type ResendCompleteRegistrationEmailMutationOptions = Apollo.BaseMutationOptions<ResendCompleteRegistrationEmailMutation, ResendCompleteRegistrationEmailMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: ResetPasswordInput!) {
  updatePassword(input: $input)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const VerifyTokenDocument = gql`
    mutation verifyToken($token: String!) {
  verifyToken(token: $token) {
    email
  }
}
    `;
export type VerifyTokenMutationFn = Apollo.MutationFunction<VerifyTokenMutation, VerifyTokenMutationVariables>;

/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTokenMutation, VerifyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTokenMutation, VerifyTokenMutationVariables>(VerifyTokenDocument, options);
      }
export type VerifyTokenMutationHookResult = ReturnType<typeof useVerifyTokenMutation>;
export type VerifyTokenMutationResult = Apollo.MutationResult<VerifyTokenMutation>;
export type VerifyTokenMutationOptions = Apollo.BaseMutationOptions<VerifyTokenMutation, VerifyTokenMutationVariables>;
export const CompleteRegistrationDocument = gql`
    mutation completeRegistration($input: CompleteRegistrationInput!) {
  completeRegistration(input: $input)
}
    `;
export type CompleteRegistrationMutationFn = Apollo.MutationFunction<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>;

/**
 * __useCompleteRegistrationMutation__
 *
 * To run a mutation, you first call `useCompleteRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRegistrationMutation, { data, loading, error }] = useCompleteRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>(CompleteRegistrationDocument, options);
      }
export type CompleteRegistrationMutationHookResult = ReturnType<typeof useCompleteRegistrationMutation>;
export type CompleteRegistrationMutationResult = Apollo.MutationResult<CompleteRegistrationMutation>;
export type CompleteRegistrationMutationOptions = Apollo.BaseMutationOptions<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>;
export const RecordUserEventDocument = gql`
    mutation RecordUserEvent($userEventInput: BrevoUserEventInput!) {
  recordUserEvent(userEventInput: $userEventInput)
}
    `;
export type RecordUserEventMutationFn = Apollo.MutationFunction<RecordUserEventMutation, RecordUserEventMutationVariables>;

/**
 * __useRecordUserEventMutation__
 *
 * To run a mutation, you first call `useRecordUserEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserEventMutation, { data, loading, error }] = useRecordUserEventMutation({
 *   variables: {
 *      userEventInput: // value for 'userEventInput'
 *   },
 * });
 */
export function useRecordUserEventMutation(baseOptions?: Apollo.MutationHookOptions<RecordUserEventMutation, RecordUserEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordUserEventMutation, RecordUserEventMutationVariables>(RecordUserEventDocument, options);
      }
export type RecordUserEventMutationHookResult = ReturnType<typeof useRecordUserEventMutation>;
export type RecordUserEventMutationResult = Apollo.MutationResult<RecordUserEventMutation>;
export type RecordUserEventMutationOptions = Apollo.BaseMutationOptions<RecordUserEventMutation, RecordUserEventMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: ContactInput!) {
  createContact(input: $input) {
    name
    email
    phoneNumber
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const InitiateFileUploadDocument = gql`
    mutation initiateFileUpload($initiateFileUploadInput: InitiateFileUploadInput!) {
  initiateFileUpload(initiateFileUploadInput: $initiateFileUploadInput) {
    id
    associatedEntityId
    associatedEntityType
    associatedDocumentFileType
    filename
    fileType
    signedUploadUrl
  }
}
    `;
export type InitiateFileUploadMutationFn = Apollo.MutationFunction<InitiateFileUploadMutation, InitiateFileUploadMutationVariables>;

/**
 * __useInitiateFileUploadMutation__
 *
 * To run a mutation, you first call `useInitiateFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateFileUploadMutation, { data, loading, error }] = useInitiateFileUploadMutation({
 *   variables: {
 *      initiateFileUploadInput: // value for 'initiateFileUploadInput'
 *   },
 * });
 */
export function useInitiateFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateFileUploadMutation, InitiateFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateFileUploadMutation, InitiateFileUploadMutationVariables>(InitiateFileUploadDocument, options);
      }
export type InitiateFileUploadMutationHookResult = ReturnType<typeof useInitiateFileUploadMutation>;
export type InitiateFileUploadMutationResult = Apollo.MutationResult<InitiateFileUploadMutation>;
export type InitiateFileUploadMutationOptions = Apollo.BaseMutationOptions<InitiateFileUploadMutation, InitiateFileUploadMutationVariables>;
export const InitiateVideoUploadDocument = gql`
    mutation initiateVideoUpload($initiateVideoUploadInput: InitiateVideoUploadInput!) {
  initiateVideoUpload(initiateVideoUploadInput: $initiateVideoUploadInput) {
    bunnyVideoUploadHeaders {
      authorizationSignature
      authorizationExpire
      videoId
      libraryId
      collectionId
    }
    file {
      id
    }
  }
}
    `;
export type InitiateVideoUploadMutationFn = Apollo.MutationFunction<InitiateVideoUploadMutation, InitiateVideoUploadMutationVariables>;

/**
 * __useInitiateVideoUploadMutation__
 *
 * To run a mutation, you first call `useInitiateVideoUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateVideoUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateVideoUploadMutation, { data, loading, error }] = useInitiateVideoUploadMutation({
 *   variables: {
 *      initiateVideoUploadInput: // value for 'initiateVideoUploadInput'
 *   },
 * });
 */
export function useInitiateVideoUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateVideoUploadMutation, InitiateVideoUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateVideoUploadMutation, InitiateVideoUploadMutationVariables>(InitiateVideoUploadDocument, options);
      }
export type InitiateVideoUploadMutationHookResult = ReturnType<typeof useInitiateVideoUploadMutation>;
export type InitiateVideoUploadMutationResult = Apollo.MutationResult<InitiateVideoUploadMutation>;
export type InitiateVideoUploadMutationOptions = Apollo.BaseMutationOptions<InitiateVideoUploadMutation, InitiateVideoUploadMutationVariables>;
export const UpdateFileUploadStatusDocument = gql`
    mutation updateFileUploadStatus($options: UpdateFileUploadStatusInput!) {
  updateFileUploadStatus(options: $options) {
    id
    associatedEntityId
    associatedEntityType
    associatedDocumentFileType
    filename
    fileType
    url
  }
}
    `;
export type UpdateFileUploadStatusMutationFn = Apollo.MutationFunction<UpdateFileUploadStatusMutation, UpdateFileUploadStatusMutationVariables>;

/**
 * __useUpdateFileUploadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFileUploadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileUploadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileUploadStatusMutation, { data, loading, error }] = useUpdateFileUploadStatusMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateFileUploadStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileUploadStatusMutation, UpdateFileUploadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileUploadStatusMutation, UpdateFileUploadStatusMutationVariables>(UpdateFileUploadStatusDocument, options);
      }
export type UpdateFileUploadStatusMutationHookResult = ReturnType<typeof useUpdateFileUploadStatusMutation>;
export type UpdateFileUploadStatusMutationResult = Apollo.MutationResult<UpdateFileUploadStatusMutation>;
export type UpdateFileUploadStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFileUploadStatusMutation, UpdateFileUploadStatusMutationVariables>;
export const DeleteFileDocument = gql`
    mutation deleteFile($id: String!) {
  deleteFile(id: $id)
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const CreateFileDocument = gql`
    mutation CreateFile($createFileInput: CreateFileInput!) {
  create(createFileInput: $createFileInput) {
    id
    associatedEntityId
    associatedEntityType
    associatedDocumentFileType
    filename
    fileType
    fileLocation
    url
    uploaderId
    createdAt
    updatedAt
    signedUploadUrl
    uploadStatus
    thumbnailUrl
    cloudId
    isLocked
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      createFileInput: // value for 'createFileInput'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const CreateHorseListingDocument = gql`
    mutation createHorseListing($options: CreateHorseListingInput!) {
  createHorseListing(createHorseListingInput: $options) {
    id
    sellerId
    horseId
    price
    deposit
    platformFeePercentage
    depositFeePercentage
    vatPercentage
    description
    status
    uid
    total
    serviceFee
    serviceFeeVat
    depositFee
    depositFeeVat
    depositTotal
    isPriceHidden
  }
}
    `;
export type CreateHorseListingMutationFn = Apollo.MutationFunction<CreateHorseListingMutation, CreateHorseListingMutationVariables>;

/**
 * __useCreateHorseListingMutation__
 *
 * To run a mutation, you first call `useCreateHorseListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHorseListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHorseListingMutation, { data, loading, error }] = useCreateHorseListingMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateHorseListingMutation(baseOptions?: Apollo.MutationHookOptions<CreateHorseListingMutation, CreateHorseListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHorseListingMutation, CreateHorseListingMutationVariables>(CreateHorseListingDocument, options);
      }
export type CreateHorseListingMutationHookResult = ReturnType<typeof useCreateHorseListingMutation>;
export type CreateHorseListingMutationResult = Apollo.MutationResult<CreateHorseListingMutation>;
export type CreateHorseListingMutationOptions = Apollo.BaseMutationOptions<CreateHorseListingMutation, CreateHorseListingMutationVariables>;
export const UpdateHorseListingDocument = gql`
    mutation updateHorseListing($options: UpdateHorseListingInput!) {
  updateHorseListing(options: $options) {
    id
    sellerId
    horseId
    price
    deposit
    platformFeePercentage
    depositFeePercentage
    vatPercentage
    description
    status
    uid
    total
    serviceFee
    serviceFeeVat
    depositFee
    depositFeeVat
    depositTotal
    isPriceHidden
  }
}
    `;
export type UpdateHorseListingMutationFn = Apollo.MutationFunction<UpdateHorseListingMutation, UpdateHorseListingMutationVariables>;

/**
 * __useUpdateHorseListingMutation__
 *
 * To run a mutation, you first call `useUpdateHorseListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHorseListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHorseListingMutation, { data, loading, error }] = useUpdateHorseListingMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateHorseListingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHorseListingMutation, UpdateHorseListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHorseListingMutation, UpdateHorseListingMutationVariables>(UpdateHorseListingDocument, options);
      }
export type UpdateHorseListingMutationHookResult = ReturnType<typeof useUpdateHorseListingMutation>;
export type UpdateHorseListingMutationResult = Apollo.MutationResult<UpdateHorseListingMutation>;
export type UpdateHorseListingMutationOptions = Apollo.BaseMutationOptions<UpdateHorseListingMutation, UpdateHorseListingMutationVariables>;
export const DeleteHorseRecordDocument = gql`
    mutation deleteHorseRecord($id: Float!) {
  deleteHorseRecord(id: $id)
}
    `;
export type DeleteHorseRecordMutationFn = Apollo.MutationFunction<DeleteHorseRecordMutation, DeleteHorseRecordMutationVariables>;

/**
 * __useDeleteHorseRecordMutation__
 *
 * To run a mutation, you first call `useDeleteHorseRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHorseRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHorseRecordMutation, { data, loading, error }] = useDeleteHorseRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHorseRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHorseRecordMutation, DeleteHorseRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHorseRecordMutation, DeleteHorseRecordMutationVariables>(DeleteHorseRecordDocument, options);
      }
export type DeleteHorseRecordMutationHookResult = ReturnType<typeof useDeleteHorseRecordMutation>;
export type DeleteHorseRecordMutationResult = Apollo.MutationResult<DeleteHorseRecordMutation>;
export type DeleteHorseRecordMutationOptions = Apollo.BaseMutationOptions<DeleteHorseRecordMutation, DeleteHorseRecordMutationVariables>;
export const CreateFarrierRecordDocument = gql`
    mutation createFarrierRecord($input: CreateFarrierRecordPayload!) {
  createFarrierRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
  }
}
    `;
export type CreateFarrierRecordMutationFn = Apollo.MutationFunction<CreateFarrierRecordMutation, CreateFarrierRecordMutationVariables>;

/**
 * __useCreateFarrierRecordMutation__
 *
 * To run a mutation, you first call `useCreateFarrierRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFarrierRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFarrierRecordMutation, { data, loading, error }] = useCreateFarrierRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFarrierRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateFarrierRecordMutation, CreateFarrierRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFarrierRecordMutation, CreateFarrierRecordMutationVariables>(CreateFarrierRecordDocument, options);
      }
export type CreateFarrierRecordMutationHookResult = ReturnType<typeof useCreateFarrierRecordMutation>;
export type CreateFarrierRecordMutationResult = Apollo.MutationResult<CreateFarrierRecordMutation>;
export type CreateFarrierRecordMutationOptions = Apollo.BaseMutationOptions<CreateFarrierRecordMutation, CreateFarrierRecordMutationVariables>;
export const CreateVetDetailsRecordDocument = gql`
    mutation CreateVetDetailsRecord($input: CreateVetDetailsRecordPayload!) {
  createVetDetailsRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateVetDetailsRecordMutationFn = Apollo.MutationFunction<CreateVetDetailsRecordMutation, CreateVetDetailsRecordMutationVariables>;

/**
 * __useCreateVetDetailsRecordMutation__
 *
 * To run a mutation, you first call `useCreateVetDetailsRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVetDetailsRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVetDetailsRecordMutation, { data, loading, error }] = useCreateVetDetailsRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVetDetailsRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateVetDetailsRecordMutation, CreateVetDetailsRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVetDetailsRecordMutation, CreateVetDetailsRecordMutationVariables>(CreateVetDetailsRecordDocument, options);
      }
export type CreateVetDetailsRecordMutationHookResult = ReturnType<typeof useCreateVetDetailsRecordMutation>;
export type CreateVetDetailsRecordMutationResult = Apollo.MutationResult<CreateVetDetailsRecordMutation>;
export type CreateVetDetailsRecordMutationOptions = Apollo.BaseMutationOptions<CreateVetDetailsRecordMutation, CreateVetDetailsRecordMutationVariables>;
export const CreateVeterinaryHistoryRecordDocument = gql`
    mutation CreateVeterinaryHistoryRecord($input: CreateVeterinaryHistoryRecordPayload!) {
  createVeterinaryHistoryRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateVeterinaryHistoryRecordMutationFn = Apollo.MutationFunction<CreateVeterinaryHistoryRecordMutation, CreateVeterinaryHistoryRecordMutationVariables>;

/**
 * __useCreateVeterinaryHistoryRecordMutation__
 *
 * To run a mutation, you first call `useCreateVeterinaryHistoryRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVeterinaryHistoryRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVeterinaryHistoryRecordMutation, { data, loading, error }] = useCreateVeterinaryHistoryRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVeterinaryHistoryRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateVeterinaryHistoryRecordMutation, CreateVeterinaryHistoryRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVeterinaryHistoryRecordMutation, CreateVeterinaryHistoryRecordMutationVariables>(CreateVeterinaryHistoryRecordDocument, options);
      }
export type CreateVeterinaryHistoryRecordMutationHookResult = ReturnType<typeof useCreateVeterinaryHistoryRecordMutation>;
export type CreateVeterinaryHistoryRecordMutationResult = Apollo.MutationResult<CreateVeterinaryHistoryRecordMutation>;
export type CreateVeterinaryHistoryRecordMutationOptions = Apollo.BaseMutationOptions<CreateVeterinaryHistoryRecordMutation, CreateVeterinaryHistoryRecordMutationVariables>;
export const CreateMedicationLogRecordDocument = gql`
    mutation CreateMedicationLogRecord($input: CreateMedicationLogRecordPayload!) {
  createMedicationLogRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
  }
}
    `;
export type CreateMedicationLogRecordMutationFn = Apollo.MutationFunction<CreateMedicationLogRecordMutation, CreateMedicationLogRecordMutationVariables>;

/**
 * __useCreateMedicationLogRecordMutation__
 *
 * To run a mutation, you first call `useCreateMedicationLogRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationLogRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationLogRecordMutation, { data, loading, error }] = useCreateMedicationLogRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicationLogRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicationLogRecordMutation, CreateMedicationLogRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicationLogRecordMutation, CreateMedicationLogRecordMutationVariables>(CreateMedicationLogRecordDocument, options);
      }
export type CreateMedicationLogRecordMutationHookResult = ReturnType<typeof useCreateMedicationLogRecordMutation>;
export type CreateMedicationLogRecordMutationResult = Apollo.MutationResult<CreateMedicationLogRecordMutation>;
export type CreateMedicationLogRecordMutationOptions = Apollo.BaseMutationOptions<CreateMedicationLogRecordMutation, CreateMedicationLogRecordMutationVariables>;
export const CreatePhysiotherapyRecordDocument = gql`
    mutation CreatePhysiotherapyRecord($input: CreatePhysiotherapyRecordPayload!) {
  createPhysiotherapyRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreatePhysiotherapyRecordMutationFn = Apollo.MutationFunction<CreatePhysiotherapyRecordMutation, CreatePhysiotherapyRecordMutationVariables>;

/**
 * __useCreatePhysiotherapyRecordMutation__
 *
 * To run a mutation, you first call `useCreatePhysiotherapyRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhysiotherapyRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhysiotherapyRecordMutation, { data, loading, error }] = useCreatePhysiotherapyRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhysiotherapyRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhysiotherapyRecordMutation, CreatePhysiotherapyRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhysiotherapyRecordMutation, CreatePhysiotherapyRecordMutationVariables>(CreatePhysiotherapyRecordDocument, options);
      }
export type CreatePhysiotherapyRecordMutationHookResult = ReturnType<typeof useCreatePhysiotherapyRecordMutation>;
export type CreatePhysiotherapyRecordMutationResult = Apollo.MutationResult<CreatePhysiotherapyRecordMutation>;
export type CreatePhysiotherapyRecordMutationOptions = Apollo.BaseMutationOptions<CreatePhysiotherapyRecordMutation, CreatePhysiotherapyRecordMutationVariables>;
export const CreateChiropractorRecordDocument = gql`
    mutation CreateChiropractorRecord($input: CreateChiropractorRecordPayload!) {
  createChiropractorRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateChiropractorRecordMutationFn = Apollo.MutationFunction<CreateChiropractorRecordMutation, CreateChiropractorRecordMutationVariables>;

/**
 * __useCreateChiropractorRecordMutation__
 *
 * To run a mutation, you first call `useCreateChiropractorRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChiropractorRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChiropractorRecordMutation, { data, loading, error }] = useCreateChiropractorRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChiropractorRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateChiropractorRecordMutation, CreateChiropractorRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChiropractorRecordMutation, CreateChiropractorRecordMutationVariables>(CreateChiropractorRecordDocument, options);
      }
export type CreateChiropractorRecordMutationHookResult = ReturnType<typeof useCreateChiropractorRecordMutation>;
export type CreateChiropractorRecordMutationResult = Apollo.MutationResult<CreateChiropractorRecordMutation>;
export type CreateChiropractorRecordMutationOptions = Apollo.BaseMutationOptions<CreateChiropractorRecordMutation, CreateChiropractorRecordMutationVariables>;
export const CreateDentalRecordDocument = gql`
    mutation CreateDentalRecord($input: CreateDentalRecordPayload!) {
  createDentalRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateDentalRecordMutationFn = Apollo.MutationFunction<CreateDentalRecordMutation, CreateDentalRecordMutationVariables>;

/**
 * __useCreateDentalRecordMutation__
 *
 * To run a mutation, you first call `useCreateDentalRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDentalRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDentalRecordMutation, { data, loading, error }] = useCreateDentalRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDentalRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateDentalRecordMutation, CreateDentalRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDentalRecordMutation, CreateDentalRecordMutationVariables>(CreateDentalRecordDocument, options);
      }
export type CreateDentalRecordMutationHookResult = ReturnType<typeof useCreateDentalRecordMutation>;
export type CreateDentalRecordMutationResult = Apollo.MutationResult<CreateDentalRecordMutation>;
export type CreateDentalRecordMutationOptions = Apollo.BaseMutationOptions<CreateDentalRecordMutation, CreateDentalRecordMutationVariables>;
export const CreateXrayRecordDocument = gql`
    mutation CreateXrayRecord($input: CreateXrayRecordPayload!) {
  createXrayRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateXrayRecordMutationFn = Apollo.MutationFunction<CreateXrayRecordMutation, CreateXrayRecordMutationVariables>;

/**
 * __useCreateXrayRecordMutation__
 *
 * To run a mutation, you first call `useCreateXrayRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateXrayRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createXrayRecordMutation, { data, loading, error }] = useCreateXrayRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateXrayRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateXrayRecordMutation, CreateXrayRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateXrayRecordMutation, CreateXrayRecordMutationVariables>(CreateXrayRecordDocument, options);
      }
export type CreateXrayRecordMutationHookResult = ReturnType<typeof useCreateXrayRecordMutation>;
export type CreateXrayRecordMutationResult = Apollo.MutationResult<CreateXrayRecordMutation>;
export type CreateXrayRecordMutationOptions = Apollo.BaseMutationOptions<CreateXrayRecordMutation, CreateXrayRecordMutationVariables>;
export const CreateWormingRecordDocument = gql`
    mutation CreateWormingRecord($input: CreateWormingRecordPayload!) {
  createWormingRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateWormingRecordMutationFn = Apollo.MutationFunction<CreateWormingRecordMutation, CreateWormingRecordMutationVariables>;

/**
 * __useCreateWormingRecordMutation__
 *
 * To run a mutation, you first call `useCreateWormingRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWormingRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWormingRecordMutation, { data, loading, error }] = useCreateWormingRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWormingRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateWormingRecordMutation, CreateWormingRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWormingRecordMutation, CreateWormingRecordMutationVariables>(CreateWormingRecordDocument, options);
      }
export type CreateWormingRecordMutationHookResult = ReturnType<typeof useCreateWormingRecordMutation>;
export type CreateWormingRecordMutationResult = Apollo.MutationResult<CreateWormingRecordMutation>;
export type CreateWormingRecordMutationOptions = Apollo.BaseMutationOptions<CreateWormingRecordMutation, CreateWormingRecordMutationVariables>;
export const CreateVaccinationRecordDocument = gql`
    mutation CreateVaccinationRecord($input: CreateVaccinationRecordPayload!) {
  createVaccinationRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateVaccinationRecordMutationFn = Apollo.MutationFunction<CreateVaccinationRecordMutation, CreateVaccinationRecordMutationVariables>;

/**
 * __useCreateVaccinationRecordMutation__
 *
 * To run a mutation, you first call `useCreateVaccinationRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaccinationRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaccinationRecordMutation, { data, loading, error }] = useCreateVaccinationRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVaccinationRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateVaccinationRecordMutation, CreateVaccinationRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVaccinationRecordMutation, CreateVaccinationRecordMutationVariables>(CreateVaccinationRecordDocument, options);
      }
export type CreateVaccinationRecordMutationHookResult = ReturnType<typeof useCreateVaccinationRecordMutation>;
export type CreateVaccinationRecordMutationResult = Apollo.MutationResult<CreateVaccinationRecordMutation>;
export type CreateVaccinationRecordMutationOptions = Apollo.BaseMutationOptions<CreateVaccinationRecordMutation, CreateVaccinationRecordMutationVariables>;
export const CreateBloodTestRecordDocument = gql`
    mutation CreateBloodTestRecord($input: CreateBloodTestRecordPayload!) {
  createBloodTestRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateBloodTestRecordMutationFn = Apollo.MutationFunction<CreateBloodTestRecordMutation, CreateBloodTestRecordMutationVariables>;

/**
 * __useCreateBloodTestRecordMutation__
 *
 * To run a mutation, you first call `useCreateBloodTestRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBloodTestRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBloodTestRecordMutation, { data, loading, error }] = useCreateBloodTestRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBloodTestRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateBloodTestRecordMutation, CreateBloodTestRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBloodTestRecordMutation, CreateBloodTestRecordMutationVariables>(CreateBloodTestRecordDocument, options);
      }
export type CreateBloodTestRecordMutationHookResult = ReturnType<typeof useCreateBloodTestRecordMutation>;
export type CreateBloodTestRecordMutationResult = Apollo.MutationResult<CreateBloodTestRecordMutation>;
export type CreateBloodTestRecordMutationOptions = Apollo.BaseMutationOptions<CreateBloodTestRecordMutation, CreateBloodTestRecordMutationVariables>;
export const CreateCompetitionRecordv2Document = gql`
    mutation CreateCompetitionRecordv2($input: CreateCompetitionRecordPayload!) {
  createCompetitionRecordv2(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateCompetitionRecordv2MutationFn = Apollo.MutationFunction<CreateCompetitionRecordv2Mutation, CreateCompetitionRecordv2MutationVariables>;

/**
 * __useCreateCompetitionRecordv2Mutation__
 *
 * To run a mutation, you first call `useCreateCompetitionRecordv2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetitionRecordv2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetitionRecordv2Mutation, { data, loading, error }] = useCreateCompetitionRecordv2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetitionRecordv2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetitionRecordv2Mutation, CreateCompetitionRecordv2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetitionRecordv2Mutation, CreateCompetitionRecordv2MutationVariables>(CreateCompetitionRecordv2Document, options);
      }
export type CreateCompetitionRecordv2MutationHookResult = ReturnType<typeof useCreateCompetitionRecordv2Mutation>;
export type CreateCompetitionRecordv2MutationResult = Apollo.MutationResult<CreateCompetitionRecordv2Mutation>;
export type CreateCompetitionRecordv2MutationOptions = Apollo.BaseMutationOptions<CreateCompetitionRecordv2Mutation, CreateCompetitionRecordv2MutationVariables>;
export const CreateTravelDocumentsRecordDocument = gql`
    mutation CreateTravelDocumentsRecord($input: CreateTravelDocumentsRecordPayload!) {
  createTravelDocumentsRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateTravelDocumentsRecordMutationFn = Apollo.MutationFunction<CreateTravelDocumentsRecordMutation, CreateTravelDocumentsRecordMutationVariables>;

/**
 * __useCreateTravelDocumentsRecordMutation__
 *
 * To run a mutation, you first call `useCreateTravelDocumentsRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTravelDocumentsRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTravelDocumentsRecordMutation, { data, loading, error }] = useCreateTravelDocumentsRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTravelDocumentsRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTravelDocumentsRecordMutation, CreateTravelDocumentsRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTravelDocumentsRecordMutation, CreateTravelDocumentsRecordMutationVariables>(CreateTravelDocumentsRecordDocument, options);
      }
export type CreateTravelDocumentsRecordMutationHookResult = ReturnType<typeof useCreateTravelDocumentsRecordMutation>;
export type CreateTravelDocumentsRecordMutationResult = Apollo.MutationResult<CreateTravelDocumentsRecordMutation>;
export type CreateTravelDocumentsRecordMutationOptions = Apollo.BaseMutationOptions<CreateTravelDocumentsRecordMutation, CreateTravelDocumentsRecordMutationVariables>;
export const CreateAdditionalDocumentsRecordDocument = gql`
    mutation CreateAdditionalDocumentsRecord($input: CreateAdditionalDocumentsRecordPayload!) {
  createAdditionalDocumentsRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    data
    contacts {
      name
      type
    }
  }
}
    `;
export type CreateAdditionalDocumentsRecordMutationFn = Apollo.MutationFunction<CreateAdditionalDocumentsRecordMutation, CreateAdditionalDocumentsRecordMutationVariables>;

/**
 * __useCreateAdditionalDocumentsRecordMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalDocumentsRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalDocumentsRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalDocumentsRecordMutation, { data, loading, error }] = useCreateAdditionalDocumentsRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditionalDocumentsRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalDocumentsRecordMutation, CreateAdditionalDocumentsRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalDocumentsRecordMutation, CreateAdditionalDocumentsRecordMutationVariables>(CreateAdditionalDocumentsRecordDocument, options);
      }
export type CreateAdditionalDocumentsRecordMutationHookResult = ReturnType<typeof useCreateAdditionalDocumentsRecordMutation>;
export type CreateAdditionalDocumentsRecordMutationResult = Apollo.MutationResult<CreateAdditionalDocumentsRecordMutation>;
export type CreateAdditionalDocumentsRecordMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalDocumentsRecordMutation, CreateAdditionalDocumentsRecordMutationVariables>;
export const CreateTurnoutRecordDocument = gql`
    mutation CreateTurnoutRecord($input: CreateTurnoutRecordPayload!) {
  createTurnoutRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateTurnoutRecordMutationFn = Apollo.MutationFunction<CreateTurnoutRecordMutation, CreateTurnoutRecordMutationVariables>;

/**
 * __useCreateTurnoutRecordMutation__
 *
 * To run a mutation, you first call `useCreateTurnoutRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTurnoutRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTurnoutRecordMutation, { data, loading, error }] = useCreateTurnoutRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTurnoutRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTurnoutRecordMutation, CreateTurnoutRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTurnoutRecordMutation, CreateTurnoutRecordMutationVariables>(CreateTurnoutRecordDocument, options);
      }
export type CreateTurnoutRecordMutationHookResult = ReturnType<typeof useCreateTurnoutRecordMutation>;
export type CreateTurnoutRecordMutationResult = Apollo.MutationResult<CreateTurnoutRecordMutation>;
export type CreateTurnoutRecordMutationOptions = Apollo.BaseMutationOptions<CreateTurnoutRecordMutation, CreateTurnoutRecordMutationVariables>;
export const CreateFeedingRecordDocument = gql`
    mutation CreateFeedingRecord($input: CreateFeedingRecordPayload!) {
  createFeedingRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateFeedingRecordMutationFn = Apollo.MutationFunction<CreateFeedingRecordMutation, CreateFeedingRecordMutationVariables>;

/**
 * __useCreateFeedingRecordMutation__
 *
 * To run a mutation, you first call `useCreateFeedingRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedingRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedingRecordMutation, { data, loading, error }] = useCreateFeedingRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedingRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedingRecordMutation, CreateFeedingRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedingRecordMutation, CreateFeedingRecordMutationVariables>(CreateFeedingRecordDocument, options);
      }
export type CreateFeedingRecordMutationHookResult = ReturnType<typeof useCreateFeedingRecordMutation>;
export type CreateFeedingRecordMutationResult = Apollo.MutationResult<CreateFeedingRecordMutation>;
export type CreateFeedingRecordMutationOptions = Apollo.BaseMutationOptions<CreateFeedingRecordMutation, CreateFeedingRecordMutationVariables>;
export const CreateExerciseRecordDocument = gql`
    mutation CreateExerciseRecord($input: CreateExerciseRecordPayload!) {
  createExerciseRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateExerciseRecordMutationFn = Apollo.MutationFunction<CreateExerciseRecordMutation, CreateExerciseRecordMutationVariables>;

/**
 * __useCreateExerciseRecordMutation__
 *
 * To run a mutation, you first call `useCreateExerciseRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExerciseRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExerciseRecordMutation, { data, loading, error }] = useCreateExerciseRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExerciseRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateExerciseRecordMutation, CreateExerciseRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExerciseRecordMutation, CreateExerciseRecordMutationVariables>(CreateExerciseRecordDocument, options);
      }
export type CreateExerciseRecordMutationHookResult = ReturnType<typeof useCreateExerciseRecordMutation>;
export type CreateExerciseRecordMutationResult = Apollo.MutationResult<CreateExerciseRecordMutation>;
export type CreateExerciseRecordMutationOptions = Apollo.BaseMutationOptions<CreateExerciseRecordMutation, CreateExerciseRecordMutationVariables>;
export const CreateTrainingRecordDocument = gql`
    mutation CreateTrainingRecord($input: CreateTrainingRecordPayload!) {
  createTrainingRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateTrainingRecordMutationFn = Apollo.MutationFunction<CreateTrainingRecordMutation, CreateTrainingRecordMutationVariables>;

/**
 * __useCreateTrainingRecordMutation__
 *
 * To run a mutation, you first call `useCreateTrainingRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainingRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainingRecordMutation, { data, loading, error }] = useCreateTrainingRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainingRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainingRecordMutation, CreateTrainingRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainingRecordMutation, CreateTrainingRecordMutationVariables>(CreateTrainingRecordDocument, options);
      }
export type CreateTrainingRecordMutationHookResult = ReturnType<typeof useCreateTrainingRecordMutation>;
export type CreateTrainingRecordMutationResult = Apollo.MutationResult<CreateTrainingRecordMutation>;
export type CreateTrainingRecordMutationOptions = Apollo.BaseMutationOptions<CreateTrainingRecordMutation, CreateTrainingRecordMutationVariables>;
export const CreateTackRecordDocument = gql`
    mutation CreateTackRecord($input: CreateTackRecordPayload!) {
  createTackRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreateTackRecordMutationFn = Apollo.MutationFunction<CreateTackRecordMutation, CreateTackRecordMutationVariables>;

/**
 * __useCreateTackRecordMutation__
 *
 * To run a mutation, you first call `useCreateTackRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTackRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTackRecordMutation, { data, loading, error }] = useCreateTackRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTackRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTackRecordMutation, CreateTackRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTackRecordMutation, CreateTackRecordMutationVariables>(CreateTackRecordDocument, options);
      }
export type CreateTackRecordMutationHookResult = ReturnType<typeof useCreateTackRecordMutation>;
export type CreateTackRecordMutationResult = Apollo.MutationResult<CreateTackRecordMutation>;
export type CreateTackRecordMutationOptions = Apollo.BaseMutationOptions<CreateTackRecordMutation, CreateTackRecordMutationVariables>;
export const CreatePersonalityRecordDocument = gql`
    mutation CreatePersonalityRecord($input: CreatePersonalityRecordPayload!) {
  createPersonalityRecord(input: $input) {
    id
    horseId
    type
    date
    notes
    files
    contacts {
      name
      type
    }
    data
  }
}
    `;
export type CreatePersonalityRecordMutationFn = Apollo.MutationFunction<CreatePersonalityRecordMutation, CreatePersonalityRecordMutationVariables>;

/**
 * __useCreatePersonalityRecordMutation__
 *
 * To run a mutation, you first call `useCreatePersonalityRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonalityRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonalityRecordMutation, { data, loading, error }] = useCreatePersonalityRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonalityRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonalityRecordMutation, CreatePersonalityRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonalityRecordMutation, CreatePersonalityRecordMutationVariables>(CreatePersonalityRecordDocument, options);
      }
export type CreatePersonalityRecordMutationHookResult = ReturnType<typeof useCreatePersonalityRecordMutation>;
export type CreatePersonalityRecordMutationResult = Apollo.MutationResult<CreatePersonalityRecordMutation>;
export type CreatePersonalityRecordMutationOptions = Apollo.BaseMutationOptions<CreatePersonalityRecordMutation, CreatePersonalityRecordMutationVariables>;
export const CreateHorseDocument = gql`
    mutation createHorse($createHorseInput: CreateHorseInput!) {
  createHorse(createHorseInput: $createHorseInput) {
    id
    createdAt
    updatedAt
    ownerId
    name
    displayName
    passportNumber
    transponderCode
    stableName
    breed
    category
    ageInYear
    heightInCentimeter
    heightInHands
    colour
    sex
    dam
    sire
    damSire
    addressLine1
    addressLine2
    country
    city
    postcode
    dateOfBirth
  }
}
    `;
export type CreateHorseMutationFn = Apollo.MutationFunction<CreateHorseMutation, CreateHorseMutationVariables>;

/**
 * __useCreateHorseMutation__
 *
 * To run a mutation, you first call `useCreateHorseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHorseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHorseMutation, { data, loading, error }] = useCreateHorseMutation({
 *   variables: {
 *      createHorseInput: // value for 'createHorseInput'
 *   },
 * });
 */
export function useCreateHorseMutation(baseOptions?: Apollo.MutationHookOptions<CreateHorseMutation, CreateHorseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHorseMutation, CreateHorseMutationVariables>(CreateHorseDocument, options);
      }
export type CreateHorseMutationHookResult = ReturnType<typeof useCreateHorseMutation>;
export type CreateHorseMutationResult = Apollo.MutationResult<CreateHorseMutation>;
export type CreateHorseMutationOptions = Apollo.BaseMutationOptions<CreateHorseMutation, CreateHorseMutationVariables>;
export const DeleteHorseDocument = gql`
    mutation deleteHorse($horseId: Float!) {
  deleteHorse(horseId: $horseId)
}
    `;
export type DeleteHorseMutationFn = Apollo.MutationFunction<DeleteHorseMutation, DeleteHorseMutationVariables>;

/**
 * __useDeleteHorseMutation__
 *
 * To run a mutation, you first call `useDeleteHorseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHorseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHorseMutation, { data, loading, error }] = useDeleteHorseMutation({
 *   variables: {
 *      horseId: // value for 'horseId'
 *   },
 * });
 */
export function useDeleteHorseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHorseMutation, DeleteHorseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHorseMutation, DeleteHorseMutationVariables>(DeleteHorseDocument, options);
      }
export type DeleteHorseMutationHookResult = ReturnType<typeof useDeleteHorseMutation>;
export type DeleteHorseMutationResult = Apollo.MutationResult<DeleteHorseMutation>;
export type DeleteHorseMutationOptions = Apollo.BaseMutationOptions<DeleteHorseMutation, DeleteHorseMutationVariables>;
export const UpdateHorseDocument = gql`
    mutation updateHorse($updateHorseInput: UpdateHorseInput!) {
  updateHorse(updateHorseInput: $updateHorseInput) {
    id
    createdAt
    updatedAt
    ownerId
    name
    displayName
    passportNumber
    transponderCode
    stableName
    breed
    category
    ageInYear
    heightInCentimeter
    heightInHands
    colour
    sex
    dam
    sire
    damSire
    addressLine1
    addressLine2
    country
    city
    postcode
    dateOfBirth
  }
}
    `;
export type UpdateHorseMutationFn = Apollo.MutationFunction<UpdateHorseMutation, UpdateHorseMutationVariables>;

/**
 * __useUpdateHorseMutation__
 *
 * To run a mutation, you first call `useUpdateHorseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHorseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHorseMutation, { data, loading, error }] = useUpdateHorseMutation({
 *   variables: {
 *      updateHorseInput: // value for 'updateHorseInput'
 *   },
 * });
 */
export function useUpdateHorseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHorseMutation, UpdateHorseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHorseMutation, UpdateHorseMutationVariables>(UpdateHorseDocument, options);
      }
export type UpdateHorseMutationHookResult = ReturnType<typeof useUpdateHorseMutation>;
export type UpdateHorseMutationResult = Apollo.MutationResult<UpdateHorseMutation>;
export type UpdateHorseMutationOptions = Apollo.BaseMutationOptions<UpdateHorseMutation, UpdateHorseMutationVariables>;
export const SetProfilePhotoDocument = gql`
    mutation setProfilePhoto($setProfilePhotoInput: SetProfilePhotoInput!) {
  setProfilePhoto(setProfilePhotoInput: $setProfilePhotoInput) {
    id
    createdAt
    name
    ownerId
  }
}
    `;
export type SetProfilePhotoMutationFn = Apollo.MutationFunction<SetProfilePhotoMutation, SetProfilePhotoMutationVariables>;

/**
 * __useSetProfilePhotoMutation__
 *
 * To run a mutation, you first call `useSetProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProfilePhotoMutation, { data, loading, error }] = useSetProfilePhotoMutation({
 *   variables: {
 *      setProfilePhotoInput: // value for 'setProfilePhotoInput'
 *   },
 * });
 */
export function useSetProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<SetProfilePhotoMutation, SetProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProfilePhotoMutation, SetProfilePhotoMutationVariables>(SetProfilePhotoDocument, options);
      }
export type SetProfilePhotoMutationHookResult = ReturnType<typeof useSetProfilePhotoMutation>;
export type SetProfilePhotoMutationResult = Apollo.MutationResult<SetProfilePhotoMutation>;
export type SetProfilePhotoMutationOptions = Apollo.BaseMutationOptions<SetProfilePhotoMutation, SetProfilePhotoMutationVariables>;
export const DeleteProfilePhotoDocument = gql`
    mutation deleteProfilePhoto($id: Float!) {
  deleteProfilePhoto(id: $id)
}
    `;
export type DeleteProfilePhotoMutationFn = Apollo.MutationFunction<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>;

/**
 * __useDeleteProfilePhotoMutation__
 *
 * To run a mutation, you first call `useDeleteProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfilePhotoMutation, { data, loading, error }] = useDeleteProfilePhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>(DeleteProfilePhotoDocument, options);
      }
export type DeleteProfilePhotoMutationHookResult = ReturnType<typeof useDeleteProfilePhotoMutation>;
export type DeleteProfilePhotoMutationResult = Apollo.MutationResult<DeleteProfilePhotoMutation>;
export type DeleteProfilePhotoMutationOptions = Apollo.BaseMutationOptions<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>;
export const CreateCompetitionRecordDocument = gql`
    mutation createCompetitionRecord($createCompetitionRecordInput: CreateCompetitionRecordInput!) {
  createCompetitionRecord(
    createCompetitionRecordInput: $createCompetitionRecordInput
  ) {
    id
    horseId
    fileId
    competitionName
    competitionNumber
  }
}
    `;
export type CreateCompetitionRecordMutationFn = Apollo.MutationFunction<CreateCompetitionRecordMutation, CreateCompetitionRecordMutationVariables>;

/**
 * __useCreateCompetitionRecordMutation__
 *
 * To run a mutation, you first call `useCreateCompetitionRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetitionRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetitionRecordMutation, { data, loading, error }] = useCreateCompetitionRecordMutation({
 *   variables: {
 *      createCompetitionRecordInput: // value for 'createCompetitionRecordInput'
 *   },
 * });
 */
export function useCreateCompetitionRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetitionRecordMutation, CreateCompetitionRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetitionRecordMutation, CreateCompetitionRecordMutationVariables>(CreateCompetitionRecordDocument, options);
      }
export type CreateCompetitionRecordMutationHookResult = ReturnType<typeof useCreateCompetitionRecordMutation>;
export type CreateCompetitionRecordMutationResult = Apollo.MutationResult<CreateCompetitionRecordMutation>;
export type CreateCompetitionRecordMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionRecordMutation, CreateCompetitionRecordMutationVariables>;
export const UpdateHorseDocumentsDocument = gql`
    mutation updateHorseDocuments($updateHorseDocumentsInput: UpdateHorseDocumentsInput!) {
  updateHorseDocuments(updateHorseDocumentsInput: $updateHorseDocumentsInput) {
    id
    createdAt
    updatedAt
    ownerId
    name
    displayName
    passportNumber
    transponderCode
    stableName
    breed
    category
    ageInYear
    heightInCentimeter
    heightInHands
    colour
    sex
    dam
    sire
    damSire
    addressLine1
    addressLine2
    country
    city
    postcode
    noBreedingCertificate
    noVeterinarianHistory
    noCompetitionRecords
  }
}
    `;
export type UpdateHorseDocumentsMutationFn = Apollo.MutationFunction<UpdateHorseDocumentsMutation, UpdateHorseDocumentsMutationVariables>;

/**
 * __useUpdateHorseDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateHorseDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHorseDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHorseDocumentsMutation, { data, loading, error }] = useUpdateHorseDocumentsMutation({
 *   variables: {
 *      updateHorseDocumentsInput: // value for 'updateHorseDocumentsInput'
 *   },
 * });
 */
export function useUpdateHorseDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHorseDocumentsMutation, UpdateHorseDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHorseDocumentsMutation, UpdateHorseDocumentsMutationVariables>(UpdateHorseDocumentsDocument, options);
      }
export type UpdateHorseDocumentsMutationHookResult = ReturnType<typeof useUpdateHorseDocumentsMutation>;
export type UpdateHorseDocumentsMutationResult = Apollo.MutationResult<UpdateHorseDocumentsMutation>;
export type UpdateHorseDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateHorseDocumentsMutation, UpdateHorseDocumentsMutationVariables>;
export const AcknowledgeNotificationDocument = gql`
    mutation acknowledgeNotification($id: Float!) {
  acknowledgeNotification(id: $id)
}
    `;
export type AcknowledgeNotificationMutationFn = Apollo.MutationFunction<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;

/**
 * __useAcknowledgeNotificationMutation__
 *
 * To run a mutation, you first call `useAcknowledgeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeNotificationMutation, { data, loading, error }] = useAcknowledgeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcknowledgeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>(AcknowledgeNotificationDocument, options);
      }
export type AcknowledgeNotificationMutationHookResult = ReturnType<typeof useAcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationResult = Apollo.MutationResult<AcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationOptions = Apollo.BaseMutationOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;
export const CreateOrUpdateSellerAccountDocument = gql`
    mutation createOrUpdateSellerAccount($createSellerAccountInput: CreateSellerAccountInput!) {
  createOrUpdateSellerAccount(createSellerAccountInput: $createSellerAccountInput) {
    stripeResponse {
      requirements {
        currently_due
        eventually_due
        past_due
        pending_verification
        errors {
          code
          reason
          requirement
        }
        current_deadline
        disabled_reason
      }
    }
  }
}
    `;
export type CreateOrUpdateSellerAccountMutationFn = Apollo.MutationFunction<CreateOrUpdateSellerAccountMutation, CreateOrUpdateSellerAccountMutationVariables>;

/**
 * __useCreateOrUpdateSellerAccountMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSellerAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSellerAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSellerAccountMutation, { data, loading, error }] = useCreateOrUpdateSellerAccountMutation({
 *   variables: {
 *      createSellerAccountInput: // value for 'createSellerAccountInput'
 *   },
 * });
 */
export function useCreateOrUpdateSellerAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateSellerAccountMutation, CreateOrUpdateSellerAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateSellerAccountMutation, CreateOrUpdateSellerAccountMutationVariables>(CreateOrUpdateSellerAccountDocument, options);
      }
export type CreateOrUpdateSellerAccountMutationHookResult = ReturnType<typeof useCreateOrUpdateSellerAccountMutation>;
export type CreateOrUpdateSellerAccountMutationResult = Apollo.MutationResult<CreateOrUpdateSellerAccountMutation>;
export type CreateOrUpdateSellerAccountMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateSellerAccountMutation, CreateOrUpdateSellerAccountMutationVariables>;
export const CreateOrUpdatePayoutBankAccountDocument = gql`
    mutation createOrUpdatePayoutBankAccount($createPayoutBankAccountInput: CreatePayoutBankAccountInput!) {
  createOrUpdatePayoutBankAccount(
    createPayoutBankAccountInput: $createPayoutBankAccountInput
  ) {
    stripeResponse {
      requirements {
        currently_due
        eventually_due
        past_due
        pending_verification
        errors {
          code
          reason
          requirement
        }
        current_deadline
        disabled_reason
      }
    }
  }
}
    `;
export type CreateOrUpdatePayoutBankAccountMutationFn = Apollo.MutationFunction<CreateOrUpdatePayoutBankAccountMutation, CreateOrUpdatePayoutBankAccountMutationVariables>;

/**
 * __useCreateOrUpdatePayoutBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePayoutBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePayoutBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePayoutBankAccountMutation, { data, loading, error }] = useCreateOrUpdatePayoutBankAccountMutation({
 *   variables: {
 *      createPayoutBankAccountInput: // value for 'createPayoutBankAccountInput'
 *   },
 * });
 */
export function useCreateOrUpdatePayoutBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePayoutBankAccountMutation, CreateOrUpdatePayoutBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePayoutBankAccountMutation, CreateOrUpdatePayoutBankAccountMutationVariables>(CreateOrUpdatePayoutBankAccountDocument, options);
      }
export type CreateOrUpdatePayoutBankAccountMutationHookResult = ReturnType<typeof useCreateOrUpdatePayoutBankAccountMutation>;
export type CreateOrUpdatePayoutBankAccountMutationResult = Apollo.MutationResult<CreateOrUpdatePayoutBankAccountMutation>;
export type CreateOrUpdatePayoutBankAccountMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePayoutBankAccountMutation, CreateOrUpdatePayoutBankAccountMutationVariables>;
export const UploadVerificationDocumentsDocument = gql`
    mutation uploadVerificationDocuments($userId: Float!) {
  uploadVerificationDocuments(userId: $userId) {
    stripeResponse {
      requirements {
        currently_due
        eventually_due
        past_due
        pending_verification
        errors {
          code
          reason
          requirement
        }
        current_deadline
        disabled_reason
      }
    }
  }
}
    `;
export type UploadVerificationDocumentsMutationFn = Apollo.MutationFunction<UploadVerificationDocumentsMutation, UploadVerificationDocumentsMutationVariables>;

/**
 * __useUploadVerificationDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadVerificationDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVerificationDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVerificationDocumentsMutation, { data, loading, error }] = useUploadVerificationDocumentsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUploadVerificationDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UploadVerificationDocumentsMutation, UploadVerificationDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVerificationDocumentsMutation, UploadVerificationDocumentsMutationVariables>(UploadVerificationDocumentsDocument, options);
      }
export type UploadVerificationDocumentsMutationHookResult = ReturnType<typeof useUploadVerificationDocumentsMutation>;
export type UploadVerificationDocumentsMutationResult = Apollo.MutationResult<UploadVerificationDocumentsMutation>;
export type UploadVerificationDocumentsMutationOptions = Apollo.BaseMutationOptions<UploadVerificationDocumentsMutation, UploadVerificationDocumentsMutationVariables>;
export const CreateTransactionRecordDocument = gql`
    mutation createTransactionRecord($createTransactionRecordInput: CreateTransactionRecordInput!) {
  createTransactionRecord(
    createTransactionRecordInput: $createTransactionRecordInput
  ) {
    id
    buyerId
    listingId
    state
  }
}
    `;
export type CreateTransactionRecordMutationFn = Apollo.MutationFunction<CreateTransactionRecordMutation, CreateTransactionRecordMutationVariables>;

/**
 * __useCreateTransactionRecordMutation__
 *
 * To run a mutation, you first call `useCreateTransactionRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionRecordMutation, { data, loading, error }] = useCreateTransactionRecordMutation({
 *   variables: {
 *      createTransactionRecordInput: // value for 'createTransactionRecordInput'
 *   },
 * });
 */
export function useCreateTransactionRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionRecordMutation, CreateTransactionRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionRecordMutation, CreateTransactionRecordMutationVariables>(CreateTransactionRecordDocument, options);
      }
export type CreateTransactionRecordMutationHookResult = ReturnType<typeof useCreateTransactionRecordMutation>;
export type CreateTransactionRecordMutationResult = Apollo.MutationResult<CreateTransactionRecordMutation>;
export type CreateTransactionRecordMutationOptions = Apollo.BaseMutationOptions<CreateTransactionRecordMutation, CreateTransactionRecordMutationVariables>;
export const HandleBuyerEventDocument = gql`
    mutation handleBuyerEvent($transactionEventInput: TransactionEventInput!) {
  handleBuyerEvent(transactionEventInput: $transactionEventInput) {
    ...TransactionRecordFields
  }
}
    ${TransactionRecordFieldsFragmentDoc}`;
export type HandleBuyerEventMutationFn = Apollo.MutationFunction<HandleBuyerEventMutation, HandleBuyerEventMutationVariables>;

/**
 * __useHandleBuyerEventMutation__
 *
 * To run a mutation, you first call `useHandleBuyerEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleBuyerEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleBuyerEventMutation, { data, loading, error }] = useHandleBuyerEventMutation({
 *   variables: {
 *      transactionEventInput: // value for 'transactionEventInput'
 *   },
 * });
 */
export function useHandleBuyerEventMutation(baseOptions?: Apollo.MutationHookOptions<HandleBuyerEventMutation, HandleBuyerEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleBuyerEventMutation, HandleBuyerEventMutationVariables>(HandleBuyerEventDocument, options);
      }
export type HandleBuyerEventMutationHookResult = ReturnType<typeof useHandleBuyerEventMutation>;
export type HandleBuyerEventMutationResult = Apollo.MutationResult<HandleBuyerEventMutation>;
export type HandleBuyerEventMutationOptions = Apollo.BaseMutationOptions<HandleBuyerEventMutation, HandleBuyerEventMutationVariables>;
export const HandleSellerEventDocument = gql`
    mutation handleSellerEvent($transactionEventInput: TransactionEventInput!) {
  handleSellerEvent(transactionEventInput: $transactionEventInput) {
    ...TransactionRecordFields
  }
}
    ${TransactionRecordFieldsFragmentDoc}`;
export type HandleSellerEventMutationFn = Apollo.MutationFunction<HandleSellerEventMutation, HandleSellerEventMutationVariables>;

/**
 * __useHandleSellerEventMutation__
 *
 * To run a mutation, you first call `useHandleSellerEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleSellerEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleSellerEventMutation, { data, loading, error }] = useHandleSellerEventMutation({
 *   variables: {
 *      transactionEventInput: // value for 'transactionEventInput'
 *   },
 * });
 */
export function useHandleSellerEventMutation(baseOptions?: Apollo.MutationHookOptions<HandleSellerEventMutation, HandleSellerEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleSellerEventMutation, HandleSellerEventMutationVariables>(HandleSellerEventDocument, options);
      }
export type HandleSellerEventMutationHookResult = ReturnType<typeof useHandleSellerEventMutation>;
export type HandleSellerEventMutationResult = Apollo.MutationResult<HandleSellerEventMutation>;
export type HandleSellerEventMutationOptions = Apollo.BaseMutationOptions<HandleSellerEventMutation, HandleSellerEventMutationVariables>;
export const UpsertProfileDocument = gql`
    mutation upsertProfile($upsertProfileInput: UpsertProfileInput!) {
  upsertProfile(upsertProfileInput: $upsertProfileInput) {
    id
    profile {
      id
      firstName
      lastName
      countryDialCode
      phoneNumber
      addressLine1
      addressLine2
      city
      postcode
      isBusiness
    }
  }
}
    `;
export type UpsertProfileMutationFn = Apollo.MutationFunction<UpsertProfileMutation, UpsertProfileMutationVariables>;

/**
 * __useUpsertProfileMutation__
 *
 * To run a mutation, you first call `useUpsertProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProfileMutation, { data, loading, error }] = useUpsertProfileMutation({
 *   variables: {
 *      upsertProfileInput: // value for 'upsertProfileInput'
 *   },
 * });
 */
export function useUpsertProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProfileMutation, UpsertProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProfileMutation, UpsertProfileMutationVariables>(UpsertProfileDocument, options);
      }
export type UpsertProfileMutationHookResult = ReturnType<typeof useUpsertProfileMutation>;
export type UpsertProfileMutationResult = Apollo.MutationResult<UpsertProfileMutation>;
export type UpsertProfileMutationOptions = Apollo.BaseMutationOptions<UpsertProfileMutation, UpsertProfileMutationVariables>;
export const SendSupportRequestDocument = gql`
    mutation sendSupportRequest($sendSupportRequestInput: SendSupportRequestInput!) {
  sendSupportRequest(sendSupportRequestInput: $sendSupportRequestInput) {
    id
    userId
    message
  }
}
    `;
export type SendSupportRequestMutationFn = Apollo.MutationFunction<SendSupportRequestMutation, SendSupportRequestMutationVariables>;

/**
 * __useSendSupportRequestMutation__
 *
 * To run a mutation, you first call `useSendSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportRequestMutation, { data, loading, error }] = useSendSupportRequestMutation({
 *   variables: {
 *      sendSupportRequestInput: // value for 'sendSupportRequestInput'
 *   },
 * });
 */
export function useSendSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportRequestMutation, SendSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportRequestMutation, SendSupportRequestMutationVariables>(SendSupportRequestDocument, options);
      }
export type SendSupportRequestMutationHookResult = ReturnType<typeof useSendSupportRequestMutation>;
export type SendSupportRequestMutationResult = Apollo.MutationResult<SendSupportRequestMutation>;
export type SendSupportRequestMutationOptions = Apollo.BaseMutationOptions<SendSupportRequestMutation, SendSupportRequestMutationVariables>;
export const AddVerificationDocumentsDocument = gql`
    mutation addVerificationDocuments($userId: Float!, $frontFileId: String!, $backFileId: String!) {
  addVerificationDocuments(
    userId: $userId
    frontFileId: $frontFileId
    backFileId: $backFileId
  ) {
    id
    verificationDocumentFrontFileId
    verificationDocumentBackFileId
  }
}
    `;
export type AddVerificationDocumentsMutationFn = Apollo.MutationFunction<AddVerificationDocumentsMutation, AddVerificationDocumentsMutationVariables>;

/**
 * __useAddVerificationDocumentsMutation__
 *
 * To run a mutation, you first call `useAddVerificationDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVerificationDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVerificationDocumentsMutation, { data, loading, error }] = useAddVerificationDocumentsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      frontFileId: // value for 'frontFileId'
 *      backFileId: // value for 'backFileId'
 *   },
 * });
 */
export function useAddVerificationDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<AddVerificationDocumentsMutation, AddVerificationDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVerificationDocumentsMutation, AddVerificationDocumentsMutationVariables>(AddVerificationDocumentsDocument, options);
      }
export type AddVerificationDocumentsMutationHookResult = ReturnType<typeof useAddVerificationDocumentsMutation>;
export type AddVerificationDocumentsMutationResult = Apollo.MutationResult<AddVerificationDocumentsMutation>;
export type AddVerificationDocumentsMutationOptions = Apollo.BaseMutationOptions<AddVerificationDocumentsMutation, AddVerificationDocumentsMutationVariables>;
export const FundBalanceDocument = gql`
    mutation fundBalance($userId: Float!, $amount: Float!, $reference: String!) {
  fundBalance(userId: $userId, amount: $amount, reference: $reference)
}
    `;
export type FundBalanceMutationFn = Apollo.MutationFunction<FundBalanceMutation, FundBalanceMutationVariables>;

/**
 * __useFundBalanceMutation__
 *
 * To run a mutation, you first call `useFundBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFundBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fundBalanceMutation, { data, loading, error }] = useFundBalanceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      amount: // value for 'amount'
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useFundBalanceMutation(baseOptions?: Apollo.MutationHookOptions<FundBalanceMutation, FundBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FundBalanceMutation, FundBalanceMutationVariables>(FundBalanceDocument, options);
      }
export type FundBalanceMutationHookResult = ReturnType<typeof useFundBalanceMutation>;
export type FundBalanceMutationResult = Apollo.MutationResult<FundBalanceMutation>;
export type FundBalanceMutationOptions = Apollo.BaseMutationOptions<FundBalanceMutation, FundBalanceMutationVariables>;
export const ProcessSellerPayoutDocument = gql`
    query ProcessSellerPayout {
  processSellerPayout
}
    `;

/**
 * __useProcessSellerPayoutQuery__
 *
 * To run a query within a React component, call `useProcessSellerPayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessSellerPayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessSellerPayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessSellerPayoutQuery(baseOptions?: Apollo.QueryHookOptions<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>(ProcessSellerPayoutDocument, options);
      }
export function useProcessSellerPayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>(ProcessSellerPayoutDocument, options);
        }
export function useProcessSellerPayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>(ProcessSellerPayoutDocument, options);
        }
export type ProcessSellerPayoutQueryHookResult = ReturnType<typeof useProcessSellerPayoutQuery>;
export type ProcessSellerPayoutLazyQueryHookResult = ReturnType<typeof useProcessSellerPayoutLazyQuery>;
export type ProcessSellerPayoutSuspenseQueryHookResult = ReturnType<typeof useProcessSellerPayoutSuspenseQuery>;
export type ProcessSellerPayoutQueryResult = Apollo.QueryResult<ProcessSellerPayoutQuery, ProcessSellerPayoutQueryVariables>;
export const ProcessPaidPayoutDocument = gql`
    query ProcessPaidPayout {
  processPaidPayout
}
    `;

/**
 * __useProcessPaidPayoutQuery__
 *
 * To run a query within a React component, call `useProcessPaidPayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessPaidPayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessPaidPayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessPaidPayoutQuery(baseOptions?: Apollo.QueryHookOptions<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>(ProcessPaidPayoutDocument, options);
      }
export function useProcessPaidPayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>(ProcessPaidPayoutDocument, options);
        }
export function useProcessPaidPayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>(ProcessPaidPayoutDocument, options);
        }
export type ProcessPaidPayoutQueryHookResult = ReturnType<typeof useProcessPaidPayoutQuery>;
export type ProcessPaidPayoutLazyQueryHookResult = ReturnType<typeof useProcessPaidPayoutLazyQuery>;
export type ProcessPaidPayoutSuspenseQueryHookResult = ReturnType<typeof useProcessPaidPayoutSuspenseQuery>;
export type ProcessPaidPayoutQueryResult = Apollo.QueryResult<ProcessPaidPayoutQuery, ProcessPaidPayoutQueryVariables>;
export const QueryContactsByUserDocument = gql`
    query QueryContactsByUser($userId: Float!) {
  contactsByUser(input: {userId: $userId}) {
    id
    name
    email
    phoneNumber
  }
}
    `;

/**
 * __useQueryContactsByUserQuery__
 *
 * To run a query within a React component, call `useQueryContactsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryContactsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryContactsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useQueryContactsByUserQuery(baseOptions: Apollo.QueryHookOptions<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>(QueryContactsByUserDocument, options);
      }
export function useQueryContactsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>(QueryContactsByUserDocument, options);
        }
export function useQueryContactsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>(QueryContactsByUserDocument, options);
        }
export type QueryContactsByUserQueryHookResult = ReturnType<typeof useQueryContactsByUserQuery>;
export type QueryContactsByUserLazyQueryHookResult = ReturnType<typeof useQueryContactsByUserLazyQuery>;
export type QueryContactsByUserSuspenseQueryHookResult = ReturnType<typeof useQueryContactsByUserSuspenseQuery>;
export type QueryContactsByUserQueryResult = Apollo.QueryResult<QueryContactsByUserQuery, QueryContactsByUserQueryVariables>;
export const QueryContactsByNameDocument = gql`
    query QueryContactsByName($userId: Float!, $name: String!, $contactType: ContactType!) {
  contactsByName(input: {userId: $userId, name: $name, contactType: $contactType}) {
    id
    name
    email
    phoneNumber
  }
}
    `;

/**
 * __useQueryContactsByNameQuery__
 *
 * To run a query within a React component, call `useQueryContactsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryContactsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryContactsByNameQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      contactType: // value for 'contactType'
 *   },
 * });
 */
export function useQueryContactsByNameQuery(baseOptions: Apollo.QueryHookOptions<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>(QueryContactsByNameDocument, options);
      }
export function useQueryContactsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>(QueryContactsByNameDocument, options);
        }
export function useQueryContactsByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>(QueryContactsByNameDocument, options);
        }
export type QueryContactsByNameQueryHookResult = ReturnType<typeof useQueryContactsByNameQuery>;
export type QueryContactsByNameLazyQueryHookResult = ReturnType<typeof useQueryContactsByNameLazyQuery>;
export type QueryContactsByNameSuspenseQueryHookResult = ReturnType<typeof useQueryContactsByNameSuspenseQuery>;
export type QueryContactsByNameQueryResult = Apollo.QueryResult<QueryContactsByNameQuery, QueryContactsByNameQueryVariables>;
export const FilesDocument = gql`
    query files($options: FileQueryInput!) {
  files(options: $options) {
    id
    associatedEntityId
    associatedEntityType
    associatedDocumentFileType
    uploaderId
    createdAt
    filename
    fileLocation
    fileType
    url
    uploadStatus
    thumbnailUrl
    isLocked
  }
}
    `;

/**
 * __useFilesQuery__
 *
 * To run a query within a React component, call `useFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFilesQuery(baseOptions: Apollo.QueryHookOptions<FilesQuery, FilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
      }
export function useFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesQuery, FilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
        }
export function useFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilesQuery, FilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
        }
export type FilesQueryHookResult = ReturnType<typeof useFilesQuery>;
export type FilesLazyQueryHookResult = ReturnType<typeof useFilesLazyQuery>;
export type FilesSuspenseQueryHookResult = ReturnType<typeof useFilesSuspenseQuery>;
export type FilesQueryResult = Apollo.QueryResult<FilesQuery, FilesQueryVariables>;
export const FileDocument = gql`
    query file($fileId: String!) {
  file(fileId: $fileId) {
    id
    createdAt
    filename
    url
    thumbnailUrl
    fileType
    isLocked
  }
}
    `;

/**
 * __useFileQuery__
 *
 * To run a query within a React component, call `useFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useFileQuery(baseOptions: Apollo.QueryHookOptions<FileQuery, FileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileQuery, FileQueryVariables>(FileDocument, options);
      }
export function useFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileQuery, FileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileQuery, FileQueryVariables>(FileDocument, options);
        }
export function useFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileQuery, FileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileQuery, FileQueryVariables>(FileDocument, options);
        }
export type FileQueryHookResult = ReturnType<typeof useFileQuery>;
export type FileLazyQueryHookResult = ReturnType<typeof useFileLazyQuery>;
export type FileSuspenseQueryHookResult = ReturnType<typeof useFileSuspenseQuery>;
export type FileQueryResult = Apollo.QueryResult<FileQuery, FileQueryVariables>;
export const GetSignedUrlDocument = gql`
    query getSignedUrl($fileId: String!) {
  getSignedUrl(fileId: $fileId)
}
    `;

/**
 * __useGetSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUrlQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
      }
export function useGetSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
        }
export function useGetSignedUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
        }
export type GetSignedUrlQueryHookResult = ReturnType<typeof useGetSignedUrlQuery>;
export type GetSignedUrlLazyQueryHookResult = ReturnType<typeof useGetSignedUrlLazyQuery>;
export type GetSignedUrlSuspenseQueryHookResult = ReturnType<typeof useGetSignedUrlSuspenseQuery>;
export type GetSignedUrlQueryResult = Apollo.QueryResult<GetSignedUrlQuery, GetSignedUrlQueryVariables>;
export const HorseListingsDocument = gql`
    query HorseListings($pagedQueryInput: PagedHorseListingInput!) {
  horseListings(pagedQueryInput: $pagedQueryInput) {
    pageOffset
    pageSize
    totalCount
    results {
      id
      horse {
        ...HorseProfileDisplayFields
      }
      sellerId
      description
      status
      price
      platformFeePercentage
      depositFeePercentage
      vatPercentage
      deposit
      uid
      total
      serviceFee
      serviceFeeVat
      depositFee
      depositFeeVat
      depositTotal
      isPriceHidden
    }
  }
}
    ${HorseProfileDisplayFieldsFragmentDoc}`;

/**
 * __useHorseListingsQuery__
 *
 * To run a query within a React component, call `useHorseListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorseListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorseListingsQuery({
 *   variables: {
 *      pagedQueryInput: // value for 'pagedQueryInput'
 *   },
 * });
 */
export function useHorseListingsQuery(baseOptions: Apollo.QueryHookOptions<HorseListingsQuery, HorseListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorseListingsQuery, HorseListingsQueryVariables>(HorseListingsDocument, options);
      }
export function useHorseListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorseListingsQuery, HorseListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorseListingsQuery, HorseListingsQueryVariables>(HorseListingsDocument, options);
        }
export function useHorseListingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorseListingsQuery, HorseListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorseListingsQuery, HorseListingsQueryVariables>(HorseListingsDocument, options);
        }
export type HorseListingsQueryHookResult = ReturnType<typeof useHorseListingsQuery>;
export type HorseListingsLazyQueryHookResult = ReturnType<typeof useHorseListingsLazyQuery>;
export type HorseListingsSuspenseQueryHookResult = ReturnType<typeof useHorseListingsSuspenseQuery>;
export type HorseListingsQueryResult = Apollo.QueryResult<HorseListingsQuery, HorseListingsQueryVariables>;
export const HorseListingDocument = gql`
    query HorseListing($options: QueryHorseListingInput!) {
  horseListing(options: $options) {
    id
    horseId
    horse {
      ...HorseProfileFields
    }
    sellerId
    description
    status
    price
    platformFeePercentage
    depositFeePercentage
    vatPercentage
    deposit
    uid
    total
    serviceFee
    serviceFeeVat
    depositFee
    depositFeeVat
    depositTotal
    isPriceHidden
  }
}
    ${HorseProfileFieldsFragmentDoc}`;

/**
 * __useHorseListingQuery__
 *
 * To run a query within a React component, call `useHorseListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorseListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorseListingQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useHorseListingQuery(baseOptions: Apollo.QueryHookOptions<HorseListingQuery, HorseListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorseListingQuery, HorseListingQueryVariables>(HorseListingDocument, options);
      }
export function useHorseListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorseListingQuery, HorseListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorseListingQuery, HorseListingQueryVariables>(HorseListingDocument, options);
        }
export function useHorseListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorseListingQuery, HorseListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorseListingQuery, HorseListingQueryVariables>(HorseListingDocument, options);
        }
export type HorseListingQueryHookResult = ReturnType<typeof useHorseListingQuery>;
export type HorseListingLazyQueryHookResult = ReturnType<typeof useHorseListingLazyQuery>;
export type HorseListingSuspenseQueryHookResult = ReturnType<typeof useHorseListingSuspenseQuery>;
export type HorseListingQueryResult = Apollo.QueryResult<HorseListingQuery, HorseListingQueryVariables>;
export const GetFarrierTreatmentsDocument = gql`
    query GetFarrierTreatments {
  getFarrierTreatments {
    uid
    name
  }
}
    `;

/**
 * __useGetFarrierTreatmentsQuery__
 *
 * To run a query within a React component, call `useGetFarrierTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFarrierTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFarrierTreatmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFarrierTreatmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>(GetFarrierTreatmentsDocument, options);
      }
export function useGetFarrierTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>(GetFarrierTreatmentsDocument, options);
        }
export function useGetFarrierTreatmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>(GetFarrierTreatmentsDocument, options);
        }
export type GetFarrierTreatmentsQueryHookResult = ReturnType<typeof useGetFarrierTreatmentsQuery>;
export type GetFarrierTreatmentsLazyQueryHookResult = ReturnType<typeof useGetFarrierTreatmentsLazyQuery>;
export type GetFarrierTreatmentsSuspenseQueryHookResult = ReturnType<typeof useGetFarrierTreatmentsSuspenseQuery>;
export type GetFarrierTreatmentsQueryResult = Apollo.QueryResult<GetFarrierTreatmentsQuery, GetFarrierTreatmentsQueryVariables>;
export const GetVeterinaryHistoriesDocument = gql`
    query GetVeterinaryHistories {
  getVeterinaryHistories {
    uid
    name
    parentUid
    category
  }
}
    `;

/**
 * __useGetVeterinaryHistoriesQuery__
 *
 * To run a query within a React component, call `useGetVeterinaryHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVeterinaryHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVeterinaryHistoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVeterinaryHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>(GetVeterinaryHistoriesDocument, options);
      }
export function useGetVeterinaryHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>(GetVeterinaryHistoriesDocument, options);
        }
export function useGetVeterinaryHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>(GetVeterinaryHistoriesDocument, options);
        }
export type GetVeterinaryHistoriesQueryHookResult = ReturnType<typeof useGetVeterinaryHistoriesQuery>;
export type GetVeterinaryHistoriesLazyQueryHookResult = ReturnType<typeof useGetVeterinaryHistoriesLazyQuery>;
export type GetVeterinaryHistoriesSuspenseQueryHookResult = ReturnType<typeof useGetVeterinaryHistoriesSuspenseQuery>;
export type GetVeterinaryHistoriesQueryResult = Apollo.QueryResult<GetVeterinaryHistoriesQuery, GetVeterinaryHistoriesQueryVariables>;
export const GetMedicationLogDocument = gql`
    query GetMedicationLog {
  getMedicationLog {
    uid
    name
    medicationLogType
  }
}
    `;

/**
 * __useGetMedicationLogQuery__
 *
 * To run a query within a React component, call `useGetMedicationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicationLogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMedicationLogQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicationLogQuery, GetMedicationLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMedicationLogQuery, GetMedicationLogQueryVariables>(GetMedicationLogDocument, options);
      }
export function useGetMedicationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicationLogQuery, GetMedicationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMedicationLogQuery, GetMedicationLogQueryVariables>(GetMedicationLogDocument, options);
        }
export function useGetMedicationLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMedicationLogQuery, GetMedicationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMedicationLogQuery, GetMedicationLogQueryVariables>(GetMedicationLogDocument, options);
        }
export type GetMedicationLogQueryHookResult = ReturnType<typeof useGetMedicationLogQuery>;
export type GetMedicationLogLazyQueryHookResult = ReturnType<typeof useGetMedicationLogLazyQuery>;
export type GetMedicationLogSuspenseQueryHookResult = ReturnType<typeof useGetMedicationLogSuspenseQuery>;
export type GetMedicationLogQueryResult = Apollo.QueryResult<GetMedicationLogQuery, GetMedicationLogQueryVariables>;
export const GetPhysiotherapyDocument = gql`
    query GetPhysiotherapy {
  getPhysiotherapy {
    uid
    name
  }
}
    `;

/**
 * __useGetPhysiotherapyQuery__
 *
 * To run a query within a React component, call `useGetPhysiotherapyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhysiotherapyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhysiotherapyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPhysiotherapyQuery(baseOptions?: Apollo.QueryHookOptions<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>(GetPhysiotherapyDocument, options);
      }
export function useGetPhysiotherapyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>(GetPhysiotherapyDocument, options);
        }
export function useGetPhysiotherapySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>(GetPhysiotherapyDocument, options);
        }
export type GetPhysiotherapyQueryHookResult = ReturnType<typeof useGetPhysiotherapyQuery>;
export type GetPhysiotherapyLazyQueryHookResult = ReturnType<typeof useGetPhysiotherapyLazyQuery>;
export type GetPhysiotherapySuspenseQueryHookResult = ReturnType<typeof useGetPhysiotherapySuspenseQuery>;
export type GetPhysiotherapyQueryResult = Apollo.QueryResult<GetPhysiotherapyQuery, GetPhysiotherapyQueryVariables>;
export const GetChiropractorDocument = gql`
    query GetChiropractor {
  getChiropractor {
    uid
    name
  }
}
    `;

/**
 * __useGetChiropractorQuery__
 *
 * To run a query within a React component, call `useGetChiropractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChiropractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChiropractorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChiropractorQuery(baseOptions?: Apollo.QueryHookOptions<GetChiropractorQuery, GetChiropractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChiropractorQuery, GetChiropractorQueryVariables>(GetChiropractorDocument, options);
      }
export function useGetChiropractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChiropractorQuery, GetChiropractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChiropractorQuery, GetChiropractorQueryVariables>(GetChiropractorDocument, options);
        }
export function useGetChiropractorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChiropractorQuery, GetChiropractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChiropractorQuery, GetChiropractorQueryVariables>(GetChiropractorDocument, options);
        }
export type GetChiropractorQueryHookResult = ReturnType<typeof useGetChiropractorQuery>;
export type GetChiropractorLazyQueryHookResult = ReturnType<typeof useGetChiropractorLazyQuery>;
export type GetChiropractorSuspenseQueryHookResult = ReturnType<typeof useGetChiropractorSuspenseQuery>;
export type GetChiropractorQueryResult = Apollo.QueryResult<GetChiropractorQuery, GetChiropractorQueryVariables>;
export const GetDentalDocument = gql`
    query GetDental {
  getDental {
    uid
    name
  }
}
    `;

/**
 * __useGetDentalQuery__
 *
 * To run a query within a React component, call `useGetDentalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDentalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDentalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDentalQuery(baseOptions?: Apollo.QueryHookOptions<GetDentalQuery, GetDentalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDentalQuery, GetDentalQueryVariables>(GetDentalDocument, options);
      }
export function useGetDentalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDentalQuery, GetDentalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDentalQuery, GetDentalQueryVariables>(GetDentalDocument, options);
        }
export function useGetDentalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDentalQuery, GetDentalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDentalQuery, GetDentalQueryVariables>(GetDentalDocument, options);
        }
export type GetDentalQueryHookResult = ReturnType<typeof useGetDentalQuery>;
export type GetDentalLazyQueryHookResult = ReturnType<typeof useGetDentalLazyQuery>;
export type GetDentalSuspenseQueryHookResult = ReturnType<typeof useGetDentalSuspenseQuery>;
export type GetDentalQueryResult = Apollo.QueryResult<GetDentalQuery, GetDentalQueryVariables>;
export const GetXrayDocument = gql`
    query GetXray {
  getXray {
    uid
    name
    category
    parentUid
  }
}
    `;

/**
 * __useGetXrayQuery__
 *
 * To run a query within a React component, call `useGetXrayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXrayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXrayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetXrayQuery(baseOptions?: Apollo.QueryHookOptions<GetXrayQuery, GetXrayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXrayQuery, GetXrayQueryVariables>(GetXrayDocument, options);
      }
export function useGetXrayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXrayQuery, GetXrayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXrayQuery, GetXrayQueryVariables>(GetXrayDocument, options);
        }
export function useGetXraySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetXrayQuery, GetXrayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetXrayQuery, GetXrayQueryVariables>(GetXrayDocument, options);
        }
export type GetXrayQueryHookResult = ReturnType<typeof useGetXrayQuery>;
export type GetXrayLazyQueryHookResult = ReturnType<typeof useGetXrayLazyQuery>;
export type GetXraySuspenseQueryHookResult = ReturnType<typeof useGetXraySuspenseQuery>;
export type GetXrayQueryResult = Apollo.QueryResult<GetXrayQuery, GetXrayQueryVariables>;
export const GetWormingDocument = gql`
    query GetWorming {
  getWorming {
    uid
    name
  }
}
    `;

/**
 * __useGetWormingQuery__
 *
 * To run a query within a React component, call `useGetWormingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWormingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWormingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWormingQuery(baseOptions?: Apollo.QueryHookOptions<GetWormingQuery, GetWormingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWormingQuery, GetWormingQueryVariables>(GetWormingDocument, options);
      }
export function useGetWormingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWormingQuery, GetWormingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWormingQuery, GetWormingQueryVariables>(GetWormingDocument, options);
        }
export function useGetWormingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWormingQuery, GetWormingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWormingQuery, GetWormingQueryVariables>(GetWormingDocument, options);
        }
export type GetWormingQueryHookResult = ReturnType<typeof useGetWormingQuery>;
export type GetWormingLazyQueryHookResult = ReturnType<typeof useGetWormingLazyQuery>;
export type GetWormingSuspenseQueryHookResult = ReturnType<typeof useGetWormingSuspenseQuery>;
export type GetWormingQueryResult = Apollo.QueryResult<GetWormingQuery, GetWormingQueryVariables>;
export const GetVaccinationDocument = gql`
    query GetVaccination {
  getVaccination {
    uid
    name
    category
    parentUid
  }
}
    `;

/**
 * __useGetVaccinationQuery__
 *
 * To run a query within a React component, call `useGetVaccinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVaccinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVaccinationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVaccinationQuery(baseOptions?: Apollo.QueryHookOptions<GetVaccinationQuery, GetVaccinationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVaccinationQuery, GetVaccinationQueryVariables>(GetVaccinationDocument, options);
      }
export function useGetVaccinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVaccinationQuery, GetVaccinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVaccinationQuery, GetVaccinationQueryVariables>(GetVaccinationDocument, options);
        }
export function useGetVaccinationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVaccinationQuery, GetVaccinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVaccinationQuery, GetVaccinationQueryVariables>(GetVaccinationDocument, options);
        }
export type GetVaccinationQueryHookResult = ReturnType<typeof useGetVaccinationQuery>;
export type GetVaccinationLazyQueryHookResult = ReturnType<typeof useGetVaccinationLazyQuery>;
export type GetVaccinationSuspenseQueryHookResult = ReturnType<typeof useGetVaccinationSuspenseQuery>;
export type GetVaccinationQueryResult = Apollo.QueryResult<GetVaccinationQuery, GetVaccinationQueryVariables>;
export const GetBloodTestDocument = gql`
    query GetBloodTest {
  getBloodTest {
    uid
    name
    category
    parentUid
  }
}
    `;

/**
 * __useGetBloodTestQuery__
 *
 * To run a query within a React component, call `useGetBloodTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBloodTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBloodTestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBloodTestQuery(baseOptions?: Apollo.QueryHookOptions<GetBloodTestQuery, GetBloodTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBloodTestQuery, GetBloodTestQueryVariables>(GetBloodTestDocument, options);
      }
export function useGetBloodTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBloodTestQuery, GetBloodTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBloodTestQuery, GetBloodTestQueryVariables>(GetBloodTestDocument, options);
        }
export function useGetBloodTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBloodTestQuery, GetBloodTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBloodTestQuery, GetBloodTestQueryVariables>(GetBloodTestDocument, options);
        }
export type GetBloodTestQueryHookResult = ReturnType<typeof useGetBloodTestQuery>;
export type GetBloodTestLazyQueryHookResult = ReturnType<typeof useGetBloodTestLazyQuery>;
export type GetBloodTestSuspenseQueryHookResult = ReturnType<typeof useGetBloodTestSuspenseQuery>;
export type GetBloodTestQueryResult = Apollo.QueryResult<GetBloodTestQuery, GetBloodTestQueryVariables>;
export const GetFeedingDocument = gql`
    query GetFeeding {
  getFeeding {
    uid
    name
    category
  }
}
    `;

/**
 * __useGetFeedingQuery__
 *
 * To run a query within a React component, call `useGetFeedingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedingQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedingQuery, GetFeedingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedingQuery, GetFeedingQueryVariables>(GetFeedingDocument, options);
      }
export function useGetFeedingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedingQuery, GetFeedingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedingQuery, GetFeedingQueryVariables>(GetFeedingDocument, options);
        }
export function useGetFeedingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeedingQuery, GetFeedingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedingQuery, GetFeedingQueryVariables>(GetFeedingDocument, options);
        }
export type GetFeedingQueryHookResult = ReturnType<typeof useGetFeedingQuery>;
export type GetFeedingLazyQueryHookResult = ReturnType<typeof useGetFeedingLazyQuery>;
export type GetFeedingSuspenseQueryHookResult = ReturnType<typeof useGetFeedingSuspenseQuery>;
export type GetFeedingQueryResult = Apollo.QueryResult<GetFeedingQuery, GetFeedingQueryVariables>;
export const ExerciseTypesDocument = gql`
    query ExerciseTypes {
  exerciseTypes {
    uid
    name
  }
}
    `;

/**
 * __useExerciseTypesQuery__
 *
 * To run a query within a React component, call `useExerciseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExerciseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExerciseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExerciseTypesQuery(baseOptions?: Apollo.QueryHookOptions<ExerciseTypesQuery, ExerciseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExerciseTypesQuery, ExerciseTypesQueryVariables>(ExerciseTypesDocument, options);
      }
export function useExerciseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExerciseTypesQuery, ExerciseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExerciseTypesQuery, ExerciseTypesQueryVariables>(ExerciseTypesDocument, options);
        }
export function useExerciseTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExerciseTypesQuery, ExerciseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExerciseTypesQuery, ExerciseTypesQueryVariables>(ExerciseTypesDocument, options);
        }
export type ExerciseTypesQueryHookResult = ReturnType<typeof useExerciseTypesQuery>;
export type ExerciseTypesLazyQueryHookResult = ReturnType<typeof useExerciseTypesLazyQuery>;
export type ExerciseTypesSuspenseQueryHookResult = ReturnType<typeof useExerciseTypesSuspenseQuery>;
export type ExerciseTypesQueryResult = Apollo.QueryResult<ExerciseTypesQuery, ExerciseTypesQueryVariables>;
export const GetPersonalityDocument = gql`
    query GetPersonality {
  getPersonality {
    uid
    name
    category
  }
}
    `;

/**
 * __useGetPersonalityQuery__
 *
 * To run a query within a React component, call `useGetPersonalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalityQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalityQuery, GetPersonalityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalityQuery, GetPersonalityQueryVariables>(GetPersonalityDocument, options);
      }
export function useGetPersonalityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalityQuery, GetPersonalityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalityQuery, GetPersonalityQueryVariables>(GetPersonalityDocument, options);
        }
export function useGetPersonalitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonalityQuery, GetPersonalityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonalityQuery, GetPersonalityQueryVariables>(GetPersonalityDocument, options);
        }
export type GetPersonalityQueryHookResult = ReturnType<typeof useGetPersonalityQuery>;
export type GetPersonalityLazyQueryHookResult = ReturnType<typeof useGetPersonalityLazyQuery>;
export type GetPersonalitySuspenseQueryHookResult = ReturnType<typeof useGetPersonalitySuspenseQuery>;
export type GetPersonalityQueryResult = Apollo.QueryResult<GetPersonalityQuery, GetPersonalityQueryVariables>;
export const HorseRecordsDocument = gql`
    query HorseRecords($type: HorseRecordType!, $horseId: Float!) {
  horseRecords(options: {type: $type, horseId: $horseId}) {
    id
    type
    createdAt
    date
    nextVisitDueDate
    reasonForVisit
    data
    files
    horseId
    outcome
    notes
    contacts {
      id
      name
    }
  }
}
    `;

/**
 * __useHorseRecordsQuery__
 *
 * To run a query within a React component, call `useHorseRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorseRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorseRecordsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      horseId: // value for 'horseId'
 *   },
 * });
 */
export function useHorseRecordsQuery(baseOptions: Apollo.QueryHookOptions<HorseRecordsQuery, HorseRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorseRecordsQuery, HorseRecordsQueryVariables>(HorseRecordsDocument, options);
      }
export function useHorseRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorseRecordsQuery, HorseRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorseRecordsQuery, HorseRecordsQueryVariables>(HorseRecordsDocument, options);
        }
export function useHorseRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorseRecordsQuery, HorseRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorseRecordsQuery, HorseRecordsQueryVariables>(HorseRecordsDocument, options);
        }
export type HorseRecordsQueryHookResult = ReturnType<typeof useHorseRecordsQuery>;
export type HorseRecordsLazyQueryHookResult = ReturnType<typeof useHorseRecordsLazyQuery>;
export type HorseRecordsSuspenseQueryHookResult = ReturnType<typeof useHorseRecordsSuspenseQuery>;
export type HorseRecordsQueryResult = Apollo.QueryResult<HorseRecordsQuery, HorseRecordsQueryVariables>;
export const HorseRecordDocument = gql`
    query HorseRecord($id: Float!) {
  horseRecord(id: $id) {
    id
    type
    createdAt
    date
    nextVisitDueDate
    reasonForVisit
    data
    files
    horseId
    outcome
    notes
    contacts {
      id
      name
    }
  }
}
    `;

/**
 * __useHorseRecordQuery__
 *
 * To run a query within a React component, call `useHorseRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorseRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorseRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHorseRecordQuery(baseOptions: Apollo.QueryHookOptions<HorseRecordQuery, HorseRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorseRecordQuery, HorseRecordQueryVariables>(HorseRecordDocument, options);
      }
export function useHorseRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorseRecordQuery, HorseRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorseRecordQuery, HorseRecordQueryVariables>(HorseRecordDocument, options);
        }
export function useHorseRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorseRecordQuery, HorseRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorseRecordQuery, HorseRecordQueryVariables>(HorseRecordDocument, options);
        }
export type HorseRecordQueryHookResult = ReturnType<typeof useHorseRecordQuery>;
export type HorseRecordLazyQueryHookResult = ReturnType<typeof useHorseRecordLazyQuery>;
export type HorseRecordSuspenseQueryHookResult = ReturnType<typeof useHorseRecordSuspenseQuery>;
export type HorseRecordQueryResult = Apollo.QueryResult<HorseRecordQuery, HorseRecordQueryVariables>;
export const HorseDocument = gql`
    query horse($id: Float!) {
  horse(id: $id) {
    id
    horseListings {
      id
      horseId
      uid
      status
    }
    id
    createdAt
    updatedAt
    ownerId
    name
    displayName
    passportNumber
    transponderCode
    stableName
    breed
    category
    ageInYear
    currentAge
    heightInCentimeter
    heightInHands
    colour
    sex
    dam
    sire
    damSire
    sireSire
    breedersName
    studBook
    registrationNumber
    dateOfLicensing
    addressLine1
    addressLine2
    country
    city
    postcode
    dateOfBirth
    breedingCertificates {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    vaccinationRecords {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    vetHistory {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    competitionRecords {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    vetCertificates {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    xRays {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    vetOther {
      id
      createdAt
      filename
      fileType
      fileLocation
      url
    }
    noBreedingCertificate
    noVeterinarianHistory
    noCompetitionRecords
    profilePhoto {
      id
      url
    }
  }
}
    `;

/**
 * __useHorseQuery__
 *
 * To run a query within a React component, call `useHorseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHorseQuery(baseOptions: Apollo.QueryHookOptions<HorseQuery, HorseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorseQuery, HorseQueryVariables>(HorseDocument, options);
      }
export function useHorseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorseQuery, HorseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorseQuery, HorseQueryVariables>(HorseDocument, options);
        }
export function useHorseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorseQuery, HorseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorseQuery, HorseQueryVariables>(HorseDocument, options);
        }
export type HorseQueryHookResult = ReturnType<typeof useHorseQuery>;
export type HorseLazyQueryHookResult = ReturnType<typeof useHorseLazyQuery>;
export type HorseSuspenseQueryHookResult = ReturnType<typeof useHorseSuspenseQuery>;
export type HorseQueryResult = Apollo.QueryResult<HorseQuery, HorseQueryVariables>;
export const HorsesDocument = gql`
    query horses($ownerId: Float!) {
  horses(ownerId: $ownerId) {
    id
    name
    displayName
    ownerId
    profilePhoto {
      id
      url
    }
    horseListings {
      id
      horseId
      uid
      status
      price
    }
  }
}
    `;

/**
 * __useHorsesQuery__
 *
 * To run a query within a React component, call `useHorsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorsesQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useHorsesQuery(baseOptions: Apollo.QueryHookOptions<HorsesQuery, HorsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorsesQuery, HorsesQueryVariables>(HorsesDocument, options);
      }
export function useHorsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorsesQuery, HorsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorsesQuery, HorsesQueryVariables>(HorsesDocument, options);
        }
export function useHorsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HorsesQuery, HorsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HorsesQuery, HorsesQueryVariables>(HorsesDocument, options);
        }
export type HorsesQueryHookResult = ReturnType<typeof useHorsesQuery>;
export type HorsesLazyQueryHookResult = ReturnType<typeof useHorsesLazyQuery>;
export type HorsesSuspenseQueryHookResult = ReturnType<typeof useHorsesSuspenseQuery>;
export type HorsesQueryResult = Apollo.QueryResult<HorsesQuery, HorsesQueryVariables>;
export const CompetitionRecordsDocument = gql`
    query competitionRecords($competitionRecordQueryInput: CompetitionRecordQueryInput!) {
  competitionRecords(competitionRecordQueryInput: $competitionRecordQueryInput) {
    id
    horseId
    fileId
    competitionName
    competitionNumber
  }
}
    `;

/**
 * __useCompetitionRecordsQuery__
 *
 * To run a query within a React component, call `useCompetitionRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionRecordsQuery({
 *   variables: {
 *      competitionRecordQueryInput: // value for 'competitionRecordQueryInput'
 *   },
 * });
 */
export function useCompetitionRecordsQuery(baseOptions: Apollo.QueryHookOptions<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>(CompetitionRecordsDocument, options);
      }
export function useCompetitionRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>(CompetitionRecordsDocument, options);
        }
export function useCompetitionRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>(CompetitionRecordsDocument, options);
        }
export type CompetitionRecordsQueryHookResult = ReturnType<typeof useCompetitionRecordsQuery>;
export type CompetitionRecordsLazyQueryHookResult = ReturnType<typeof useCompetitionRecordsLazyQuery>;
export type CompetitionRecordsSuspenseQueryHookResult = ReturnType<typeof useCompetitionRecordsSuspenseQuery>;
export type CompetitionRecordsQueryResult = Apollo.QueryResult<CompetitionRecordsQuery, CompetitionRecordsQueryVariables>;
export const DeleteCompetitionRecordDocument = gql`
    mutation deleteCompetitionRecord($id: Float!) {
  deleteCompetitionRecord(id: $id)
}
    `;
export type DeleteCompetitionRecordMutationFn = Apollo.MutationFunction<DeleteCompetitionRecordMutation, DeleteCompetitionRecordMutationVariables>;

/**
 * __useDeleteCompetitionRecordMutation__
 *
 * To run a mutation, you first call `useDeleteCompetitionRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompetitionRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompetitionRecordMutation, { data, loading, error }] = useDeleteCompetitionRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompetitionRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompetitionRecordMutation, DeleteCompetitionRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompetitionRecordMutation, DeleteCompetitionRecordMutationVariables>(DeleteCompetitionRecordDocument, options);
      }
export type DeleteCompetitionRecordMutationHookResult = ReturnType<typeof useDeleteCompetitionRecordMutation>;
export type DeleteCompetitionRecordMutationResult = Apollo.MutationResult<DeleteCompetitionRecordMutation>;
export type DeleteCompetitionRecordMutationOptions = Apollo.BaseMutationOptions<DeleteCompetitionRecordMutation, DeleteCompetitionRecordMutationVariables>;
export const ActiveNotificationsDocument = gql`
    query activeNotifications {
  activeNotifications {
    id
    recipientUserId
    title
    message
    acknowledgedDate
  }
}
    `;

/**
 * __useActiveNotificationsQuery__
 *
 * To run a query within a React component, call `useActiveNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>(ActiveNotificationsDocument, options);
      }
export function useActiveNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>(ActiveNotificationsDocument, options);
        }
export function useActiveNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>(ActiveNotificationsDocument, options);
        }
export type ActiveNotificationsQueryHookResult = ReturnType<typeof useActiveNotificationsQuery>;
export type ActiveNotificationsLazyQueryHookResult = ReturnType<typeof useActiveNotificationsLazyQuery>;
export type ActiveNotificationsSuspenseQueryHookResult = ReturnType<typeof useActiveNotificationsSuspenseQuery>;
export type ActiveNotificationsQueryResult = Apollo.QueryResult<ActiveNotificationsQuery, ActiveNotificationsQueryVariables>;
export const PaymentsDocument = gql`
    query payments($options: PagedPaymentQueryInput!) {
  payments(options: $options) {
    totalCount
    pageOffset
    results {
      id
      createdAt
      amount
      transactionRecordId
      paymentType
      paymentStatus
      chargeStatus
      refundStatus
    }
  }
}
    `;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsSuspenseQueryHookResult = ReturnType<typeof usePaymentsSuspenseQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const PaymentWithActionDocument = gql`
    query paymentWithAction($paymentId: Float!) {
  payment(id: $paymentId) {
    id
    createdAt
    amount
    transactionRecordId
    paymentType
    paymentStatus
    chargeStatus
    refundStatus
    nextAction {
      type
      bankTransferInstructions {
        type
        currency
        reference
        amountRemaining
        financialAddresses
      }
    }
  }
}
    `;

/**
 * __usePaymentWithActionQuery__
 *
 * To run a query within a React component, call `usePaymentWithActionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentWithActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentWithActionQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentWithActionQuery(baseOptions: Apollo.QueryHookOptions<PaymentWithActionQuery, PaymentWithActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentWithActionQuery, PaymentWithActionQueryVariables>(PaymentWithActionDocument, options);
      }
export function usePaymentWithActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentWithActionQuery, PaymentWithActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentWithActionQuery, PaymentWithActionQueryVariables>(PaymentWithActionDocument, options);
        }
export function usePaymentWithActionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentWithActionQuery, PaymentWithActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentWithActionQuery, PaymentWithActionQueryVariables>(PaymentWithActionDocument, options);
        }
export type PaymentWithActionQueryHookResult = ReturnType<typeof usePaymentWithActionQuery>;
export type PaymentWithActionLazyQueryHookResult = ReturnType<typeof usePaymentWithActionLazyQuery>;
export type PaymentWithActionSuspenseQueryHookResult = ReturnType<typeof usePaymentWithActionSuspenseQuery>;
export type PaymentWithActionQueryResult = Apollo.QueryResult<PaymentWithActionQuery, PaymentWithActionQueryVariables>;
export const PurchasesDocument = gql`
    query purchases($options: PurchasesQueryInput!) {
  purchases(options: $options) {
    id
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __usePurchasesQuery__
 *
 * To run a query within a React component, call `usePurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchasesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePurchasesQuery(baseOptions: Apollo.QueryHookOptions<PurchasesQuery, PurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchasesQuery, PurchasesQueryVariables>(PurchasesDocument, options);
      }
export function usePurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchasesQuery, PurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchasesQuery, PurchasesQueryVariables>(PurchasesDocument, options);
        }
export function usePurchasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchasesQuery, PurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchasesQuery, PurchasesQueryVariables>(PurchasesDocument, options);
        }
export type PurchasesQueryHookResult = ReturnType<typeof usePurchasesQuery>;
export type PurchasesLazyQueryHookResult = ReturnType<typeof usePurchasesLazyQuery>;
export type PurchasesSuspenseQueryHookResult = ReturnType<typeof usePurchasesSuspenseQuery>;
export type PurchasesQueryResult = Apollo.QueryResult<PurchasesQuery, PurchasesQueryVariables>;
export const PurchaseDocument = gql`
    query purchase($purchaseRequestId: Float!) {
  purchase(purchaseRequestId: $purchaseRequestId) {
    id
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __usePurchaseQuery__
 *
 * To run a query within a React component, call `usePurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseQuery({
 *   variables: {
 *      purchaseRequestId: // value for 'purchaseRequestId'
 *   },
 * });
 */
export function usePurchaseQuery(baseOptions: Apollo.QueryHookOptions<PurchaseQuery, PurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseQuery, PurchaseQueryVariables>(PurchaseDocument, options);
      }
export function usePurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseQuery, PurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseQuery, PurchaseQueryVariables>(PurchaseDocument, options);
        }
export function usePurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseQuery, PurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseQuery, PurchaseQueryVariables>(PurchaseDocument, options);
        }
export type PurchaseQueryHookResult = ReturnType<typeof usePurchaseQuery>;
export type PurchaseLazyQueryHookResult = ReturnType<typeof usePurchaseLazyQuery>;
export type PurchaseSuspenseQueryHookResult = ReturnType<typeof usePurchaseSuspenseQuery>;
export type PurchaseQueryResult = Apollo.QueryResult<PurchaseQuery, PurchaseQueryVariables>;
export const SelfDocument = gql`
    query Self {
  self {
    id
    email
    firebaseId
    accountStatus {
      emailVerificationStatus
      personalDetailsStatus
      identityVerificationStatus
    }
    roles
    profile {
      id
      firstName
      lastName
      countryDialCode
      phoneNumber
      addressLine1
      addressLine2
      city
      postcode
      countryCode
      isBusiness
      photoUrl
      reasonForJoining
    }
  }
}
    `;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: Apollo.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
      }
export function useSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export function useSelfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfSuspenseQueryHookResult = ReturnType<typeof useSelfSuspenseQuery>;
export type SelfQueryResult = Apollo.QueryResult<SelfQuery, SelfQueryVariables>;
export const SellerAccountDocument = gql`
    query sellerAccount($userId: Float!) {
  sellerAccount(userId: $userId) {
    canAcceptPayments
    canMakePayments
    firstName
    lastName
    dateOfBirth {
      year
      month
      day
    }
    address {
      addressLine1
      addressLine2
      city
      state
      postalCode
      countryCode
    }
    countryCode
    phone
    countryDialCode
    externalBankAccounts {
      id
      accountHolderName
      accountHolderType
      bankName
      country
      currency
      defaultForCurrency
      last4
      routingNumber
      status
    }
    stripeResponse {
      id
      charges_enabled
      payouts_enabled
      default_currency
      country
      requirements {
        currently_due
        eventually_due
        past_due
        pending_verification
        errors {
          code
          reason
          requirement
        }
        current_deadline
        disabled_reason
      }
    }
  }
}
    `;

/**
 * __useSellerAccountQuery__
 *
 * To run a query within a React component, call `useSellerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerAccountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSellerAccountQuery(baseOptions: Apollo.QueryHookOptions<SellerAccountQuery, SellerAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerAccountQuery, SellerAccountQueryVariables>(SellerAccountDocument, options);
      }
export function useSellerAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerAccountQuery, SellerAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerAccountQuery, SellerAccountQueryVariables>(SellerAccountDocument, options);
        }
export function useSellerAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerAccountQuery, SellerAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerAccountQuery, SellerAccountQueryVariables>(SellerAccountDocument, options);
        }
export type SellerAccountQueryHookResult = ReturnType<typeof useSellerAccountQuery>;
export type SellerAccountLazyQueryHookResult = ReturnType<typeof useSellerAccountLazyQuery>;
export type SellerAccountSuspenseQueryHookResult = ReturnType<typeof useSellerAccountSuspenseQuery>;
export type SellerAccountQueryResult = Apollo.QueryResult<SellerAccountQuery, SellerAccountQueryVariables>;
export const TransactionRecordsDocument = gql`
    query transactionRecords($options: TransactionRecordsQueryInput!) {
  transactionRecords(options: $options) {
    ...TransactionRecordFields
  }
}
    ${TransactionRecordFieldsFragmentDoc}`;

/**
 * __useTransactionRecordsQuery__
 *
 * To run a query within a React component, call `useTransactionRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionRecordsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTransactionRecordsQuery(baseOptions: Apollo.QueryHookOptions<TransactionRecordsQuery, TransactionRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionRecordsQuery, TransactionRecordsQueryVariables>(TransactionRecordsDocument, options);
      }
export function useTransactionRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionRecordsQuery, TransactionRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionRecordsQuery, TransactionRecordsQueryVariables>(TransactionRecordsDocument, options);
        }
export function useTransactionRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionRecordsQuery, TransactionRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionRecordsQuery, TransactionRecordsQueryVariables>(TransactionRecordsDocument, options);
        }
export type TransactionRecordsQueryHookResult = ReturnType<typeof useTransactionRecordsQuery>;
export type TransactionRecordsLazyQueryHookResult = ReturnType<typeof useTransactionRecordsLazyQuery>;
export type TransactionRecordsSuspenseQueryHookResult = ReturnType<typeof useTransactionRecordsSuspenseQuery>;
export type TransactionRecordsQueryResult = Apollo.QueryResult<TransactionRecordsQuery, TransactionRecordsQueryVariables>;
export const TransactionRecordDocument = gql`
    query transactionRecord($id: Float!) {
  transactionRecord(id: $id) {
    ...TransactionRecordFields
  }
}
    ${TransactionRecordFieldsFragmentDoc}`;

/**
 * __useTransactionRecordQuery__
 *
 * To run a query within a React component, call `useTransactionRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionRecordQuery(baseOptions: Apollo.QueryHookOptions<TransactionRecordQuery, TransactionRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionRecordQuery, TransactionRecordQueryVariables>(TransactionRecordDocument, options);
      }
export function useTransactionRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionRecordQuery, TransactionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionRecordQuery, TransactionRecordQueryVariables>(TransactionRecordDocument, options);
        }
export function useTransactionRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionRecordQuery, TransactionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionRecordQuery, TransactionRecordQueryVariables>(TransactionRecordDocument, options);
        }
export type TransactionRecordQueryHookResult = ReturnType<typeof useTransactionRecordQuery>;
export type TransactionRecordLazyQueryHookResult = ReturnType<typeof useTransactionRecordLazyQuery>;
export type TransactionRecordSuspenseQueryHookResult = ReturnType<typeof useTransactionRecordSuspenseQuery>;
export type TransactionRecordQueryResult = Apollo.QueryResult<TransactionRecordQuery, TransactionRecordQueryVariables>;
export const BuyerTransactionRecordDocument = gql`
    query buyerTransactionRecord($options: TransactionRecordQueryInput!) {
  buyerTransactionRecord(options: $options) {
    ...TransactionRecordFields
  }
}
    ${TransactionRecordFieldsFragmentDoc}`;

/**
 * __useBuyerTransactionRecordQuery__
 *
 * To run a query within a React component, call `useBuyerTransactionRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerTransactionRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerTransactionRecordQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBuyerTransactionRecordQuery(baseOptions: Apollo.QueryHookOptions<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>(BuyerTransactionRecordDocument, options);
      }
export function useBuyerTransactionRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>(BuyerTransactionRecordDocument, options);
        }
export function useBuyerTransactionRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>(BuyerTransactionRecordDocument, options);
        }
export type BuyerTransactionRecordQueryHookResult = ReturnType<typeof useBuyerTransactionRecordQuery>;
export type BuyerTransactionRecordLazyQueryHookResult = ReturnType<typeof useBuyerTransactionRecordLazyQuery>;
export type BuyerTransactionRecordSuspenseQueryHookResult = ReturnType<typeof useBuyerTransactionRecordSuspenseQuery>;
export type BuyerTransactionRecordQueryResult = Apollo.QueryResult<BuyerTransactionRecordQuery, BuyerTransactionRecordQueryVariables>;
export const TransactionRecordsNotificationCounterDocument = gql`
    query transactionRecordsNotificationCounter($options: TransactionRecordsQueryInput!) {
  transactionRecordsNotificationCounter(options: $options) {
    buyerNotificationCount
    sellerNotificationCount
  }
}
    `;

/**
 * __useTransactionRecordsNotificationCounterQuery__
 *
 * To run a query within a React component, call `useTransactionRecordsNotificationCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionRecordsNotificationCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionRecordsNotificationCounterQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTransactionRecordsNotificationCounterQuery(baseOptions: Apollo.QueryHookOptions<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>(TransactionRecordsNotificationCounterDocument, options);
      }
export function useTransactionRecordsNotificationCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>(TransactionRecordsNotificationCounterDocument, options);
        }
export function useTransactionRecordsNotificationCounterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>(TransactionRecordsNotificationCounterDocument, options);
        }
export type TransactionRecordsNotificationCounterQueryHookResult = ReturnType<typeof useTransactionRecordsNotificationCounterQuery>;
export type TransactionRecordsNotificationCounterLazyQueryHookResult = ReturnType<typeof useTransactionRecordsNotificationCounterLazyQuery>;
export type TransactionRecordsNotificationCounterSuspenseQueryHookResult = ReturnType<typeof useTransactionRecordsNotificationCounterSuspenseQuery>;
export type TransactionRecordsNotificationCounterQueryResult = Apollo.QueryResult<TransactionRecordsNotificationCounterQuery, TransactionRecordsNotificationCounterQueryVariables>;
export const SellerHorseNotificationCounterDocument = gql`
    query sellerHorseNotificationCounter($options: TransactionRecordsQueryInput!) {
  sellerHorseNotificationCounter(options: $options) {
    horseNotificationCount
  }
}
    `;

/**
 * __useSellerHorseNotificationCounterQuery__
 *
 * To run a query within a React component, call `useSellerHorseNotificationCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerHorseNotificationCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerHorseNotificationCounterQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSellerHorseNotificationCounterQuery(baseOptions: Apollo.QueryHookOptions<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>(SellerHorseNotificationCounterDocument, options);
      }
export function useSellerHorseNotificationCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>(SellerHorseNotificationCounterDocument, options);
        }
export function useSellerHorseNotificationCounterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>(SellerHorseNotificationCounterDocument, options);
        }
export type SellerHorseNotificationCounterQueryHookResult = ReturnType<typeof useSellerHorseNotificationCounterQuery>;
export type SellerHorseNotificationCounterLazyQueryHookResult = ReturnType<typeof useSellerHorseNotificationCounterLazyQuery>;
export type SellerHorseNotificationCounterSuspenseQueryHookResult = ReturnType<typeof useSellerHorseNotificationCounterSuspenseQuery>;
export type SellerHorseNotificationCounterQueryResult = Apollo.QueryResult<SellerHorseNotificationCounterQuery, SellerHorseNotificationCounterQueryVariables>;
export const VettingDocument = gql`
    query vetting($vettingId: Float!) {
  vetting(vettingId: $vettingId) {
    id
    createdAt
    updatedAt
    status
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
    vetDetails {
      id
      createdAt
      updatedAt
      vetName
      vettingDate
      conflictStatus
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __useVettingQuery__
 *
 * To run a query within a React component, call `useVettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVettingQuery({
 *   variables: {
 *      vettingId: // value for 'vettingId'
 *   },
 * });
 */
export function useVettingQuery(baseOptions: Apollo.QueryHookOptions<VettingQuery, VettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VettingQuery, VettingQueryVariables>(VettingDocument, options);
      }
export function useVettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VettingQuery, VettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VettingQuery, VettingQueryVariables>(VettingDocument, options);
        }
export function useVettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VettingQuery, VettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VettingQuery, VettingQueryVariables>(VettingDocument, options);
        }
export type VettingQueryHookResult = ReturnType<typeof useVettingQuery>;
export type VettingLazyQueryHookResult = ReturnType<typeof useVettingLazyQuery>;
export type VettingSuspenseQueryHookResult = ReturnType<typeof useVettingSuspenseQuery>;
export type VettingQueryResult = Apollo.QueryResult<VettingQuery, VettingQueryVariables>;
export const VettingsDocument = gql`
    query vettings($options: VettingsQueryInput!) {
  vettings(options: $options) {
    id
    createdAt
    updatedAt
    status
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
    vetDetails {
      id
      createdAt
      updatedAt
      vetName
      vettingDate
      conflictStatus
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __useVettingsQuery__
 *
 * To run a query within a React component, call `useVettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVettingsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useVettingsQuery(baseOptions: Apollo.QueryHookOptions<VettingsQuery, VettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VettingsQuery, VettingsQueryVariables>(VettingsDocument, options);
      }
export function useVettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VettingsQuery, VettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VettingsQuery, VettingsQueryVariables>(VettingsDocument, options);
        }
export function useVettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VettingsQuery, VettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VettingsQuery, VettingsQueryVariables>(VettingsDocument, options);
        }
export type VettingsQueryHookResult = ReturnType<typeof useVettingsQuery>;
export type VettingsLazyQueryHookResult = ReturnType<typeof useVettingsLazyQuery>;
export type VettingsSuspenseQueryHookResult = ReturnType<typeof useVettingsSuspenseQuery>;
export type VettingsQueryResult = Apollo.QueryResult<VettingsQuery, VettingsQueryVariables>;
export const ViewingRequestsDocument = gql`
    query viewingRequests($options: ViewingRequestQueryInput!) {
  viewingRequests(options: $options) {
    id
    createdAt
    updatedAt
    message
    status
    documentRequestStatus
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __useViewingRequestsQuery__
 *
 * To run a query within a React component, call `useViewingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewingRequestsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useViewingRequestsQuery(baseOptions: Apollo.QueryHookOptions<ViewingRequestsQuery, ViewingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewingRequestsQuery, ViewingRequestsQueryVariables>(ViewingRequestsDocument, options);
      }
export function useViewingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewingRequestsQuery, ViewingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewingRequestsQuery, ViewingRequestsQueryVariables>(ViewingRequestsDocument, options);
        }
export function useViewingRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewingRequestsQuery, ViewingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewingRequestsQuery, ViewingRequestsQueryVariables>(ViewingRequestsDocument, options);
        }
export type ViewingRequestsQueryHookResult = ReturnType<typeof useViewingRequestsQuery>;
export type ViewingRequestsLazyQueryHookResult = ReturnType<typeof useViewingRequestsLazyQuery>;
export type ViewingRequestsSuspenseQueryHookResult = ReturnType<typeof useViewingRequestsSuspenseQuery>;
export type ViewingRequestsQueryResult = Apollo.QueryResult<ViewingRequestsQuery, ViewingRequestsQueryVariables>;
export const ViewingRequestDocument = gql`
    query viewingRequest($viewingRequestId: Float!) {
  viewingRequest(viewingRequestId: $viewingRequestId) {
    id
    createdAt
    updatedAt
    message
    status
    documentRequestStatus
    transactionRecordId
    transactionRecord {
      id
      buyerProfile {
        ...TransactionUserProfileFields
      }
    }
  }
}
    ${TransactionUserProfileFieldsFragmentDoc}`;

/**
 * __useViewingRequestQuery__
 *
 * To run a query within a React component, call `useViewingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewingRequestQuery({
 *   variables: {
 *      viewingRequestId: // value for 'viewingRequestId'
 *   },
 * });
 */
export function useViewingRequestQuery(baseOptions: Apollo.QueryHookOptions<ViewingRequestQuery, ViewingRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewingRequestQuery, ViewingRequestQueryVariables>(ViewingRequestDocument, options);
      }
export function useViewingRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewingRequestQuery, ViewingRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewingRequestQuery, ViewingRequestQueryVariables>(ViewingRequestDocument, options);
        }
export function useViewingRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewingRequestQuery, ViewingRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewingRequestQuery, ViewingRequestQueryVariables>(ViewingRequestDocument, options);
        }
export type ViewingRequestQueryHookResult = ReturnType<typeof useViewingRequestQuery>;
export type ViewingRequestLazyQueryHookResult = ReturnType<typeof useViewingRequestLazyQuery>;
export type ViewingRequestSuspenseQueryHookResult = ReturnType<typeof useViewingRequestSuspenseQuery>;
export type ViewingRequestQueryResult = Apollo.QueryResult<ViewingRequestQuery, ViewingRequestQueryVariables>;